'use strict';

/*
*	MG2 Media JS Framework
*	@author  François Vandal
*	@version: 0.9.4
*	Last update: 6 september 2016
*/

(function ($, global, undefined) {
	var html = $('html');
	var lang = html.attr('lang');
	var defaultLang = html.attr('data-default-lang');

	var modules = {};
	var components = {};
	var pages = {};

	/* Modules */
	var createModule = function createModule(module) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageChange: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop,
			pageStartChange: $.noop
		}, module);
	};

	var exportModule = function exportModule(key, module) {
		modules[key] = createModule(module);

		return modules[key];
	};

	/* Pages */
	var createPage = function createPage(page) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop
		}, page);
	};

	var exportPage = function exportPage(key, page) {
		pages[key] = createPage(page);

		return pages[key];
	};

	var checkForPage = function checkForPage(pageIdNum) {
		var currPage = $('.main-content .page[data-page-id-num=' + pageIdNum + ']').attr('data-page-id');

		if (pages[pageIdNum] !== undefined) {
			pages[pageIdNum].init('#page-' + currPage);
			pages[pageIdNum].pageLoad('#page-' + currPage);
		}
	};

	/* Components */
	var createComponent = function createComponent(component) {
		return $.extend({ init: $.noop }, component);
	};

	var exportComponent = function exportComponent(key, component) {
		components[key] = createPage(component);

		return pages[key];
	};

	var start = function start() {
		var lang = $('html').attr('lang');
		var defaultLang = $('html').attr('data-default-lang');

		var currPathname = location.pathname;
		var currentIdNum = $('.main-content .page').data('pageIdNum');

		if (currPathname !== '/' && currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		if (lang !== defaultLang) {
			currPathname = currPathname.substring(lang.length);
		}

		currPathname = currPathname !== '/' ? currPathname : 'home';

		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname + 'home';
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('?')[0];
		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname.substring(0, currPathname.length - 1);
		}

		if (lang !== defaultLang) {
			if (currPathname.substring(0, lang.length) === lang) {
				currPathname = currPathname.substring(lang.length);
			}
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('/')[0];

		$.each(Fw.modules.models(), function () {
			this.init('body');
			this.pageLoad('body');
		});

		$('html').attr('data-curr-page', 'page-' + currPathname);
		checkForPage(currentIdNum);

		return Fw;
	};

	global.Fw = $.extend(global.Fw, {
		data: '',

		modules: {
			models: function models() {
				return modules;
			},

			export: exportModule
		},

		component: {
			models: function models() {
				return components;
			},

			export: exportComponent
		},

		page: {
			models: function models() {
				return pages;
			},

			export: exportPage,

			checkForPage: checkForPage
		},

		start: start
	});
})(jQuery, window);
"use strict";

function getQuery(param, search) {
    var se = search !== undefined ? search : window.location.search;
    var qs = se.replace("?", "");
    if (!param || param === "") return qs;
    if (qs === "") return null;

    var qa = qs.split("&");
    for (var i = 0; i < qa.length; i++) {
        var q = qa[i];
        if (q.indexOf("=") > -1) {
            var a = q.split("=");
            if (a[0] === param) return a[1];
        } else {
            if (q === param) return "";
        }
    }
}
function setQuery(param, value, search) {
    var se = search !== undefined ? search : window.location.search;
    if (se !== "") {
        var qa = se.replace("?", "").split("&");
        var qa2 = [];
        var isNew = true;

        for (var i = 0; i < qa.length; i++) {
            var qi = qa[i];
            var j = qi.indexOf("=");
            var qname = j > -1 ? qi.substring(0, j) : qi;
            if (qname === param) {
                if (value && value !== "") {
                    qi = param + "=" + encodeURIComponent(value);
                } else {
                    qi = param;
                }
                isNew = false;
            }
            qa2.push(qi);
        }
        if (isNew) {
            if (value && value !== "") {
                qa2.push(param + "=" + encodeURIComponent(value));
            } else {
                qa2.push(param);
            }
        }

        return qa2.join("&");
    } else if (value && value !== "") {
        return param + "=" + encodeURIComponent(value);
    } else {
        return param;
    }
}
function removeQuery(param, search) {
    var se = search !== undefined ? search : window.location.search;
    if (!param || param === "") return se.replace("?", "");

    var qa = se.replace("?", "").split("&");
    var qa2 = [];
    for (var i = 0; i < qa.length; i++) {
        var qi = qa[i];
        var j = qi.indexOf("=");
        var qname = j > -1 ? qi.substring(0, j) : qi;

        if (qname !== param) qa2.push(qi);
    }

    return qa2.join("&");
}
function pushQueryState(q, x, state, title) {
    var qs = "";
    var url = window.location.pathname;

    if (!q || typeof q !== "string") {
        return null;
    }

    if (x === null || x === undefined) {
        qs = removeQuery(q);
    } else {
        qs = setQuery(q, x);
    }
    if (qs !== "") {
        qs = "?" + qs;
    }
    url += qs + window.location.hash;

    return window.history.pushState(state, title ? title : q + " " + x, url);
}

function moveElementWithTinyMCE($el, fn) {
    /*Issue: moving the DOM element of the mce container bugs the editor where 
     it loses the content and becomes uneditable. To fix this, remove its 
     instance and reinitalize with the textarea.*/
    if ($el.has(".mce-container").length) {
        var id = $el.find("textarea.form-input").attr("id"),
            settings = tinymce.settings;

        tinymce.settings = tinymce.get(id).settings;
        fn();
        tinymce.EditorManager.execCommand("mceRemoveEditor", false, id);
        tinymce.EditorManager.execCommand("mceAddEditor", false, id);
        tinymce.settings = settings;
    } else {
        fn();
    }
}

function escapeXMLEntities(s) {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function escapeXMLEntities2(s) {
    return s.replace(/&(?!amp;([a-z]+|#[0-9]+);)/g, "&amp;");
}

function randomHex() {
    return Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1);
}
function randomIdNumber(length) {
    return Math.floor((1 + Math.random()) * Math.pow(10, length ? length : 4)).toString().substring(1);
}
function randomIdLetter(length) {
    var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var chars = "";
    var l = length ? length : 6;
    for (var i = 0; i < l; i++) {
        chars += letters.charAt(Math.floor(Math.random() * letters.length));
    }
    return chars;
}
function randomIdMix(length) {
    var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
    var chars = randomIdLetter(1);
    var l = length ? length - 1 : 12;
    for (var i = 0; i < l; i++) {
        chars += letters.charAt(Math.floor(Math.random() * letters.length));
    }
    return chars;
}

function scrollToElement(event, scroller, element, offset, speed) {
    if (event) {
        var targ = event.currentTarget || this;
        var dataset = targ.dataset;
        var ctn = $(dataset.ctn || "html, body");
        var offsetEl = $(dataset.offsetElement);
        var oh = offsetEl[0] ? offsetEl.height() : 0;

        ctn.animate({
            scrollTop: $("#" + dataset.id).offset().top - oh
        }, 300);
    } else {
        $(scroller).animate({
            scrollTop: $(element).offset().top - offset
        }, speed);
    }
}
'use strict';

(function ($, undefined) {

	'use strict';

	var accordionHeader;

	var toggleAccordion = function toggleAccordion() {
		var t = $(this);
		var ctn = t.closest('.accordion-outer-ctn');

		ctn.toggleClass('open');
		ctn.find('.accordion-content').slideToggle();
	};

	var init = function init() {
		accordionHeader = $('.accordion-header');

		accordionHeader.click(toggleAccordion);

		var autoOpenHeader = accordionHeader.filter('.auto-open');

		if (autoOpenHeader.length) autoOpenHeader.click();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
"use strict";

(function () {
    'use strict';

    var $blogCtn;

    function loadLastBlogs(index, ctn) {
        var cat = ctn.getAttribute("data-category");
        var wrap = ctn.querySelector(".blog-home-row");
        var settingsCount = ctn.getAttribute("data-count") ? ctn.getAttribute("data-count") : $(ctn).hasClass("ver1") ? 3 : 2;

        if (wrap.getAttribute("data-use-ajax")) {
            var data = [];

            data.push("count=" + (parseInt(settingsCount) + 3));

            if (cat !== "") {
                data.push("categoryId=" + cat);
            }

            ajax("/action/ajaxGetBlog?" + data.join("&"), function (res) {
                var o = JSON.parse(res);
                var count = o.blogs.length;
                var temp1 = wrap.querySelector(".one-suggested-blog.home") || wrap.querySelector(".one-suggested-blog");
                var temp2 = wrap.querySelector(".one-suggested-blog.column");
                var sideColumn = wrap.querySelector(".blog-home-column");

                if (sideColumn && count <= settingsCount) {
                    sideColumn.parentElement.removeChild(sideColumn);
                    sideColumn = null;
                }

                if (count) {
                    wrap.removeChild(wrap.querySelector(".no-blogs-message"));

                    for (var i = 0; i < count; i++) {
                        var ob = o.blogs[i];
                        var clone, html;

                        if (temp2 && i >= settingsCount) {
                            clone = temp2.cloneNode(true);
                            temp2.parentElement.appendChild(clone);
                        } else {
                            clone = temp1.cloneNode(true);
                            if (sideColumn) {
                                wrap.insertBefore(clone, sideColumn);
                            } else {
                                wrap.appendChild(clone);
                            }
                        }
                        html = clone.innerHTML;

                        for (var prop in ob) {
                            var re = new RegExp("\\[\\[" + prop + "\\]\\]", "g");
                            html = html.replace(re, ob[prop]);
                        }
                        clone.innerHTML = html;

                        if (ob.imagePath || !ob.mediaId || ob.mediaId === "0") {
                            var imgLink = clone.querySelector(".blog-img-link");
                            if (imgLink) {
                                imgLink.parentElement.removeChild(imgLink);
                            }
                        }
                        if (!ob.imagePath) {
                            var imgLink = clone.querySelector(".blog-img-path-link");
                            if (imgLink) {
                                imgLink.parentElement.removeChild(imgLink);
                            }
                        }
                        clone.querySelector(".suggested-blog-content").className += " no-padding";
                        if (!ob.author || ob.author === "") {
                            var author = clone.querySelector(".suggested-blog-author");
                            if (author) {
                                author.parentElement.removeChild(author);
                            }
                        }
                    }
                }

                wrap.style.display = "";
                if (temp1) {
                    temp1.parentElement.removeChild(temp1);
                }
                if (temp2) {
                    temp2.parentElement.removeChild(temp2);
                }
                if (count > 3) {
                    var t = $(wrap);

                    t.on('init', function (event, slick) {
                        adaptHeight(slick);
                    }).on('beforeChange', function (event, slick, currentSlide) {
                        adaptHeight(slick);
                    }).slick({
                        dots: false,
                        arrows: true,
                        prevArrow: t.find('.blog-slider-btn.prev'),
                        nextArrow: t.find('.blog-slider-btn.next'),
                        slide: '.one-suggested-blog',
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    }).fadeIn();
                } else {
                    $(wrap).find('.blog-slider-btn').remove();
                }
            });
        }
    }

    function adaptHeight(slick) {
        setTimeout(function () {
            if (slick.$slideTrack.css('display') === 'flex') {
                slick.$list.css('height', '');
            } else {
                var h = 0;
                slick.$slides.filter('.slick-active').each(function () {
                    if (this.clientHeight > h) {
                        h = this.clientHeight;
                    }
                });
                slick.$list.css('height', h + 20 + 'px');
            }
        }, 10);
    }

    /* INIT */
    $(window).ready(function () {

        $blogCtn = $(".blog-home-ctn");
        if ($blogCtn.length) {
            $blogCtn.each(loadLastBlogs);
        }
    });
})();
'use strict';

(function ($, undefined) {
	'use strict';

	var showDescription = function showDescription() {
		var t = $(this);
		var com = t.closest('.board-of-directors-com');
		var desc = t.attr('data-description');
		var top = t.offset().top;
		var descCtn;
		var delay = 0;

		$('.board-director', com).each(function () {
			if ($(this).offset().top > top) {
				descCtn = $(this).prev();
				return false;
			} else if ($(this).index() === $('.board-of-directors-all-items-inner', com).children().length - 2) {
				descCtn = $(this).next();
			}
		});

		if ($('.board-director-desc-ctn.open', com).length > 0 && descCtn.attr('id') !== $('.board-director-desc-ctn.open', com).attr('id')) {
			delay = 500;
			$('.board-director.open', com).removeClass('open');
			$('.board-director-desc-ctn.open', com).slideUp(function () {
				$(this).find('.board-director-desc').html('');
				$(this).removeClass('open');
			});
		}

		setTimeout(function () {
			$('.board-director.open', com).removeClass('open');
			t.addClass('open');
			descCtn.find('.board-director-desc').html(desc);
			descCtn.slideDown(function () {
				$(this).addClass('open');
			});
		}, delay);
	};

	var hideDescription = function hideDescription() {
		var descCtn = $('.board-director-desc-ctn.open');

		$('.board-director.open').removeClass('open');
		descCtn.slideUp(function () {
			$(this).find('.board-director-desc').html('');
			$(this).removeClass('open');
		});
	};

	var init = function init() {
		$('.board-director.has-desc').click(showDescription);
		$('.close-board-director-desc-btn').click(hideDescription);

		$(window).resize(function () {
			if ($('.board-director-desc-ctn.open').length > 0) {
				hideDescription();
			}
		});
	};

	$(window).ready(init);
})(jQuery);
"use strict";

(function ($, undefined) {

    'use strict';

    var catalogProductsAutocomplete;
    var catalogProductsChoiceRemove;

    var fetchCatalogProducts = function fetchCatalogProducts() {
        var t = $(this);
        var parent = t.closest(".catalog-products-autocomplete-results");
        var dropdown = parent.find(".catalog-products-results-ctn");
        var input = parent.find(".catalog-products-autocomplete-results-choice");
        var val = t.val();

        var arr = input.val().split(",");
        if (val.length > 2) {
            ajax("/action/ajaxGetProduct?name=" + val, function (response, e) {
                dropdown.empty();
                var json = JSON.parse(response.trim());
                $.each(json, function (k, v) {
                    var cl = "";
                    if (arr.indexOf(String(json[k].productId)) !== -1) {
                        cl = " pmi-autocomplete-catalog-product-name-added";
                    }
                    var el = $("<div class='pmi-autocomplete-catalog-product-name" + cl + "' data-id='" + json[k].productId + "'></div>").text(json[k].name);
                    dropdown.append(el);
                });
                dropdown.slideDown();
                dropdown.find(".pmi-autocomplete-catalog-product-name:not('.pmi-autocomplete-catalog-product-name-added')").on("click", selectCatalogProduct);
            }, true);
        }
    };

    var selectCatalogProduct = function selectCatalogProduct() {
        var t = $(this);
        var id = t.attr("data-id");
        var name = t.text();
        var parent = t.closest(".catalog-products-autocomplete-results");
        var tags = parent.find(".catalog-products-results-tag-ctn");
        var input = parent.find(".catalog-products-autocomplete-results-choice");

        var inputVal = input.val();

        var arr = inputVal.split(",");
        if (arr.indexOf(id) === -1) {
            arr.push(id);
            var el = $("<div class='pmi-autocomplete-catalog-product-name-tags' data-id='" + id + "'></div>");
            var el2 = "<span class='pmi-remove-tag'>X</span>";
            var el3 = "<span>" + name + "</span>";
            el.append(el3);
            el.append(el2);
            el.on("click", removeSelectedCatalogProducts);
            tags.append(el);
            t.addClass("pmi-autocomplete-catalog-product-name-added");
            if (tags.not(":visible")) {
                tags.slideDown();
            }
        }

        input.val(arr.join(","));
        var langs = $('html').attr('data-all-langs');
        updateLabelLangs(input.attr("name"), arr.join(","), langs, function () {
            if (t.hasClass('refresh')) {
                window.location.reload();
            }
        }, true);
    };

    function removeSelectedCatalogProducts() {
        var t = $(this);
        var id = t.attr("data-id");
        var parent = t.closest(".catalog-products-autocomplete-results");
        var tags = parent.find(".catalog-products-results-tag-ctn");
        var input = parent.find(".catalog-products-autocomplete-results-choice");

        var inputVal = input.val();

        var arr = inputVal.split(",");
        if (arr.indexOf(id) !== -1) {
            arr.splice(arr.indexOf(id), 1);
            if (arr.length === 1) {
                tags.slideUp();
            }
        }
        input.val(arr.join(","));
        t.remove();
        var langs = $('html').attr('data-all-langs');
        updateLabelLangs(input.attr("name"), arr.join(","), langs, function () {
            if (t.hasClass('refresh')) {
                window.location.reload();
            }
        }, true);
    }

    var init = function init() {

        catalogProductsAutocomplete = $(".catalog-products-featured-pick");
        catalogProductsAutocomplete.on("keyup", fetchCatalogProducts);
        catalogProductsAutocomplete.on("focus", fetchCatalogProducts);

        catalogProductsChoiceRemove = $(".pmi-autocomplete-catalog-product-name-tags");
        catalogProductsChoiceRemove.on("click", removeSelectedCatalogProducts);

        $(document).on('click', function (catalogProduct) {
            if (!$(catalogProduct.target).closest('.catalog-products-autocomplete-results').length) {
                $(".catalog-products-results-ctn").slideUp();
            }
        });
    };

    $(window).ready(function () {
        init();
    });
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var mapOuterCtn;

	var initMap = function initMap() {
		mapOuterCtn.each(function (index) {
			var id = $(this).attr('data-id');
			var mapCtn = $(this).find('.contact-ver1-middle-ctn');
			var map;
			var geocoder;
			var marker;
			var address = $(this).find('.contact-address').html();

			if (address.length === 0) {
				return;
			}

			var mapOptions = {
				zoom: 16,
				disableDefaultUI: true
			};

			geocoder = new google.maps.Geocoder();
			geocoder.geocode({
				'address': address
			}, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					mapOptions.center = results[0].geometry.location;
					map = new google.maps.Map(document.getElementById('map-' + id), mapOptions);
					marker = new google.maps.Marker({
						map: map,
						position: results[0].geometry.location
					});
				}
			});
		});
	};

	var init = function init() {
		mapOuterCtn = $('.contact-ctn.ver1');

		if ($('.contact-address').length && mapOuterCtn.length) {
			initMap();
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function () {
    'use strict';

    var opts = {
        clockFace: 'DailyCounter',
        countdown: true,
        autoplay: true,
        language: 'Custom'
    };

    /* INIT */
    $(window).ready(function () {
        var $el = $('.countdown-clock-ctn');
        if (!$el.length) {
            return;
        }

        $('.countdown-date-input .datepicker').on('blur', function () {
            var inp = this;
            setTimeout(function () {
                updateLabelLangs(inp.name, inp.value, $('html').attr('langs'), function () {
                    var output = $(inp).parents('.com-countdown-inner').find('.countdown-clock-ctn')[0];
                    output.setAttribute('data-date', inp.value);
                    initCountdown.call(output);
                }, true);
            }, 200);
        });

        $el.each(initCountdown);
    });

    function initCountdown() {
        var data = this.dataset;

        FlipClock.Lang.Custom = {
            days: data.langDays,
            hours: data.langHours,
            minutes: data.langMinutes,
            seconds: data.langSeconds
        };

        if (data.date !== '') {
            var d1 = new Date(data.date);
            var d2 = new Date();
            var countdown = (d1.getTime() - d2.getTime()) / 1000;

            countdown = Math.max(1, countdown);
            $(this).FlipClock(countdown, opts);
        } else {
            $(this).FlipClock(opts);
        }
    }
})();
'use strict';

/* global Fw, actionPath, tinyMCE, grecaptcha */
(function () {
    'use strict';

    var utils_recaptcha2 = void 0,
        form_validateForm = void 0;

    function submitCustomizedForm(captcha) {
        var btn = $(this);
        var form = btn.closest('.js-form');
        var widgetId = btn.attr('data-widget-id');

        if (btn.hasClass('is-processing') || btn.hasClass('disabled')) {
            return false;
        }

        // Validate required fields
        form_validateForm(form);

        if (form.hasClass('has-error')) {
            // Reset if there is any error
            grecaptcha.reset(widgetId);
        } else {
            // No errors
            btn.addClass('is-processing disabled');
            var formdata = void 0;

            // Fetch the real content from the tinymce editors
            form.find('.mce-enabled').each(function () {
                if (window.tinymce) {
                    this.value = tinymce.get(this.id).getContent();
                }
            });
            // Init FormData
            formdata = new FormData(form[0]);
            formdata.append('ajax', 'true');

            $.ajax({
                method: 'post',
                type: 'post',
                url: actionPath + 'submitGenForm',
                data: formdata,
                cache: false,
                contentType: false,
                processData: false,
                success: function success(res) {
                    grecaptcha.reset(widgetId);
                    btn.removeClass('is-processing disabled');
                    if (res.indexOf('success') !== -1) {
                        var valuesArray = res.split(',').map(function (value) {
                            return value.trim();
                        });
                        form.removeClass('is-checked');
                        form.find('.has-value, .success').removeClass('has-value success').val('');
                        try {
                            form[0].reset();
                        } catch (err) {}
                        $('.js-form-success-message.form-sent', form).append("<br/> Your Submission ID: " + valuesArray[1]);
                        $('.js-form-success-hide', form).slideUp(300);
                        $('.js-form-success-message.form-sent', form).slideDown(300);
                    } else {
                        console.error(res);
                    }
                }
            });
        }
    }

    var init = function init() {
        utils_recaptcha2 = Fw.component.models().utils.recaptcha2;
        form_validateForm = Fw.component.models().form.validateForm;

        $('.submit-customized-form-btn').each(function () {
            utils_recaptcha2(this, submitCustomizedForm);
        });
    };

    $(window).ready(init);
})();
'use strict';

/* global Fw, actionPath, tinyMCE */
(function () {
    /* jshint validthis: true */
    'use strict';

    function init() {
        //INIT STOP
        if (!document.querySelector(".com-document-library")) return;

        $('.com-document-library-item-edit .edit-access').on('click', openActionPopup);
        $('html').on('click', closeAllActionPopups);
        $('.com-document-library-item-access-popup .access-group').on('click', changeViewAccess);
        $('.com-document-library-item-edit-metadata-popup .save-btn').on('click', editMetadata);
    }

    function openActionPopup(e) {
        e.stopPropagation();
        var btn = e.currentTarget;
        var popup = $(btn).parent().find('.action-popup');

        if (popup.hasClass('open')) {
            popup.removeClass('open');
        } else {
            $('.action-popup.open').removeClass('open');
            popup.addClass('open');
        }
    }

    function closeActionPopup(e) {
        $(e.currentTarget).closest('.action-popup').removeClass('open');
    }

    function closeAllActionPopups(e) {
        if (!e || !$(e.target).closest('.action-ctn')[0]) {
            $('.action-popup.open').removeClass('open');
        }
    }

    function changeViewAccess(e) {
        var el = e.currentTarget;
        var ctn = $(el).closest('.action-ctn');
        if (ctn.data('field6') === el.dataset.value) {
            return false;
        }

        ctn.data('field6', el.dataset.value).attr('data-field6', el.dataset.value);

        saveGenData(ctn, function () {
            $(el).closest('.action-ctn').find('.edit-access .text').text(el.dataset.label ? el.dataset.label : el.textContent);
        });

        closeAllActionPopups();
    }

    function editMetadata(e) {
        var btn = $(e.currentTarget);
        var popup = btn.closest('.popup');
        var ctn = btn.closest('.action-ctn');
        var title = popup.find('.input[name=field5]').val();
        var description = popup.find('.input[name=field7]').val();

        ctn.data('field5', title).attr('data-field5', title).data('field7', description).attr('data-field7', description);

        saveGenData(ctn, function () {
            var el = ctn.closest('.com-document-library-item');
            el.find('.com-document-library-item-link').attr('title', description).children('span').text(title);
            // Description element exists in version 2
            el.find('.com-document-library-item-description').text(description);
        });

        popup.find('.close-popup-btn').trigger('click');
    }

    function saveGenData(ctn, callback) {
        var param = 'ajax=true';
        var dataset = ctn.data();

        for (var key in dataset) {
            param += '&' + key + '=' + encodeURIComponent(dataset[key]);
        }

        console.log(param);
        ajax(actionPath + 'manageGenData?' + param, function (resp) {
            if (resp.indexOf('success-') > -1) {
                console.log(resp);
                var id = resp.substr(8);
                ctn.data('id', id).attr('data-id', id);

                if (typeof callback === 'function') {
                    callback();
                }
            }
        }, true, null, true);
    }

    $(window).ready(init);
})();
'use strict';

(function ($, undefined) {
	'use strict';

	var galleryImg;
	var closeFullscreenBtn;
	var viewingImg;

	var initGallerySlider = function initGallerySlider() {
		$('.gallery-com-ctn.ver1 .gallery-com-images-ctn').each(function () {
			var t = $(this);

			t.slick({
				dots: false,
				arrows: true,
				prevArrow: t.find('.arrow-btn.prev'),
				nextArrow: t.find('.arrow-btn.next'),
				slide: '.gallery-one-image',
				slidesToShow: 3,
				slidesToScroll: 3,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			}).fadeIn();
		});
	};

	var showImgFullscreen = function showImgFullscreen() {
		var t = $(this);
		var ctn = t.closest('.gallery-com-ctn').find('.fullscreen-img-ctn');

		ctn.find('.fullscreen-img').attr('style', t.attr('style'));
		ctn.addClass('open');
		viewingImg = this;
	};

	var closeFullscreen = function closeFullscreen() {
		$(this).closest('.fullscreen-img-ctn').removeClass('open');
		viewingImg = null;
		setTimeout(function () {
			$('.fullscreen-img').removeAttr('style');
		}, 300);
	};

	var nextImg = function nextImg() {
		var t = $(this);
		var el = $(viewingImg).closest('.gallery-one-image');
		var img;

		if (t.hasClass('prev')) {
			if (el.prev()[0]) {
				img = el.prev();
			} else {
				img = el.parent().children(':last');
			}
		} else {
			if (el.next()[0]) {
				img = el.next();
			} else {
				img = el.parent().children(':first');
			}
		}
		if (img && img[0]) {
			viewingImg = img.children()[0];
			t.closest('.fullscreen-img-ctn').find('.fullscreen-img').attr('style', viewingImg.getAttribute('style'));
		}
	};

	var init = function init() {
		initGallerySlider();
		galleryImg = $('.gallery-one-image-inner:not(.text-only)');
		closeFullscreenBtn = $('.close-image-fullscreen-btn');

		galleryImg.click(showImgFullscreen);
		closeFullscreenBtn.click(closeFullscreen);
		$('.gallery-fullscreen-nav').click(nextImg);
	};

	$(window).ready(init);
})(jQuery);
'use strict';

(function ($, undefined) {

    'use strict';

    var handleClickDayEvent = function handleClickDayEvent() {
        var t = $(this);

        if (t.hasClass('hover') && !$('html').hasClass('mobile')) {
            window.location.href = $(this).attr('data-url');
        } else if (t.hasClass('forward') && !$('html').hasClass('mobile')) {
            window.location.href = $(this).attr('data-url');
        } else {
            showDayEvent(t);
        }
    };

    var showDayEvent = function showDayEvent(dayCtn) {
        var t;
        dayCtn.length !== undefined ? t = dayCtn : t = $(this);
        var calendarOuter = t.closest('.calendar-home-cal-ctn');

        if (t.hasClass('selected') || calendarOuter.hasClass('animating')) {
            return;
        }

        calendarOuter.addClass('animating');

        var day = parseInt(t.find('.home-calendar-day-number').html());
        var id = t.attr('data-id');
        var version2 = false;
        var eventInfosCtn = calendarOuter.find('.home-calendar-one-event-right-side .calendar-home-event-infos-ver2');
        if (eventInfosCtn.length !== 0) {
            version2 = true;
        } else {
            eventInfosCtn = calendarOuter.find('.home-calendar-one-event-right-side .calendar-home-event-infos');
        }
        calendarOuter.find('.home-calendar-day.selected').removeClass('selected');
        t.addClass('selected');

        calendarOuter.find('.day-to-replace').html(day);
        if (calendarOuter.find('.day-suffix-to-replace').length) {
            var suffix = 'th';

            if (day % 10 === 1 && day % 100 !== 11) {
                suffix = 'st';
            } else if (day % 10 === 2 && day % 100 !== 12) {
                suffix = 'nd';
            } else if (day % 10 === 3 && day % 100 !== 13) {
                suffix = 'rd';
            }
            calendarOuter.find('.day-suffix-to-replace').html(suffix);
        }
        if (eventInfosCtn.attr('data-id') !== id) {
            eventInfosCtn.fadeOut(function () {
                if (version2) {
                    $('.calendar-home-event-infos-ver2').slick('unslick');
                    eventInfosCtn.html($('.calendar-home-event-infos-ver2[data-id=' + id + ']').html());
                    $('.calendar-home-event-infos-ver2').slick({
                        infinite: true,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        nextArrow: '<button class="event-slider-arrows event-slider-next" />',
                        prevArrow: '<button class="event-slider-arrows event-slider-prev" />'
                    });
                    $('.calendar-home-event-infos-ver2').resize();
                } else {
                    eventInfosCtn.html($('.calendar-home-event-infos[data-id=' + id + ']').html());
                }
                eventInfosCtn.attr('data-id', id);
                eventInfosCtn.fadeIn();

                if (calendarOuter.find('.home-cal-event-ctn').hasClass('hide')) {
                    if (version2) {
                        calendarOuter.find('.home-cal-event-ctn').slideUp(function () {
                            $(this).removeClass('hide');
                            calendarOuter.removeClass('animating');
                            $('.calendar-home-event-infos-ver2').slick("refresh");
                        });
                    } else {
                        calendarOuter.find('.home-cal-event-ctn').slideDown(function () {
                            $(this).removeClass('hide');
                            calendarOuter.removeClass('animating');
                        });
                    }
                } else {
                    calendarOuter.removeClass('animating');
                }
            });
        } else {
            calendarOuter.removeClass('animating');
        }
    };

    var init = function init() {
        $('.home-calendar-day.has-event').click(handleClickDayEvent);
        $('.home-calendar-day.has-event.hover').mouseover(showDayEvent);
    };
    $('.calendar-home-event-infos-ver2').slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        autoplaySpeed: 2000,
        nextArrow: '<button class="event-slider-arrows event-slider-next" />',
        prevArrow: '<button class="event-slider-arrows event-slider-prev" />'
    });
    $(window).ready(function () {
        init();
    });
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var initLogosSlider = function initLogosSlider() {
		$('.logos-component-all-logos-inner.slider').each(function () {
			var t = $(this);
			var ctn = t.closest('.logos-component-all-logos-outer');
			var count = t.data('count');
			// console.log(count)

			if (t.closest('.side-nav-content-ctn').length) {
				slickSideNav(t, ctn);
			} else {
				slick(t, ctn);
			}

			ctn.fadeIn();
		});
	};

	var slick = function slick(t) {
		// console.log('slick')
		if (!t.hasClass('slick-initialized')) {
			t.removeClass('flexbox');
			var max = t.data('max');

			t.slick({
				autoplay: true,
				dots: false,
				arrows: false,
				slide: '.logos-component-one-logo',
				autoplaySpeed: 4000,
				slidesToShow: max,
				slidesToScroll: max,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: max <= 4 ? max : 4,
						slidesToScroll: max <= 4 ? max : 4
					}
				}, {
					breakpoint: 767,
					settings: {
						slidesToShow: max <= 3 ? max : 3,
						slidesToScroll: max <= 3 ? max : 3
					}
				}, {
					breakpoint: 599,
					settings: {
						slidesToShow: max <= 2 ? max : 2,
						slidesToScroll: max <= 2 ? max : 2
					}
				}, {
					breakpoint: 479,
					settings: {
						slidesToShow: max <= 1 ? max : 1,
						slidesToScroll: max <= 1 ? max : 1
					}
				}]
			});
		}
	};

	var slickSideNav = function slickSideNav(t) {
		// console.log('slick')
		if (!t.hasClass('slick-initialized')) {
			t.removeClass('flexbox');
			var max = t.data('max');

			t.slick({
				autoplay: true,
				dots: false,
				arrows: false,
				slide: '.logos-component-one-logo',
				autoplaySpeed: 4000,
				slidesToShow: max,
				slidesToScroll: max,
				responsive: [{
					breakpoint: 1280,
					settings: {
						slidesToShow: max <= 3 ? max : 3,
						slidesToScroll: max <= 3 ? max : 3
					}
				}, {
					breakpoint: 1024,
					settings: {
						slidesToShow: max,
						slidesToScroll: max
					}
				}, {
					breakpoint: 768,
					settings: {
						slidesToShow: max <= 3 ? max : 3,
						slidesToScroll: max <= 3 ? max : 3
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: max <= 2 ? max : 2,
						slidesToScroll: max <= 2 ? max : 2
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: max <= 1 ? max : 1,
						slidesToScroll: max <= 1 ? max : 1
					}
				}]
			});
		}
	};

	var unslick = function unslick(t) {
		// console.log('unslick')
		if (t.hasClass('slick-initialized')) {
			t.slick('unslick');
		}
		t.addClass('flexbox');
	};

	var init = function init() {
		if ($('.logos-component-all-logos-inner.slider').length > 0) {
			initLogosSlider();

			$(window).resize(function () {
				initLogosSlider();
			});
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($, undefined) {
	'use strict';

	var mapCtn;
	var isUnderSm = true;

	var initMap = function initMap() {
		mapCtn.each(function (index) {
			var t = $(this);
			var id = t.closest('.map-com-outer-ctn').attr('data-id');
			var map;
			var geocoder;
			var marker;
			var address = t.closest('.map-com').find('.map-com-address').html();
			var panX = t.data('panX');
			var panY = t.data('panY');
			var panMinWidth = t.data('panMinWidth');

			if (address.length === 0) {
				return;
			}

			if ($(window).width() >= panMinWidth) {
				isUnderSm = false;
			}

			var mapOptions = {
				zoom: 16,
				disableDefaultUI: true
			};

			geocoder = new google.maps.Geocoder();
			geocoder.geocode({
				'address': address
			}, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					mapOptions.center = results[0].geometry.location;
					map = new google.maps.Map(document.getElementById('map-' + id), mapOptions);
					// var newPanX = panX;
					// var newPanY = panY;

					// if (panX.substr(panX.length - 1) === '%') {
					//     var percValueX = parseInt(panX.substr(0, (panX.length - 1)));
					//     var mapWidth = parseInt(t.width());
					//     newPanX = mapWidth / 100 * percValueX;
					// }

					// if (panY.substr(panY.length - 1) === '%') {
					//     var percValueY = parseInt(panY.substr(0, (panY.length - 1)));
					//     var mapHeight = parseInt(t.height());
					//     newPanY = mapHeight / 100 * percValueY;
					// }
					// if (!isUnderSm) {
					//     map.panBy(newPanX, newPanY);
					// }

					marker = new google.maps.Marker({
						map: map,
						position: results[0].geometry.location,
						icon: t.attr('data-marker'),
						title: address
					});
				}
			});
		});
	};

	var init = function init() {
		mapCtn = $('.map-com-outer-ctn');

		if (mapCtn.length) {
			initMap();
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

/* global getPosition */
(function () {
    'use strict';

    var firstItem;
    var incrementsArray;

    /* INIT */
    $(window).ready(function () {
        if (!$('.membership-statistics-com-ctn').length) {
            return;
        }
        firstItem = $('.membership-statistics-box-value')[0];

        $(window).on('scroll', checkPosition);
        checkPosition();
    });

    function checkPosition() {
        if (window.innerHeight + window.scrollY > getPosition(firstItem).y) {
            // Detected proximity, turn off position checking for performance purpose
            $(window).off('scroll', checkPosition);
            // Initiate the array
            incrementsArray = [];
            // Activate number changing on each item
            $('.membership-statistics-box-value').each(function (i, el) {
                // Span over 2 seconds at the interval of 42 miliseconds
                incrementsArray[i] = parseFloat(el.getAttribute('data-value')) / (2000 / 42);
                runValues(i, el);
            });
        }
    }

    function runValues(i, el) {
        var a = parseInt(el.getAttribute('data-value'));
        var b = parseFloat(el.getAttribute('data-current')) + incrementsArray[i];

        el.setAttribute('data-current', b);
        el.textContent = Math.round(b);
        if (a > b) {
            setTimeout(function () {
                runValues(i, el);
            }, 42);
        } else if (a != b) {
            el.textContent = a;
        }
    }
})();
'use strict';

(function ($, undefined) {

    'use strict';

    var formValidator;
    var checkbox;
    var extraRadio;
    var submitMentorFormBtn;

    var addCheckboxes = function addCheckboxes() {
        var t = $(this);
        var form = t.closest('.js-form');
        var input = form.find('.checkbox-field');

        if (t.prop('checked') === true) {
            input.val(input.val() + t.val() + ', ');
        } else {
            input.val(input.val().replace(t.val() + ', ', ''));
        }
    };

    var addExtraRadio = function addExtraRadio() {
        var t = $(this);
        var form = t.closest('.js-form');
        var input = form.find('.field-extra-checkbox');

        input.val(t.val());
    };

    var submitMentorForm = function submitMentorForm() {
        var t = $(this);
        var form = t.closest('.js-form');
        var successMsg = form.find('.mentoring-form-sent');

        successMsg.slideUp();
        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            var multipart = form.hasClass("js-multipart-form");
            var formdata = new FormData(form[0]);

            var count = t.attr('data-count');
            var email = form.find('input[name=email]').val();
            var subject = form.find('input[name=subject]').val();
            var content = form.find('textarea[name=content]').val();
            var type = t.attr('data-id');
            var url = '/action/pmiMentorat';

            if (multipart) {
                formdata.append('count', count);
                formdata.append('email', email);
                formdata.append('targetEmail', '');
                formdata.append('type', type);
                formdata.append('subject', subject);
                formdata.append('content', content);

                for (var i = 1; i < count; i++) {
                    if ($('.field' + i, form).length !== 0) {
                        formdata.append('fieldName' + i, $('.fieldName' + i, form).val());
                        formdata.append('field' + i, $('.field' + i, form).val());
                    }
                }

                $.ajax({
                    method: 'post',
                    type: 'post',
                    url: url,
                    data: formdata,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function success(res) {
                        _success(res);
                    }
                });
            } else {
                url += '?subject=' + encodeURIComponent(subject);
                url += '&type=' + type;

                for (var i = 1; i < count; i++) {
                    if ($('.field' + i, form).length !== 0) {
                        url += '&fieldName' + i + '=' + encodeURIComponent($('.fieldName' + i, form).val());
                        url += '&field' + i + '=' + encodeURIComponent($('.field' + i, form).val());
                    }
                }
                url += '&count=' + count + '&targetEmail=' + '&email=' + email + '&content=' + content;

                ajax(url, function (response) {
                    _success(response);
                }, true);
            }
        }

        var _success = function _success(response) {
            if (response.indexOf('success') !== -1) {
                form.find('input[type=checkbox]:checked').prop('checked', false);
                form.find('input[type=radio]:checked').prop('checked', false);
                form.find('input:not([type=checkbox]), textarea').removeClass('has-value').removeClass('success').val('');
                form.find('.success-fields-hide').slideUp();
                t.hide();
                successMsg.slideDown();
            }
        };
    };

    var init = function init() {
        formValidator = Fw.component.models().form;
        checkbox = $('input[name=mentorship-type]');
        extraRadio = $('input[name=mentorship-radio-extra]');
        submitMentorFormBtn = $('.submit-mentor-form-btn');

        checkbox.click(addCheckboxes);
        extraRadio.click(addExtraRadio);
        submitMentorFormBtn.click(submitMentorForm);
    };

    $(window).ready(function () {
        init();
    });
})(jQuery);
'use strict';

(function ($, undefined) {

    'use strict';

    var eventsAutocomplete;
    var eventsChoiceRemove;

    var initPageHeaderEventSlider = function initPageHeaderEventSlider() {
        $('.page-header-event-outer').each(function () {
            var com = $(this);
            if (!(com.hasClass('ver3') || com.hasClass('ver4'))) {
                return;
            }

            var textSlider = com.find('.page-header-event-content-top');
            var imagesSlider = com.find('.page-header-event-images-ctn');
            var boxesSlider = com.find('.page-header-event-boxes-ctn');
            var delay = com.find('.page-header-event-inner').attr('data-delay');

            if (com.hasClass('admin')) {
                textSlider.slick({
                    dots: false,
                    arrows: true,
                    autoplay: false,
                    prevArrow: com.find('.arrow-btn.prev'),
                    nextArrow: com.find('.arrow-btn.next'),
                    slide: '.page-header-event-text-ctn',
                    slidesToShow: 1,
                    draggable: false,
                    asNavFor: $('.page-header-event-images-ctn, .page-header-event-boxes-ctn')
                });
                textSlider.find('.page-header-event-text-ctn').fadeIn();

                imagesSlider.slick({
                    dots: false,
                    arrows: false,
                    autoplay: false,
                    slide: '.page-header-event-image',
                    slidesToShow: 1,
                    draggable: false,
                    asNavFor: $('.page-header-event-content-top, .page-header-event-boxes-ctn'),
                    fade: true
                });
                imagesSlider.find('.page-header-event-image').fadeIn();

                boxesSlider.slick({
                    dots: false,
                    arrows: false,
                    autoplay: false,
                    slide: '.page-header-event-box-ctn',
                    slidesToShow: 1,
                    draggable: false,
                    asNavFor: $('.page-header-event-images-ctn, .page-header-event-content-top')
                });
                boxesSlider.find('.page-header-event-image').fadeIn();

                $('*[draggable!=true]', '.slick-track').unbind('dragstart');
                $('.page-header-event-box').draggable();

                $(".page-header-event-box").on("dragstop", function (event, ui) {
                    var boxX = ui.position.left;
                    var boxY = ui.position.top;

                    var langs = $('html').attr('data-all-langs');

                    updateLabelLangs(ui.helper.attr("data-name") + '-x', boxX, langs, function () {}, true);
                    updateLabelLangs(ui.helper.attr("data-name") + '-y', boxY, langs, function () {}, true);
                });
            } else {
                textSlider.slick({
                    dots: false,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: delay * 1000,
                    prevArrow: com.find('.arrow-btn.prev'),
                    nextArrow: com.find('.arrow-btn.next'),
                    slide: '.page-header-event-text-ctn',
                    slidesToShow: 1,
                    asNavFor: $('.page-header-event-images-ctn, .page-header-event-boxes-ctn')
                    // asNavFor: (imagesSlider, boxesSlider)
                });
                textSlider.find('.page-header-event-text-ctn').fadeIn();

                imagesSlider.slick({
                    dots: false,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: delay * 1000,
                    slide: '.page-header-event-image',
                    slidesToShow: 1,
                    asNavFor: $('.page-header-event-content-top, .page-header-event-boxes-ctn'),
                    fade: true
                    // asNavFor: (textSlider, boxesSlider),
                });
                imagesSlider.find('.page-header-event-image').fadeIn();

                boxesSlider.slick({
                    dots: false,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: delay * 1000,
                    slide: '.page-header-event-box-ctn',
                    slidesToShow: 1,
                    asNavFor: $('.page-header-event-images-ctn, .page-header-event-content-top')
                    // asNavFor: (textSlider, imagesSlider)
                });
                boxesSlider.find('.page-header-event-image').fadeIn();
            }
        });
    };

    var fetchEvents = function fetchEvents() {
        var t = $(this);
        var parent = t.closest(".events-autocomplete-results");
        var dropdown = parent.find(".events-results-ctn");
        var input = parent.find(".events-autocomplete-results-choice");
        var val = t.val();

        var arr = input.val().split(",");
        if (val.length > 2) {
            ajax("/action/pmiEvent?getFutureEvents=true&q=" + encodeURIComponent(val), function (response, e) {
                dropdown.empty();
                var json = JSON.parse(response.trim());
                $.each(json, function (k, v) {
                    var cl = "";
                    if (arr.indexOf(String(json[k].id)) !== -1) {
                        cl = " pmi-autocomplete-event-name-added";
                    }
                    var el = $("<div class='pmi-autocomplete-event-name" + cl + "' data-id='" + json[k].id + "'></div>").text(json[k].name);
                    dropdown.append(el);
                });
                dropdown.slideDown();
                dropdown.find(".pmi-autocomplete-event-name:not('.pmi-autocomplete-event-name-added')").on("click", selectEvent);
            }, true);
        }
    };

    var selectEvent = function selectEvent() {
        var t = $(this);
        var id = t.attr("data-id");

        var name = t.text();
        var parent = t.closest(".events-autocomplete-results");
        var tags = parent.find(".events-results-tag-ctn");
        var input = parent.find(".events-autocomplete-results-choice");

        var inputVal = input.val();

        var arr = inputVal.split(",");
        if (arr.indexOf(id) === -1) {
            arr.push(id);
            var el = $("<div class='pmi-autocomplete-event-name-tags' data-id='" + id + "'></div>");
            var el2 = "<span class='pmi-remove-tag'>X</span>";
            var el3 = "<span>" + name + "</span>";
            el.append(el3);
            el.append(el2);
            el.on("click", removeSelectedEvents);
            tags.append(el);
            t.addClass("pmi-autocomplete-event-name-added");
            if (tags.not(":visible")) {
                tags.slideDown();
            }
        }

        input.val(arr.join(","));
        var langs = $('html').attr('data-all-langs');
        updateLabelLangs(input.attr("name"), arr.join(","), langs, function () {
            if (t.hasClass('refresh')) {
                window.location.reload();
            }
        }, true);
    };

    function removeSelectedEvents() {
        var t = $(this);
        var id = t.attr("data-id");
        var parent = t.closest(".events-autocomplete-results");
        var tags = parent.find(".events-results-tag-ctn");
        var input = parent.find(".events-autocomplete-results-choice");

        var inputVal = input.val();

        var arr = inputVal.split(",");
        if (arr.indexOf(id) !== -1) {
            arr.splice(arr.indexOf(id), 1);
            if (arr.length === 1) {
                tags.slideUp();
            }
        }
        input.val(arr.join(","));
        t.remove();
        var langs = $('html').attr('data-all-langs');
        updateLabelLangs(input.attr("name"), arr.join(","), langs, function () {
            if (t.hasClass('refresh')) {
                window.location.reload();
            }
        }, true);
    }

    var init = function init() {
        initPageHeaderEventSlider();

        eventsAutocomplete = $(".event-featured-pick");
        eventsAutocomplete.on("keyup", fetchEvents);
        eventsAutocomplete.on("focus", fetchEvents);

        eventsChoiceRemove = $(".pmi-autocomplete-event-name-tags");
        eventsChoiceRemove.on("click", removeSelectedEvents);

        $(document).on('click', function (event) {
            if (!$(event.target).closest('.events-autocomplete-results').length) {
                $(".events-results-ctn").slideUp();
            }
        });
    };

    $(window).ready(function () {
        init();
    });
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var initLogosSlider = function initLogosSlider() {
		$('.quotes-outer-ctn.ver1 .quotes-inner-ctn').each(function () {
			var t = $(this);

			t.slick({
				dots: true,
				arrows: true,
				prevArrow: t.find('.arrow-btn.prev'),
				nextArrow: t.find('.arrow-btn.next'),
				slide: '.one-quote',
				slidesToShow: 1,
				fade: true,
				responsive: [{
					breakpoint: 768,
					settings: {
						fade: false
					}
				}]
			}).fadeIn();
		});

		$('.quotes-outer-ctn.ver2 .quotes-inner-ctn').each(function () {
			var t = $(this);
			if (t.closest('.side-nav-content-ctn').length) {
				t.slick({
					dots: true,
					arrows: true,
					prevArrow: t.find('.arrow-btn.prev'),
					nextArrow: t.find('.arrow-btn.next'),
					slide: '.one-quote',
					slidesToShow: 2,
					slidesToScroll: 2,
					responsive: [{
						breakpoint: 1280,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}]
				}).fadeIn();
			} else {
				t.slick({
					dots: true,
					arrows: true,
					prevArrow: t.find('.arrow-btn.prev'),
					nextArrow: t.find('.arrow-btn.next'),
					slide: '.one-quote',
					slidesToShow: 3,
					slidesToScroll: 3,
					responsive: [{
						breakpoint: 1150,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}, {
						breakpoint: 768,
						settings: {
							// rtl: true,
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}]
				}).fadeIn();
			}
		});
	};

	var init = function init() {
		initLogosSlider();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
"use strict";

(function ($, undefined) {
    'use strict';

    var autoScrollUp = function autoScrollUp() {
        //Half duration since elements were cloned in the init to create seamless scrolling
        var speed = 500 * $(".rollup-membership-banner-item-single-ctn", $(this)).length;
        $(this).css({ top: 0 }).animate({ top: -($(this).outerHeight() * 0.5) - 7.5 }, speed, "linear", autoScrollUp);
    };

    var initRollupBannerSCroll = function initRollupBannerSCroll() {
        $('.rollup-membership-banner-scroll-ctn').each(function () {
            var speed = 1000 * $(".rollup-membership-banner-item-single-ctn", $(this)).length;
            $(".rollup-membership-banner-scroll-inner-ctn", $(this)).html($(".rollup-membership-banner-scroll-inner-ctn", $(this)).html() + $(".rollup-membership-banner-scroll-inner-ctn", $(this)).html());
            $(".rollup-membership-banner-scroll-inner-ctn", $(this)).css({ top: 0 }).animate({ top: -($(".rollup-membership-banner-scroll-inner-ctn", $(this)).outerHeight() * 0.5) - 7.5 }, speed, "linear", autoScrollUp);
        });
    };

    var showMoreRows = function showMoreRows(e) {
        var t = $(e.currentTarget);
        var ctn = t.closest('tbody');

        $('tr.hide', ctn).removeClass('hide');
        t.closest('tr').addClass('hide');
    };

    var changePageTable = function changePageTable(e) {
        e.preventDefault();
        var a = $(e.currentTarget);
        if (a.hasClass('processing')) {
            return false;
        }
        a.addClass('processing');

        var ctn = a.closest('.table-inner-wrap');
        var dataset = ctn.data();
        var page = dataset.page || 1;

        if (a.hasClass('next-page')) {
            page++;
        } else {
            page--;
        }
        $.ajax({
            method: "post",
            url: '/action/pmiMemberRecognition',
            data: {
                category: dataset.category,
                pmrJoinDate: dataset.joinDate,
                pmrPage: page
            },
            cache: false,
            success: function success(resp) {
                var parentEl = resp.children[0];
                var accountList = parentEl.getElementsByTagName('PMIAccount');
                var pagerEl = parentEl.getElementsByTagName('Pager')[0];
                var navCtn = a.closest('.pager-numbers-and-arrows-ctn');
                var content = '';

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = accountList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var el = _step.value;

                        var name = el.hasAttribute('fullName') ? el.getAttribute('fullName') : el.getAttribute('firstName') + ' ' + el.getAttribute('lastName');
                        var date = el.getAttribute('joinDate') || '';

                        if (dataset.category === 'certifications') {
                            date = el.getAttribute('pmpDate') || '';
                        }
                        if (date && dataset.usDate) {
                            var m = date.substring(3, 5);
                            var d = date.substring(0, 2);

                            date = m + date.substring(2, 3) + d + date.substring(5);
                        }

                        content += "<tr role=\"row\"><td class=\"\" data-th=\"\">" + name + "</td><td class=\"\" data-th=\"\">" + date + "</td>";
                        if (dataset.category === 'certifications') {
                            content += "<td class=\"\" data-th=\"\">" + el.getAttribute('designation') + "</td>";
                        }
                        content += '</tr>';
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                ctn.find('tbody').html(content);

                ctn.data('page', page);
                navCtn.find('.pager-numbers-ctn .current').text(page);
                if (a.hasClass('next-page')) {
                    navCtn.find('.previous-page').show();
                    if (page == pagerEl.getAttribute('pages')) {
                        a.hide();
                    }
                } else {
                    navCtn.find('.next-page').show();
                    if (page === 1) {
                        a.hide();
                    }
                }
                a.removeClass('processing');
            }
        });
    };

    var init = function init() {
        if ($('.rollup-membership-banner-com-ctn').hasClass('ver1')) {
            initRollupBannerSCroll();
        }
        $('.rollup-membership-banner-certifications-show-more').on('click', showMoreRows);
        $('.next-page, .previous-page', $('.member-recognition-pager')).on('click', changePageTable);
    };

    $(window).ready(init);
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var tab;

	var showTabContent = function showTabContent() {
		var t = $(this);
		var id = t.attr('data-id');
		var ctn = t.closest('.all-tabs-outer-ctn');

		if (t.hasClass('selected') || ctn.hasClass('animating')) {
			return;
		} else {
			ctn.addClass('animating');
		}

		ctn.find('.one-tab.selected').removeClass('selected');
		ctn.find('.one-tab[data-id=' + id + ']').addClass('selected');

		ctn.find('.one-tab-content.selected').fadeOut(function () {
			$(this).removeClass('selected');

			ctn.find('.one-tab-content[data-id=' + id + ']').fadeIn(function () {
				$(this).addClass('selected');
				ctn.removeClass('animating');
			});
		});
	};

	var init = function init() {
		tab = $('.one-tab');

		tab.click(showTabContent);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var tab;

	var openVideoPopup = function openVideoPopup() {
		var t = $(this);
		var id = t.attr('data-id');
		var popup = $('.com-video-popup[data-id=' + id + ']');

		popup.find('iframe').attr('src', popup.find('iframe').attr('data-url') + '?autoplay=1');
		popup.addClass('visible');
	};

	var closeVideoPopup = function closeVideoPopup() {
		var t = $(this);
		var popup = t.closest('.com-video-popup');

		popup.find('iframe').attr('src', popup.find('iframe').attr('data-url'));
		popup.removeClass('visible');
	};

	var init = function init() {
		$('.com-video-open-video-btn').click(openVideoPopup);
		$('.close-com-video-popup-btn').click(closeVideoPopup);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var win;
	var winWidth;
	var winHeight;
	var items;

	var autoScreenHeight = function autoScreenHeight() {
		items.each(function () {
			var t = $(this);
			var attr = t.data('autoScreenAttr') === undefined ? 'min-height' : t.attr('data-auto-screen-attr');
			var offset = t.data('autoScreenOffset') !== undefined ? t.data('autoScreenOffset').replace(/\s+/g, '').split(',') : 0;
			var factor = t.data('autoScreenFactor') !== undefined ? t.data('autoScreenFactor') : 1;
			var offsetHeight = 0;

			$.each(offset, function (i) {
				var t = $(offset[i]);
				offsetHeight += t.height() + parseInt(t.css('border-top-width')) + parseInt(t.css('border-bottom-width')) + parseInt(t.css('padding-top')) + parseInt(t.css('padding-bottom'));
			});

			var newHeight = winHeight * factor - offsetHeight;

			t.css(attr, newHeight);
		});
	};

	var init = function init() {
		win = $(window);
		winWidth = win.width();
		winHeight = win.height();
		items = $('.js-auto-screen-height');

		autoScreenHeight();

		win.resize(function () {
			winWidth = win.width();
			winHeight = win.height();

			autoScreenHeight();
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
"use strict";

(function ($, d, g) {

    'use strict';

    var $contractPopup;
    var contractKey = ("pmi_" + btoa("contract_agreement")).replace(/=/g, "");
    var contractVal = encodeURIComponent(btoa("accepted"));

    function hideContractPopup(e) {
        setContract(contractKey, contractVal, 24);
        e.delegateTarget.style.display = "none";
    }

    function setContract(cname, cvalue, exhours) {
        var dt = new Date();
        dt.setTime(dt.getTime() + exhours * 60 * 60 * 1000);
        var expires = "expires=" + dt.toUTCString();
        d.cookie = cname + "=" + cvalue + ";" + expires + ";";
    }

    function getContract(cname) {
        var name = cname + "=";
        var ca = d.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    var init = function init() {
        $contractPopup = $(".contract-popup");
        if ($contractPopup.length && getContract(contractKey) !== contractVal) {
            $contractPopup.show();
            $contractPopup.on("click", ".closeContractPopup", hideContractPopup);
        }
    };

    $(init);
})(jQuery, document, window);
"use strict";

(function ($, d, g) {

    'use strict';

    var ckKey = ("pmi_" + btoa("cookie_agreement")).replace(/=/g, "");
    var ckVal = encodeURIComponent(btoa("accepted"));
    var ckReject = encodeURIComponent(btoa("rejected"));

    var $popup;

    function setCookie(cname, cvalue, exhours) {
        var dt = new Date();
        dt.setTime(dt.getTime() + exhours * 60 * 60 * 1000);
        var expires = "expires=" + dt.toUTCString();
        d.cookie = cname + "=" + cvalue + ";" + expires + ";";
    }
    function getCookie(cname) {
        var name = cname + "=";
        var ca = d.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function acceptPolicy(e) {
        setCookie(ckKey, ckVal, 90 * 24);
        e.delegateTarget.style.display = "none";
    }

    function rejectPolicy(e) {
        setCookie(ckKey, ckReject, 24);
        e.delegateTarget.style.display = "none";
    }

    var init = function init() {
        $popup = $(".cookie-popup");
        if ($popup.length && getCookie(ckKey) !== ckVal && getCookie(ckKey) !== ckReject) {
            $popup.show();
            $popup.on("click", ".cookie-accept-btn", acceptPolicy);
            $popup.on("click", ".cookie-reject-btn", rejectPolicy);
        }
    };

    $(init);
})(jQuery, document, window);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {

	'use strict';

	var createSelects = function createSelects() {
		var selects = document.querySelectorAll('select.change-select-js');

		for (var i = 0; i < selects.length; i++) {
			var select = selects[i];
			var options = select.querySelectorAll('option');
			var parent = select.parentNode;
			var newSelect = document.createElement('div');
			var optionsContainer = document.createElement('div');
			var selectedValue = document.createElement('div');
			var optionsValues = '';

			for (var k = 0; k < select.attributes.length; k++) {
				var selectAttr = select.attributes[k];
				selectedValue.setAttribute(selectAttr.name, selectAttr.nodeValue || selectAttr.value);
			}

			newSelect.className = 'select-changed-js';

			optionsContainer.className = 'select-options-container';

			selectedValue.classList.remove('change-select-js');
			selectedValue.classList.add('select-value');
			selectedValue.setAttribute('tabindex', '0');

			for (var j = 0; j < options.length; j++) {
				var option = options[j];
				var newOption = document.createElement('div');
				var value = getValue(option);
				newOption.setAttribute('data-value', value);
				newOption.innerText = option.innerText;

				for (var l = 0; l < option.attributes.length; l++) {
					var optionAttr = option.attributes[l];
					newOption.setAttribute(optionAttr.name, optionAttr.nodeValue || optionAttr.value);
				}

				if (option.selected) {
					selectedValue.innerText = newOption.innerText;
					selectedValue.setAttribute('data-value', value);
					newOption.className = 'select-option selected hover';
				} else {
					newOption.className = 'select-option';
				}

				if (optionsValues.length) {
					optionsValues += '\n';
				}
				optionsValues += option.innerText;

				optionsContainer.appendChild(newOption);
			}

			newSelect.setAttribute('data-items', optionsValues);

			newSelect.appendChild(selectedValue);
			newSelect.appendChild(optionsContainer);
			parent.insertBefore(newSelect, select);
			parent.removeChild(select);

			setupListeners(newSelect, selectedValue, optionsContainer);
		}
	};

	var setupListeners = function setupListeners(newSelect, selectValue, optionsContainer) {
		var options = optionsContainer.querySelectorAll('.select-option');

		selectValue.addEventListener('mousedown', toggleOptionsContainer);
		newSelect.addEventListener('focusin', startListeningForKeys);
		newSelect.addEventListener('focusout', stopListeningForKeys);

		for (var i = 0; i < options.length; i++) {
			var option = options[i];
			option.addEventListener('mouseup', updateSelectedValue);
			option.addEventListener('mouseover', optionOver);
			option.addEventListener('mouseout', optionOver);
		}
	};

	var optionOver = function optionOver(e) {
		if (e.type === 'mouseout') {
			var target = document.elementFromPoint(e.clientX, e.clientY);
			if (target) {
				if (target.classList.contains('select-option')) {
					this.classList.remove('hover');
				}
			}
			this.removeEventListener('mousemove', optionOver);
		} else if (e.type === 'mouseover' || e.type === 'mousemove') {
			var hovered = getHovered(this.parentNode);

			if (e.type === 'mouseover' || hovered !== this) {
				hovered.classList.remove('hover');
				this.classList.add('hover');
			}

			if (e.type === 'mouseover') {
				this.addEventListener('mousemove', optionOver);
			}
		}
	};

	var startListeningForKeys = function startListeningForKeys() {
		window.addEventListener('keydown', selectKeydown);
		this.classList.add('select-focused');
	};

	var stopListeningForKeys = function stopListeningForKeys() {
		window.removeEventListener('keydown', selectKeydown);
		this.classList.remove('select-focused');
	};

	var selectKeydown = function selectKeydown(e) {
		var container = document.querySelector('.select-focused .select-options-container');
		var isOpened = container.classList.contains('show-options');
		var key = getKey(e.code || e.which);

		// Allows for other keys to work as they should
		if (key.isOneOfKeys || isOpened && !key.isOneOfKeys) {
			e.preventDefault();
			e.stopPropagation();

			if (key.code === 'Tab' || key.code === 9) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}

		if (isOpened) {
			if (key.isEnter || key.isEscape) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		} else {
			if (key.isSpace) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}

		if (key.isUp) {
			goToPrevValue(container, e);
		} else if (key.isDown) {
			goToNextValue(container, e);
		} else if (key.isKey) {
			goToNextKeyValue(container, e, key.code);
		}
	};

	var toggleOptionsContainer = function toggleOptionsContainer() {
		var options = this.nextElementSibling;
		var currentHover = getHovered(options);
		var currentSelected = getSelected(options);

		options.classList.toggle('show-options');

		currentHover.classList.remove('hover');
		currentSelected.classList.add('hover');

		if (options.classList.contains('show-options')) {
			setTimeout(function () {
				window.addEventListener('mousedown', closeToggled);
			}, 1);
		} else {
			window.removeEventListener('mousedown', closeToggled);
		}
	};

	var closeToggled = function closeToggled(e) {
		var classesRegex = /select-option|select-changed-js|select-value|select-options-container/;
		var target = e.target;
		var isSelect = false;
		if (e.target.className.match(classesRegex)) {
			if (target.classList.contains('select-focused')) {
				isSelect = true;
			} else {
				while (target) {
					if (target.classList.contains('select-focused')) {
						isSelect = true;
						break;
					} else if (!target.className.match(classesRegex)) {
						break;
					}
					target = target.parentNode;
				}
			}
		}

		if (!isSelect) {
			var containers = document.querySelectorAll('.show-options');
			for (var i = 0; i < containers.length; i++) {
				var option = containers[i];
				toggleOptionsContainer.apply(option.previousElementSibling);
			}
		}
	};

	var updateSelectedValue = function updateSelectedValue(e, fromKey) {
		var parent = this.parentNode;
		var select = parent.parentNode;
		var selectedValue = parent.previousElementSibling;
		var previousOption = getSelected(parent);
		var previousOver = getHovered(parent);
		var changeEvent;

		if (typeof window.CustomEvent === 'function') {
			changeEvent = new CustomEvent('change', {
				originalEvent: e,
				type: 'change'
			});
		} else {
			changeEvent = document.createEvent('CustomEvent');
			changeEvent.initCustomEvent('change', true, true, {
				originalEvent: e,
				type: 'change'
			});
		}

		e.preventDefault();

		previousOption.classList.remove('selected');
		this.classList.add('selected');

		selectedValue.setAttribute('data-value', this.getAttribute('data-value'));
		selectedValue.innerHTML = this.innerHTML;

		if (!fromKey) {
			toggleOptionsContainer.apply(selectedValue);
		} else {
			parent.scrollTop = this.offsetTop;
			previousOver.classList.remove('hover');
			this.classList.add('hover');
		}

		if (selectedValue.dispatchEvent) {
			selectedValue.dispatchEvent(changeEvent);
		} else {
			selectedValue.fireEvent(changeEvent);
		}
	};

	var goToPrevValue = function goToPrevValue(container, e) {
		var hover = getHovered(container);
		var prev = hover.previousElementSibling;

		if (prev) {
			updateSelectedValue.apply(prev, [e, true]);
		}
	};

	var goToNextValue = function goToNextValue(container, e) {
		var hover = getHovered(container);
		var next = hover.nextElementSibling;

		if (next) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};

	var goToNextKeyValue = function goToNextKeyValue(container, e, key) {
		var hover = getHovered(container);
		var options = container.querySelectorAll('.select-option');
		var found = false;
		var isNumber = !isNaN(key);
		var keyReplaced = isNumber ? 'asdsadas' : key.replace(/Key|Digit/, '');
		var next = hover;

		for (var i = 0; i < options.length; i++) {
			next = next.nextElementSibling;

			if (!next) {
				next = container.children[0];
			}

			if (isNumber) {
				if (next.innerHTML.charCodeAt(0) === key) {
					found = true;
					break;
				}
			} else {
				if (next.innerHTML.charAt(0).toUpperCase() === keyReplaced) {
					found = true;
					break;
				}
			}
		}

		if (found) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};

	var getValue = function getValue(option) {
		if (!option.hasAttribute('value')) {
			return option.innerText;
		} else {
			return option.getAttribute('value');
		}
	};

	var getKey = function getKey(key) {
		var data = {
			code: key,
			isEnter: false,
			isKey: false,
			isEscape: false,
			isSpace: false,
			isUp: false,
			isDown: false,
			isOneOfKeys: false,
			keyValue: undefined
		};
		var isNumber = key >= 48 && key <= 57;
		var isLetter = key >= 65 && key <= 90;

		if (key === 13 || key === 'Enter') {
			data.isEnter = true;
		} else if (key === 27 || key === 'Escape') {
			data.isEscape = true;
		} else if (key === 32 || key === ' ' || key === 'Space') {
			data.isSpace = true;
		} else if (key === 38 || key === 37 || key === 'ArrowLeft' || key === 'ArrowUp') {
			data.isUp = true;
		} else if (key === 40 || key === 39 || key === 'ArrowRight' || key === 'ArrowDown') {
			data.isDown = true;
		} else if (isNumber || isLetter || /[a-z0-9]{1}/i.test(key) && key.length === 1 || /(Key[A-Z])|(Digit[0-9])/.test(key)) {
			data.isKey = true;

			if (isNumber || isLetter) {
				keyValue = String.fromCharCode(key);
			} else {
				keyValue = key;
			}
		}

		if (data.isEnter || data.isEscape || data.isSpace || data.isUp || data.isDown || data.isKey) {
			data.isOneOfKeys = true;
		}

		return data;
	};

	var getHovered = function getHovered(container) {
		var hover = container.querySelector('.hover');

		if (!hover) {
			hover = container.querySelector('.select-option');
		}

		return hover;
	};

	var getSelected = function getSelected(container) {
		var selected = container.querySelector('.selected');

		if (!selected) {
			selected = container.querySelector('.select-option');
		}

		return selected;
	};

	var getSelectValue = function getSelectValue(selectCtn) {
		var selectItem;
		if (typeof selectCtn === 'string') {
			selectItem = document.querySelector(selectCtn);
			if (!selectItem) {
				return null;
			}
		} else if ((typeof selectCtn === 'undefined' ? 'undefined' : _typeof(selectCtn)) === 'object') {
			if (selectCtn[0]) {
				selectItem = selectCtn[0];
			} else {
				return null;
			}
		} else if (selectCtn && selectCtn.nodeType) {
			selectItem = selectCtn;
		} else {
			return null;
		}

		try {
			return selectItem.querySelector('.select-value').getAttribute('data-value');
		} catch (ex) {
			console.error(ex);
			return null;
		}
	};

	$(document).ready(function () {
		createSelects();
	});

	var customSelect = Fw.component.export('customSelect', {
		val: getSelectValue
	});
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var init = function init() {
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
			$('html').addClass('mobile');
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var editableText;

	var moveEditableText = function moveEditableText() {
		var text = $('.editable-text-ctn');

		text.each(function () {
			var t = $(this);
			var ctn = t.parent('.js-editable-container');
			var pos;
			var receiver;

			if (t.attr('data-position') !== 0) {
				pos = t.attr('data-position');
			} else {
				pos = 1;
			}

			if ($('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length !== 0) {
				receiver = $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn);
			} else {
				receiver = $('.js-editable-receiver', ctn);
			}

			if ($('.js-editable-receiver[data-editable-receiver-position]', ctn).length !== 0 && $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length === 0 && t.attr('data-position') !== '') {
				t.remove();
			} else if (ctn.length !== 0 && receiver.length !== 0) {
				t.detach().appendTo(receiver);
			}
		});
	};

	var addEditableTextClass = function addEditableTextClass() {
		$('.componentContainerDiv').addClass('js-editable-container');

		editableText.each(function () {
			var t = $(this);
			var parent = t.parent();

			parent.addClass('editable-text-ctn');
		});
	};

	var addEditableTextPosition = function addEditableTextPosition() {
		$('.js-editable-container').each(function () {
			var index = 1;
			var t = $(this);

			$('.editable-text-ctn', t).each(function () {
				var t = $(this);

				t.attr('data-position', index);

				index++;
			});
		});
	};

	var init = function init() {
		editableText = $('div[id^=displayTextInnerWindow]');

		addEditableTextClass();
		addEditableTextPosition();
		moveEditableText();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var addExternalLinkTarget = function addExternalLinkTarget() {
		$.expr[':'].external = function (obj) {
			var hostname = obj.hostname === '' ? location.hostname : obj.hostname;

			return !obj.href.match(/^mailto\:/) && hostname != location.hostname && obj.target === undefined && !obj.href.match(/^javascript\:/) && !obj.href.match(/^tel\:/) && !obj.href.match(/^$/) || obj.href.match(/\.pdf$/);
		};

		$('a:external').attr('target', '_blank');
	};

	var init = function init() {
		addExternalLinkTarget();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var respDetector;
	var footerInfosToggleBtn;
	var footerPrivacyToggleBtn;

	var toggleInfos = function toggleInfos() {
		if (respDetector.css('visibility') === 'visible') {
			var ctn = $(this).closest('.footer-toggle-outer-ctn');
			ctn.toggleClass('open');
			ctn.find('.footer-element-to-toggle').slideToggle();
		}
	};

	var togglePrivacyPolicy = function togglePrivacyPolicy() {
		var t = $(this);
		var label = t.attr('name');
		var val = t.val();
		var langs = $('html').attr('data-all-langs');
		var element = $('.' + label);
		var classes = element.attr('data-class');
		var extraClasses = '';

		if (t.attr('type') === 'checkbox') {
			val = t.prop('checked').toString();
		}

		element.removeClass();
		element.addClass(classes).addClass(extraClasses);

		updateLabelLangs(label, val, langs, function () {
			if (t.hasClass('refresh')) {
				window.location.reload();
			}
		}, true);
	};

	var init = function init() {
		respDetector = $('.resp-detector-xs');
		footerInfosToggleBtn = $('.footer-toggle-trigger-element');
		footerPrivacyToggleBtn = $('.footer-toggle-privacy-policy');

		footerInfosToggleBtn.click(toggleInfos);
		footerPrivacyToggleBtn.click(togglePrivacyPolicy);
	};

	$(init);
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var win = $(window);
	var winWidth;
	var winHeight;
	var body;
	var header;
	var navItems;
	var toggleMenuBtn;
	var mobileSubnavBtn;
	var mobileBackBtn;
	var siteSearchBtn;

	var toggleScroll = function toggleScroll() {
		var diff;

		if (body.hasClass('no-scroll')) {
			$('html').removeClass('no-scroll');
			body.removeClass('no-scroll');
			diff = 0;
		} else {
			var w1 = win.width();
			$('html').addClass('no-scroll');
			body.addClass('no-scroll');
			var w2 = win.width();
			diff = w2 - w1;
		}

		changeScrollDiff(diff);
	};

	var changeScrollDiff = function changeScrollDiff(diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px').css('right', -diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};

	var onClickMenuToggle = function onClickMenuToggle() {
		if (!!body.hasClass('menu-open')) {
			var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
			body.removeClass('menu-open');
			$('.whole-container').removeClass('pushed');

			header.on(transitionEnd, function (e) {
				$('html').removeClass('no-scroll');
				body.removeClass('no-scroll');
				changeScrollDiff(0);
				$(this).off(e);
			});
		} else {
			var target = 0;

			if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
				target = $('.site-header').offset().top;
			}

			if (win.scrollTop() <= $('.site-header').offset().top) {
				$('html').animate({ scrollTop: target }, 300);
				body.animate({ scrollTop: target }, 300, function () {
					openMenu();
				});
			} else {
				openMenu();
			}
		}
	};

	var openMenu = function openMenu() {
		body.addClass('menu-open');
		$('.whole-container').addClass('pushed');
		toggleScroll();
	};

	var closeMenu = function closeMenu() {
		if (body.hasClass('menu-open')) {
			$('.whole-container').removeClass('pushed');
			body.removeClass('menu-open');
			toggleScroll();
		}
	};

	var updateNavSelected = function updateNavSelected(page) {
		navItems.removeClass('selected');
		var handleObj = $('.main-content ' + page);
		var handle = handleObj.attr('data-page-nav');

		navItems.each(function () {
			var t = $(this);

			if (t.data('pageNav') === handle) {
				t.addClass('selected');
			}
		});
	};

	var openSubNav = function openSubNav() {
		var t = $(this);
		var id = t.attr('data-id');

		$('.sub-menu-panel[data-id=' + id + ']').addClass('open');
	};

	var closeSubNav = function closeSubNav() {
		$(this).parent('.sub-menu-panel').removeClass('open');
	};

	var toggleSearchInput = function toggleSearchInput() {
		if ($('.site-search-form').hasClass('input-open') && $('.site-search-form').find('input').val() !== '' && $('.resp-detector-sm').css('visibility') === 'hidden') {
			$(this).prop("type", "submit");
		}

		$('.site-search-form').toggleClass('input-open');
	};

	var handleStickySectionMenu = function handleStickySectionMenu() {
		if (win.scrollTop() > $('.site-header').height()) {
			$('.section-menu-bar').addClass('sticky');
		} else {
			$('.section-menu-bar').removeClass('sticky');
		}
	};

	var handleStickyHeader = function handleStickyHeader() {
		if (win.scrollTop() > 92) {
			header.addClass('resized');
		} else {
			header.removeClass('resized');
		}
	};

	var init = function init() {
		winWidth = win.width();
		winHeight = win.height();
		body = $('body');
		header = $('.site-header');
		navItems = $('.nav-item-link', header);
		toggleMenuBtn = $('.site-header-menu-toggle-btn', header);
		mobileSubnavBtn = $('.mobile-menu-ctn .sub-nav-item-link');
		mobileBackBtn = $('.mobile-back-ctn');
		siteSearchBtn = $('.header-search-btn');

		toggleMenuBtn.on('click', onClickMenuToggle);
		navItems.on('click', closeMenu);
		mobileSubnavBtn.click(openSubNav);
		mobileBackBtn.click(closeSubNav);
		siteSearchBtn.click(toggleSearchInput);

		win.resize(function () {
			if (win.width() != winWidth) {
				if (body.hasClass('menu-open')) {
					toggleMenuBtn.trigger('click');
				}
				winHeight = win.height();
				winWidth = win.width();
			}
		});

		if ($('.section-menu-bar').length > 0) {
			handleStickySectionMenu();
			win.scroll(handleStickySectionMenu);
		}

		if (body.hasClass('sticky')) {
			handleStickyHeader();
			win.scroll(handleStickyHeader);
		}

		$('table.sortable').tablesorter({
			widgets: ['staticRow']
		});
	};

	$(init);
})(jQuery);
'use strict';

(function ($, undefined) {
	'use strict';

	var changeBoxesOrder = function changeBoxesOrder() {
		var btn = $(this);
		var box = btn.closest('.page-split-right-side-infos-ctn');
		var ctn = btn.closest('.right-side-boxes-ctn');
		var currPos = box.attr('data-order');
		var newPos = currPos;

		btn.hasClass('up') ? newPos = parseInt(currPos) - 1 : newPos = parseInt(currPos) + 1;

		var siblingToChange = $('.page-split-right-side-infos-ctn[data-order=' + newPos + ']');
		siblingToChange.attr('data-order', currPos).css('order', currPos);
		updateLabelLangs('boxes.order.' + siblingToChange.data('label') + '.' + box.data('page'), currPos, $('html').attr('data-all-langs'), null, true);

		box.attr('data-order', newPos).css('order', newPos);
		updateLabelLangs('boxes.order.' + box.data('label') + '.' + box.data('page'), newPos, $('html').attr('data-all-langs'), null, true);
	};

	var init = function init() {
		$('.right-side-boxes-ctn').on('click', '.sort-right-side-box-btn', changeBoxesOrder);
	};

	$(init);
})(jQuery);
'use strict';

/* global Fw, actionPath, tinyMCE */
(function () {
    'use strict';

    var recaptcha;
    var validateForm;
    var successTimeout;
    var pminoInputs;

    var formSent = function formSent(response, form) {
        if (response.indexOf('success') !== -1) {
            var successMessage = $('.js-form-success-message.contact-form-sent', form);

            form.removeClass('is-checked');
            form.find('.has-value, .success').removeClass('has-value success').val('');
            try {
                form[0].reset();
            } catch (err) {
                console.error(err);
            }

            successMessage.slideDown(300, function () {
                grecaptcha.reset();

                clearTimeout(successTimeout);
                successTimeout = setTimeout(function () {
                    successMessage.slideUp(300);
                }, 5000);
            });
        }
    };

    var sendContactFormEmailClass = function sendContactFormEmailClass(captcha, form) {
        var t = $(this);
        var count = t.data('count');
        var subjectInput = $('.contactForm-subject', form);
        var subject = subjectInput.val();
        var email = $('.contactForm-email', form).val();
        var content = null;

        try {
            content = tinyMCE.get('contactForm-content', form).getContent();
        } catch (exception) {
            content = $('.contactForm-content', form).val();
        }

        var appendField = "";
        if ($('.fieldName1', form).length) {
            var total = 9;
            if (count) {
                total = count;
            }
            for (var i = 1; i < total; i++) {
                appendField += "&fieldName" + i + "=" + encodeURIComponent($('.fieldName' + i, form).val());
                if ($('.field' + i, form).attr('type') == "checkbox") {
                    if ($('.field' + i, form).checked) {
                        appendField += "&field" + i + "=checked.";
                    } else {
                        appendField += "&field" + i + "=not checked.";
                    }
                } else {
                    appendField += "&field" + i + "=" + encodeURIComponent($('.field' + i, form).val());
                }
            }
            appendField += "&count=" + total;
        }
        if (captcha) {
            appendField += '&captcha=' + captcha;
        }

        var sendCopyUser = $('[name=sendCopyUser]', form).val();
        if (sendCopyUser) {
            appendField += '&sendCopyUser=' + sendCopyUser;
        }

        var targetEmail = $('[name=targetEmail]', form).val();
        if (targetEmail) {
            appendField += '&targetEmail=' + targetEmail;
        }

        var identifier = $('[name=identifier]', form).val();
        if (identifier) {
            appendField += '&identifier=' + identifier;
        }

        if (subjectInput.prop('tagName') === 'SELECT') {
            var directEmail = subjectInput.find('option[value="' + subject + '"]').attr('data-email');

            if (directEmail.length > 0) {
                appendField += '&directEmail=' + directEmail;
            }
        }

        console.log(actionPath + "contactUs?subject=" + encodeURIComponent(subject) + "&email=" + encodeURIComponent(email) + "&content=" + encodeURIComponent(content) + appendField);

        ajax(actionPath + "contactUs?subject=" + encodeURIComponent(subject) + "&email=" + encodeURIComponent(email) + "&content=" + encodeURIComponent(content) + appendField, formSent, false, form);
    };

    var sendContactUsAttachmentDyn = function sendContactUsAttachmentDyn(captcha, form) {
        var formdata = new FormData(form[0]);

        formdata.append('ajaxForm', 'true');
        formdata.append('captcha', captcha);

        $.ajax({
            method: 'post',
            type: 'post',
            url: actionPath + 'contactUsAttachmentDyn',
            data: formdata,
            cache: false,
            contentType: false,
            processData: false,
            success: function success(res) {
                if (res.indexOf('success') !== -1) {
                    form.removeClass('is-checked');
                    form.find('.has-value, .success').removeClass('has-value success').val('');

                    $('.js-form-success-hide', form).slideUp(300);
                    $('.js-form-success-message.contact-form-sent', form).slideDown(300, function () {
                        grecaptcha.reset();
                    });
                }
            }
        });
    };

    var appendFieldContent = function appendFieldContent(name, value) {
        var x = value ? value : '';
        if (value.match(/^[a-zA-Z0-9.!#$%&�*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
            x = '<a href="mailto:' + value + '" target="_blank">' + value + '</a>';
        }
        return '<p><strong>' + name + ' - </strong>' + x + '</p>';
    };

    var sendPhoenixForm = function sendPhoenixForm(captcha, form) {
        var content = '';

        // Email
        var emailInput = $('.contactForm-email', form);
        if (emailInput.length) {
            content += appendFieldContent(emailInput.attr('title'), emailInput.val());
        }

        // Fields
        var i = 1;
        while ($('.fieldName' + i).length) {
            var curFieldName = $('.fieldName' + i);
            var curField = $('.field' + i);

            if (curField.attr('type') === 'checkbox' || curField.attr('type') === 'radio') {
                var vals = [];
                if (curField.length > 1) {
                    curField.filter(':checked').each(function () {
                        vals.push(this.value);
                    });
                } else {
                    var val = curField.val();
                    if (val && val !== "") {
                        vals[0] = val;
                    } else {
                        vals[0] = curField.prop('checked') ? 'checked' : 'unchecked';
                    }
                }
                content += appendFieldContent(curFieldName.val(), vals.join(', '));
            } else {
                content += appendFieldContent(curFieldName.val(), curField.val());
            }
            i++;
        }

        // Contact subject
        var subjectInput = $('.contactForm-subject', form);
        if (subjectInput.length) {
            content += appendFieldContent('Subject', subjectInput.val());
        }

        // Message content
        var messageInput = $('.contactForm-content', form);
        if (messageInput.length) {
            try {
                content += appendFieldContent('Message', tinyMCE.get('contactForm-content', form).getContent());
            } catch (err) {
                content += appendFieldContent('Message', messageInput.val());
            }
        }

        content += '<p>&nbsp;</p>';
        // Add user record
        if ($('.phxkbz-fname', form).length) {
            content += appendFieldContent('Submitter First Name', $('.phxkbz-fname', form).val());
        }
        if ($('.phxkbz-lname', form).length) {
            content += appendFieldContent('Submitter Last Name', $('.phxkbz-lname', form).val());
        }
        if ($('.phxkbz-email', form).length) {
            content += appendFieldContent('Submitter Email', $('.phxkbz-email', form).val());
        }
        content += appendFieldContent('Source', '<a href="' + window.location.href + '" target="_blank">' + window.location.href + '</a>');

        // Build the query
        var q = 'ajax=true&captcha=' + captcha;
        q += '&title=' + encodeURIComponent($('.phxkbz-title', form).val());
        q += encodeURIComponent(' - ' + $('.input-firstname', form).val() + ' ' + $('.input-lastname', form).val());
        q += '&labelId=' + encodeURIComponent($('.phxkbz-label-id', form).val());
        q += '&description=' + encodeURIComponent(content);

        // Submit the data
        ajax(actionPath + "pmiKanBanZone?" + q, formSent, false, form);
    };

    var updateTargetEmail = function updateTargetEmail(t) {
        var t = $(this);
        var form = t.closest('.contactForm-Container');
        var option = $(this).find('option:selected');

        $('.directEmail', form).val(option.attr('data-email'));
    };

    var verifyMemberId = function verifyMemberId(captcha, form, identifier, callback) {
        var btn = $(this);
        // Disable submit button
        btn.addClass('disabled');

        // Verify chapter member id
        var res = 'error';
        var inp = $(pminoInputs, form)[0];
        var data = {
            captcha: captcha,
            adelaide: true,
            verifyMemberNumber: inp.value,
            formId: identifier,
            formField: inp.name
        };

        $.ajax({
            url: actionPath + 'pmiAccount',
            method: 'get',
            type: 'get',
            data: data,
            success: function success(response) {
                res = response;
            },
            complete: function complete() {
                if (res.indexOf('success') !== -1) {
                    // Verified
                    form.find('.error-msg.not-permitted').slideUp(300);
                    callback.call(btn[0], captcha, form, identifier);
                } else {
                    // Invalid
                    grecaptcha.reset();
                    btn.removeClass('disabled');
                    form.find('.error-msg.not-permitted').slideDown(300);
                }
            }
        });
    };

    var submitFormAdelaide = function submitFormAdelaide(btn, captcha, form, identifier, count, subject, targetEmail, email) {
        var appendField = '';

        // Disable submit button
        btn.addClass('disabled');

        appendField += 'subject=' + encodeURIComponent(subject);
        appendField += '&targetEmail=' + encodeURIComponent(targetEmail);
        appendField += '&identifier=' + encodeURIComponent(identifier);
        appendField += '&email=' + encodeURIComponent(email);
        appendField += '&content='; // If "content" param was not set, "null" text would appear in the email
        appendField += '&count=' + count;
        for (var i = 1; i < count; i++) {
            appendField += '&fieldName' + i + '=' + encodeURIComponent($('.fieldName' + i, form).val());

            var type = $('.field' + i, form).attr('type');
            if (type === 'checkbox' || type === 'radio') {
                var x = [];
                $('.field' + i, form).each(function (i, el) {
                    if (el.checked) {
                        x.push(el.value);
                    }
                });
                appendField += '&field' + i + '=' + encodeURIComponent(x.join(','));
            } else {
                appendField += '&field' + i + '=' + encodeURIComponent($('.field' + i, form).val());
            }
        }
        if (captcha) {
            appendField += '&captcha=' + captcha;
        }

        var res = 'error';
        $.post({
            url: actionPath + 'contactUs',
            data: appendField,
            cache: false,
            success: function success(response) {
                res = response;
            },
            complete: function complete() {
                if (res.indexOf('success') !== -1) {
                    $('.js-form-success-hide', form).slideUp(300, function () {
                        $('.js-form-success-message.contact-form-sent', form).slideDown(300);
                    });
                } else {
                    btn.removeClass('disabled');
                    alert('Failed. Something went wrong.');
                }
            }
        });
    };

    var submitAttachmentFormAdelaide = function submitAttachmentFormAdelaide(btn, captcha, form, identifier, count, targetEmail) {
        var formdata = new FormData(form[0]);

        // Disable submit button
        btn.addClass('disabled');

        formdata.append('ajaxForm', 'true');
        if (captcha) {
            formdata.append('captcha', captcha);
        }
        formdata.append('targetEmail', targetEmail);
        formdata.append('identifier', identifier);
        formdata.append('content', ''); // If "content" param was not set, "null" text would appear in the email
        formdata.append('count', count);

        var res = 'error';
        $.post({
            url: actionPath + 'contactUsAttachmentDyn',
            data: formdata,
            cache: false,
            contentType: false,
            processData: false,
            success: function success(response) {
                res = response;
            },
            complete: function complete() {
                if (res.indexOf('success') !== -1) {
                    $('.js-form-success-hide', form).slideUp(300, function () {
                        $('.js-form-success-message.contact-form-sent', form).slideDown(300);
                    });
                } else {
                    btn.removeClass('disabled');
                    alert('Failed. Something went wrong.');
                }
            }
        });
    };

    var sendAdelaideVoteForm = function sendAdelaideVoteForm(captcha, form, identifier) {
        submitFormAdelaide($(this), captcha, form, identifier, 4, $('.contactForm-subject', form).val(), 'adelaide.vote', '-');
    };

    var sendAdelaideNominationForm = function sendAdelaideNominationForm(captcha, form, identifier) {
        submitAttachmentFormAdelaide($(this), captcha, form, identifier, 15, 'adelaide.vote');
    };

    var sendAdelaideEBallotForm = function sendAdelaideEBallotForm(captcha, form, identifier) {
        submitFormAdelaide($(this), captcha, form, identifier, 3, $('.contactForm-subject', form).val(), 'adelaide.vote', form.find('input[name=email]').val());
    };

    var init = function init(page) {
        recaptcha = Fw.component.models().utils.recaptcha;
        validateForm = Fw.component.models().form.validateForm;

        pminoInputs = $('.input-pmi-number');

        $('.contactForm-subject').on('change', updateTargetEmail);

        $('.submit-contact-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendContactFormEmailClass.call(btn, response, form);
            }, true, $(this).closest('.contactForm-Container'));
        });

        $('.submit-contactattdyn-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendContactUsAttachmentDyn.call(btn, response, form);
            }, true, $(this).closest('.contactForm-Container'));
        });

        $('.submit-phxkbz-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendPhoenixForm.call(btn, response, form);
            }, true, $(this).closest('.contactForm-Container'));
        });

        $('.submit-adelaide-vote-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                verifyMemberId.call(btn, response, form, 'adelaide-vote', sendAdelaideVoteForm);
            }, true, $(this).closest('.contactForm-Container'));
        });

        $('.submit-adelaide-nomination-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                verifyMemberId.call(btn, response, form, 'adelaide-nomination', sendAdelaideNominationForm);
            }, true, $(this).closest('.contactForm-Container'));
        });

        $('.submit-adelaide-e-ballot-form-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                verifyMemberId.call(btn, response, form, 'adelaide-e-ballot', sendAdelaideEBallotForm);
            }, true, $(this).closest('.contactForm-Container'));
        });
    };

    $(init);

    Fw.component.export('sendContactForm', {
        sendContactFormEmailClass: sendContactFormEmailClass
    });
})();
'use strict';

(function ($, undefined) {

    'use strict';

    var win;
    var sideNavSubMenuBtn;
    var sideNavCtn;
    var sideNavCtnHeight;
    var sideNavOuterCtn;
    var sideNavOuterCtnTop;
    var sideNavOuterCtnHeight;

    var checkScroll = function checkScroll() {
        sideNavCtnHeight = sideNavCtn.height();
        sideNavOuterCtnTop = sideNavOuterCtn.offset().top - 60;
        sideNavOuterCtnHeight = sideNavOuterCtn.height();
        var maxBottom = sideNavOuterCtnHeight + sideNavOuterCtnTop - 70 - sideNavCtnHeight;
        var top = 0;

        if (win.scrollTop() > maxBottom) {
            top = sideNavOuterCtnHeight - sideNavCtnHeight - 70;
        } else if (win.scrollTop() > sideNavOuterCtnTop) {
            top = win.scrollTop() - sideNavOuterCtnTop;
        } else if (win.scrollTop() <= sideNavOuterCtnTop) {
            top = 0;
        }

        $('.side-nav-inner-ctn.absolute').css('top', top + 'px');
    };

    var toggleSideSubNav = function toggleSideSubNav() {
        var t = $(this);
        var id = t.closest('.side-nav-item-link-outer-ctn').attr('data-id');
        var ctn = $('.side-nav-item-link-outer-ctn[data-id=' + id + ']');

        ctn.toggleClass('open');
        if (ctn.hasClass('open')) {
            $('.side-nav-inner-ctn.invisible').find(ctn).find('.side-nav-sub-ctn').slideDown(function () {
                checkScroll();
                $('.side-nav-inner-ctn.absolute').find(ctn).find('.side-nav-sub-ctn').slideDown();
            });
        } else {
            ctn.find('.side-nav-sub-ctn').slideUp(function () {
                checkScroll();
            });
        }
    };

    var init = function init() {
        win = $(window);
        sideNavSubMenuBtn = $('.side-nav-item-link-ctn .sub-nav-arrow');
        sideNavCtn = $('.side-nav-inner-ctn.invisible');
        sideNavOuterCtn = $('.side-nav-wrap-ctn');

        if ($('.side-nav').length) {
            checkScroll();

            win.scroll(function () {
                checkScroll();
            });
            win.resize(function () {
                checkScroll();
            });
        }

        sideNavSubMenuBtn.click(toggleSideSubNav);
    };

    $(init);
})(jQuery);
"use strict";

(function ($, undefined) {

    'use strict';
    // Create a Stripe client.

    var validateForm = function validateForm() {
        var stripe = $("html").attr("data-is-dev") === 'true' ? Stripe('pk_test_HhX3YNMlO2VMhFdx6AFnBe3q') : Stripe($('#stripe-cc-form').attr('data-key'));
        var button = $('.get-stripe-token');
        var cardInputsCtn = button.closest('form').find('.card-inputs-inner');
        var cardErrorsId = "card-errors";
        var ccFieldsId = "#stripe-cc-form";
        var ccFields = $(ccFieldsId);
        var form = button.closest(".submit-after-validation-form");
        var style = JSON.parse($(ccFieldsId).data('style'));

        if (ccFields.length !== 0) {
            // Create an instance of Elements.
            var elements = stripe.elements();

            //// Create an instance of the card Element. Remove hidePostalCode if PC validation required
            var card = elements.create('card', {
                hidePostalCode: true, style: style });

            card.mount(ccFieldsId);

            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function (event) {
                var displayError = document.getElementById(cardErrorsId);
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            var _checkout = function _checkout() {
                // In the checkout process the validation will go through recaptcha next so no submission after
                if (button.attr('data-widget-id') && !!window.grecaptcha) {
                    grecaptcha.execute(button.attr('data-widget-id'));
                } else {
                    if (button.closest('form').hasClass('checkout-form')) {
                        var checkout = Fw.component.models().checkout;
                        checkout.continueCheckout(button);
                    } else {
                        var tools = Fw.component.models().tools;
                        tools.validateForm(button);
                        if (form.length !== 0) {
                            form.submit();
                        }
                    }
                }
            };

            // Handle form submission.
            button.on('click', function (event) {
                event.preventDefault();

                if (cardInputsCtn.css('display') === 'block' && cardInputsCtn.css('visibility') === 'visible' || button.closest('.create-payment-form').length > 0) {
                    stripe.createToken(card).then(function (result) {
                        if (result.error) {
                            // Inform the user if there was an error.
                            var errorElement = document.getElementById(cardErrorsId);
                            errorElement.textContent = result.error.message;
                        } else {
                            // Send the token in a stripeToken param in the payment
                            var m;
                            if (result.token.card.exp_month < 10) {
                                m = '0' + result.token.card.exp_month;
                            } else {
                                m = result.token.card.exp_month;
                            }

                            $('input[name=cardToken]').val(result.token.id);
                            $('input[type=hidden].cc').val(result.token.card.last4);
                            $('input[type=hidden].mm').val(m);
                            $('input[type=hidden].yy').val(result.token.card.exp_year.toString().substring(2));

                            _checkout();
                        }
                    });
                } else {
                    _checkout();
                }
            });
        }
    };

    Fw.component.export('stripeToken', {
        init: validateForm
    });
})(jQuery);
"use strict";

(function ($, undefined) {

    'use strict';
    // Create a Stripe client.

    var validateForm = function validateForm() {
        var stripe = $("html").attr("data-is-dev") === 'true' ? Stripe('pk_test_51S0NUd2Q7oHUVblcFOC18jPIUOk2UTNZNIEZEP1vedvBL6tqJJvZpcCqVzTrDgemv1n8dSNwwFJnCavcZn8beNrx00cxAVM14X') : Stripe($('#stripe-cc-form2').attr('data-key'));
        var button = $('.get-stripe-intent');
        var cardInputsCtn = button.closest('form').find('.card-inputs-inner');
        var cardErrorsId = "card-errors";
        var ccFieldsId = "#stripe-cc-form2";
        var ccFields = $(ccFieldsId);
        var form = button.closest(".submit-after-validation-form");
        var style = JSON.parse($(ccFieldsId).data('style'));

        if (ccFields.length !== 0) {
            // Create an instance of Elements.
            var elements = stripe.elements();

            //// Create an instance of the card Element. Remove hidePostalCode if PC validation required
            var card = elements.create('card', {
                hidePostalCode: true, style: style });

            card.mount(ccFieldsId);

            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function (event) {
                var displayError = document.getElementById(cardErrorsId);
                if (event.error) {
                    displayError.textContent = event.error.message;
                    button.addClass('disabled');
                } else {
                    displayError.textContent = '';
                    button.removeClass('disabled');
                }
            });

            button.on('click', function (event) {
                event.preventDefault();

                button.addClass('disabled');

                // Send AJAX request to create PaymentIntent
                $.ajax({
                    url: '/action/stripeIntent',
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        amount: $('input[name="amount"]').val()
                    }),
                    success: function success(data) {
                        if (!data.clientSecret) {
                            var errorElement = document.getElementById(cardErrorsId);
                            errorElement.textContent = "Could not initiate payment.";
                            return;
                        }

                        stripe.confirmCardPayment(data.clientSecret, {
                            payment_method: {
                                card: card
                            }
                        }).then(function (result) {
                            if (result.error) {
                                document.getElementById(cardErrorsId).textContent = result.error.message;
                            } else if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
                                $('input[name=cardToken]').val(result.paymentIntent.id);

                                button.closest('form').submit();
                            }
                        });
                    },
                    error: function error(xhr, status, _error) {
                        var errorElement = document.getElementById(cardErrorsId);
                        errorElement.textContent = _error.message;
                        button.removeClass('disabled');
                    }
                });
            });
        }
    };

    Fw.component.export('stripeIntent', {
        init: validateForm
    });
})(jQuery);
"use strict";

(function () {
    "use strict";

    var currentSyncScrollTimeout = null;
    var currentSyncScrollElement = null;

    /* CONTENT READY */

    $(window).load(function () {
        // Init table top scroller
        $(".table-outer-ctn .table-inner-wrap").each(function () {
            var $it = $(this);
            var $dum = $("<div class='table-top-scroller'><table></table></div>");
            // Insert before the target table wrap
            $dum.insertBefore($it);
            // Set the dummy table the same width as the real table and holding 
            // height to display the scroll bar
            $dum.find("table").css({
                width: $it.find("table").outerWidth(),
                height: "1px"
            });
            // In case the scroll has already happened after page refresh
            $dum.scrollLeft($it.scrollLeft());
            // Set scroll event to sync both scrollers
            $dum.on("scroll", syncScroll);
            $it.on("scroll", syncScroll);
        });
    });

    /* FUNCTIONS CONSTRUCTION */

    function syncScroll(e) {
        var $targ = $(e.currentTarget || this);
        var x = $targ.scrollLeft();

        if (currentSyncScrollElement === null) {
            // Assign the first active element
            currentSyncScrollElement = $targ[0];
        }
        // Prevent double event activation on both scrollbars
        if (currentSyncScrollElement === $targ[0]) {
            // Clear out the previous timeout
            if (currentSyncScrollTimeout !== null) {
                window.clearTimeout(currentSyncScrollTimeout);
            }
            // Sets new scroll timeout
            currentSyncScrollTimeout = window.setTimeout(function () {
                currentSyncScrollElement = null;
            }, 167);

            if ($targ.hasClass("table-top-scroller")) {
                // Scroll the main container
                $targ.next().scrollLeft(x);
            } else if ($targ.hasClass("table-inner-wrap")) {
                // Scroll the dummy
                $targ.prev().scrollLeft(x);
            }
        }
    }
})();
"use strict";

(function ($, undefined) {

    'use strict';
    // Create a Worldpay client.

    var validateForm = function validateForm() {
        var worldpay = $("html").attr("data-is-dev") === 'true' ? 'T_C_d3215ec3-f9b8-4b06-91da-098b38900abf' : $('#worldpay-cc-form').attr('data-key');
        var button = $('.get-worldPay-token');
        var form = button.closest('form'); //Formulaire de checkout
        var cardInputsCtn = form.find('.card-inputs-inner');
        var ccFieldsId = "#worldpay-cc-form";
        var ccFields = $(ccFieldsId);

        if (ccFields.length !== 0) {
            Worldpay.useOwnForm({
                'clientKey': worldpay, //Client id
                'form': form[0],
                'formatCardNumber': false,
                'reusable': false, //Store Card
                'callback': function callback(status, response) {
                    //Executed on submit of the form
                    document.getElementById('paymentErrors').innerHTML = '';

                    if (form.find('.card-inputs-inner').css('display') === 'block' || button.closest('.create-payment-form').length > 0) {
                        if (response.error) {
                            Worldpay.handleError(form, document.getElementById('paymentErrors'), response.error);
                            $(".validate-form-btn").removeClass("disabled");
                            button.removeClass("disabled");
                        } else {
                            var token = response.token;
                            form.find('input[name=cardToken]').val(token);
                            form[0].submit();
                        }
                    } else {
                        // check payment
                        form[0].submit();
                    }
                }
            });
            // Handle form submission.
            button.on('click', function (event) {
                event.preventDefault();
                if (cardInputsCtn.css('display') === 'block' || button.closest('.create-payment-form').length > 0) {
                    var fn = form.find("input[name = 'firstName']").val();
                    var ln = form.find("input[name = 'lastName']").val();

                    $("#worldpay-cc-form-name").val(fn + " " + ln);
                }
                if (button.closest('form').hasClass('checkout-form')) {
                    var checkout = Fw.component.models().checkout;
                    checkout.continueCheckout(button);
                } else {
                    var tools = Fw.component.models().tools;
                    tools.validateForm(button);
                }
            });
        }
    };

    var worldpayToken = Fw.component.export('worldpayToken', {
        init: validateForm
    });
})(jQuery);
"use strict";

/* global Fw, tinyMCE */

(function ($, d, g) {
    /* jshint validthis: true */
    "use strict";

    var formValidator;
    var tools;
    var step1;
    var eventSessionSelector;
    var eventPastSessionSelector;
    var number;
    var fname;
    var lname;
    var email;
    var sendEmail;
    var participantsInfos;
    var participantNotFoundCheck;
    var fetchPastEventsBtn;
    var fetchFuturEventsBtn;

    var step2;
    var step3;
    var step4;

    var submitStep;
    var submitLastStep;
    var backStep;
    var cashToggleBtn;
    var triggeredBtn;

    window.eventsData = [];

    function saveEventInSession() {
        var t = $(this);
        var val = t.val();
        var ctn = t.closest(".registration-event-selector");
        var key1 = ctn.find(fetchFuturEventsBtn).attr("data-key");
        var key2 = ctn.find(fetchPastEventsBtn).attr("data-key");

        if (key1 && key1 !== "") {
            ajax("/action/sessionVariables?key=" + key1 + "&value=" + val, null, true);
        }
        if (key2 && key2 !== "") {
            ajax("/action/sessionVariables?key=" + key2 + (t.hasClass("registration-event-select-past") ? "&value=true" : "&value="), null, true);
        }

        // Integrate the logic from the separate listener here:
        var selectedEventId = val; // Since val is the value of the selected option
        var selectedEvent = window.eventsData.find(function (event) {
            return event.id == selectedEventId;
        });
        // Clear the dynamicFieldsContainer
        $("#dynamicFieldsContainer").empty();

        // Check if the selected event has the required fields
        if (selectedEvent) {
            for (var i = 1; i <= 6; i++) {
                var fieldKey = "field" + i;
                if (selectedEvent[fieldKey]) {
                    createDynamicFields(selectedEvent[fieldKey], i, selectedEventId);
                }
            }
        }
    }

    function decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }
    function checkMember() {
        var t = $(this);
        var val = t.val();

        var registrationType = $(".registration-account-type", step1);
        var participantNotFound = $(".registration-participant-not-found", step1);
        var url = "/action/pmiAccount";
        url += "?pmiNumberRegistration=" + val;

        ajax(url, function (response) {
            try {
                var json = JSON.parse(response.trim());

                if (json.firstName) {
                    fname.val(decodeHtml(json.firstName));
                }
                fname.removeClass("error").removeClass("disabled");
                if (json.lastName) {
                    lname.val(decodeHtml(json.lastName));
                }
                lname.removeClass("error").removeClass("disabled");
                if (json.email) {
                    email.val(decodeHtml(json.email));
                }
                email.removeClass("error");

                registrationType.addClass("hide");
                participantNotFound.addClass("hide");
                participantNotFound.find("input").attr("checked", false);

                if (json.expired === 'true') {
                    registrationType.filter(".expired").removeClass("hide");
                } else if (json.member === 'true') {
                    registrationType.filter(".member").removeClass("hide");
                } else if (json.student === 'true') {
                    registrationType.filter(".student").removeClass("hide");
                } else if (json.member === 'false') {
                    registrationType.filter(".non-member").removeClass("hide");
                } else {
                    registrationType.filter(".guest").removeClass("hide");
                    registrationType.filter(".non-valid").removeClass("hide");
                    participantNotFound.removeClass("hide");
                }
            } catch (e) {
                registrationType.addClass("hide");
                registrationType.filter(".guest").removeClass("hide");
                if (val !== '') {
                    registrationType.filter(".non-valid").removeClass("hide");
                }
                participantNotFound.removeClass("hide");
                fname.val("");
                lname.val("");
                email.val("");
            }
        }, true);
    }
    function checkMemberType(memberId) {
        var registrationType = $(".registration-account-type", step1);
        var participantNotFound = $(".registration-participant-not-found", step1);

        var url = "/action/pmiAccount";
        url += "?pmiNumberRegistration=" + memberId;
        ajax(url, function (response) {
            try {
                registrationType.addClass("hide");
                participantNotFound.addClass("hide");
                participantNotFound.find("input").attr("checked", false);
                var json = JSON.parse(response.trim());
                if (json.expired === 'true') {
                    registrationType.filter(".expired").removeClass("hide");
                } else if (json.member === 'true') {
                    registrationType.filter(".member").removeClass("hide");
                } else if (json.student === 'true') {
                    registrationType.filter(".student").removeClass("hide");
                } else if (json.member === 'false') {
                    registrationType.filter(".non-member").removeClass("hide");
                } else {
                    registrationType.filter(".guest").removeClass("hide");
                    registrationType.filter(".non-valid").removeClass("hide");
                    participantNotFound.removeClass("hide");
                }
            } catch (e) {
                registrationType.addClass("hide");
                registrationType.filter(".guest").removeClass("hide");
                if (memberId !== '') {
                    registrationType.filter(".non-valid").removeClass("hide");
                }
                participantNotFound.removeClass("hide");
                fname.val("");
                lname.val("");
                email.val("");
            }
        }, true);
    }

    function toggleEmail() {
        var t = $(this);
        var checked = t.is(":checked");

        var emailField = $(".registration-send-email-field", step1);

        if (checked) {
            emailField.removeClass("hide");
            emailField.find("input").addClass("required");
        } else {
            emailField.addClass("hide");
            emailField.find("input").removeClass("required");
        }
    }

    function toggleEmailCreateAccount() {
        var t = $(this);
        var checked = t.is(":checked");

        var emailField = $(".registration-create-account-field", step1);
        if (checked) {
            emailField.removeClass("hide");
            emailField.find("input").addClass("required");
        } else {
            emailField.addClass("hide");
            emailField.find("input").removeClass("required");
        }
    }

    function submitForm() {
        var btn = $(this);
        var form = btn.closest('form');

        if (form.find('.esmp-input').length > 0) {
            compileMetaDataForStep1(form);
        }
        btn.addClass("disabled");
        formValidator.validateForm(form);
        if (!form.hasClass('has-error')) {
            form.submit();
        } else {
            btn.removeClass("disabled");
        }
    }

    function backForm(e) {
        e.preventDefault();
        e.stopPropagation();
        var btn = $(this);
        btn.addClass("disabled");
        var form = $(".back-step-form");
        form.submit();
    }

    function fetchPastEvents(e, th) {
        var t = th !== undefined ? th : $(this);
        var futur = t.attr("data-futur") === 'true';
        var eId = t.attr("data-extra");

        if (!futur) {
            eventSessionSelector.parent().addClass("hide");
            eventSessionSelector.attr("name", "eventId-temp");
            eventPastSessionSelector.parent().removeClass("hide");
            eventPastSessionSelector.attr("name", "eventId");
            if (eventSessionSelector.hasClass("required")) {
                eventSessionSelector.removeClass("required");
                eventPastSessionSelector.addClass("required");
            }
            fetchPastEventsBtn.addClass("hide");
            fetchFuturEventsBtn.removeClass("hide");

            if (!eventPastSessionSelector.hasClass("unloaded")) {
                ajax("/action/pmiAjaxGetEvent?past=true", function (response) {
                    try {
                        var json = JSON.parse(response.trim());
                        window.eventsData = json;
                        for (var j in json) {
                            var event = json[j];
                            var option = $("<option value='" + event.id + "'>" + event.name + " - " + event.timeStart + "</option>");
                            if (eId !== undefined && eId !== '' && event.id === parseInt(eId)) {
                                option.attr("selected", "true");
                            }
                            eventPastSessionSelector.append(option);
                        }
                        eventPastSessionSelector.addClass("unloaded");
                    } catch (e) {
                        console.error(e);
                    }
                }, true);
            }
        } else {
            eventSessionSelector.parent().removeClass("hide");
            eventSessionSelector.attr("name", "eventId");
            eventPastSessionSelector.parent().addClass("hide");
            eventPastSessionSelector.attr("name", "eventId-temp");
            if (eventPastSessionSelector.hasClass("required")) {
                eventSessionSelector.addClass("required");
                eventPastSessionSelector.removeClass("required");
            }
            fetchPastEventsBtn.removeClass("hide");
            fetchFuturEventsBtn.addClass("hide");
            ajax("/action/pmiAjaxGetEvent?future=true", function (response) {
                try {
                    var json = JSON.parse(response.trim());
                    window.eventsData = json;
                    for (var j in json) {
                        var event = json[j];
                        var option = $("<option value='" + event.id + "'>" + event.name + " - " + event.timeStart + "</option>");
                        if (eId !== undefined && eId !== '' && event.id === parseInt(eId)) {
                            option.attr("selected", "true");
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            }, true);
        }
    }

    function toggleCash() {
        var t = $(this);
        var ctn = t.closest('.toggle-outer-ctn');
        var el = ctn.find('.element-to-toggle'); //Card fields

        el.slideUp();
        el.find('.required').removeClass('required').addClass('derequired');
    }

    function visibleToggle() {
        var t = $(this);
        var ctn = t.closest('.toggle-outer-ctn');
        var el = ctn.find('.element-to-toggle');

        el.addClass("hide");
        var index = ctn.find(".toggle-trigger-element").index(this);
        $(el.get(index)).slideDown();

        setTimeout(function () {
            el.css("visibility", "visible");
        }, 1000);
    }

    function createDynamicFields(data, key, eventId) {
        var values = data.split("_!_")[0];
        var required = data.split("_!_")[1] === "true";
        var type = data.split("_!_")[2];

        var container = $("#dynamicFieldsContainer");

        var lblCls = "esmap-label" + key;
        var labelSuffix = "register-event-metadata" + key + "." + eventId;
        var labelKey = "page.form.input." + labelSuffix;

        // Fetch the label using AJAX
        ajax('/action/getLabel?key=' + labelKey + "&site", function (response) {

            var labelText = response.trim();
            var visibleLabelElem = $("<label>", {
                for: "metaData_part" + key,
                text: !labelText ? labelText : "",
                class: "form-input-label"
            });

            // Now, continue with the rest of the input creation logic
            switch (type) {
                case "text":
                    var inputElem = $("<input>", {
                        type: "text",
                        name: "metaData_part" + key,
                        class: "form-input esmp-input",
                        placeholder: !labelText ? labelText : ""
                    });
                    if (required) {
                        inputElem.attr("required", true);
                    }
                    inputElem.attr("data-extra", "." + lblCls);
                    container.append(inputElem);
                    break;

                case "checkbox":
                case "radio":
                    var choices = values.split(";");
                    var divElem = $("<div>", {
                        class: "input-ctn full event-signup-metadata-part"
                    });
                    choices.forEach(function (choice) {
                        var inputElem = $("<input>", {
                            type: type,
                            name: "metaData_part" + key,
                            value: choice,
                            class: "esmp-input"
                        });
                        if (required) {
                            inputElem.addClass("min-one-checked");
                        }
                        var labelElem = $("<label>").text(choice).prepend(inputElem);
                        divElem.append(labelElem);
                    });
                    container.append(divElem);
                    break;

                case "select":
                    var selectElem = $("<select>", {
                        name: "metaData_part" + key,
                        class: "form-select form-input esmp-input"
                    });
                    var placeholderOption = $("<option>", {
                        value: "",
                        text: !labelText ? labelText : "",
                        disabled: true,
                        selected: true
                    });
                    selectElem.append(placeholderOption);
                    var defaultOption = $("<option>", {
                        value: "",
                        text: ""
                    });
                    selectElem.append(defaultOption);

                    var choices = values.split(";");
                    choices.forEach(function (choice) {
                        var optionElem = $("<option>", {
                            value: choice
                        }).text(choice);
                        selectElem.append(optionElem);
                    });
                    if (required) {
                        selectElem.attr("required", true);
                    }
                    selectElem.attr("data-extra", "." + lblCls);
                    container.append(selectElem);
                    break;

                default:
                    console.error("Unsupported type: " + type);

            }
            container.append(visibleLabelElem);
        });
    }

    function compileMetaDataForStep1($form) {
        var $parts = $form.find('.admin-registration-metadata-par');
        if ($parts.length) {
            var v = '';

            $parts.each(function (i, el) {
                var input = $(el).find('.esmp-input')[0];
                var labelEl = $form.find(input.getAttribute('data-extra'))[0];
                var line = '';

                if (input && input.value.trim() !== '') {
                    // Append the meta label
                    if (labelEl && labelEl.value.trim() !== '') {
                        line += labelEl.value.trim();
                        if (!line.match(': ')) {
                            line += ' = ';
                        }
                    }
                    // Append the meta value
                    line += input.value.trim();
                }
                // Append the meta line to the main value
                if (line !== '') {
                    v += (v !== '' ? '; \n' : '') + line;
                }
            });
            if ($('input[name="metaData"]').length != 0) {
                $('input[name="metaData"]').val(v);
            } else {
                $form.append('<input type="hidden" name="metaData" value="' + v.replace(/"/g, "&quot;") + '"/>');
            }
        }
    }

    function init(e) {
        ajax("/action/pmiAjaxGetEvent?future=true", function (response) {
            try {
                var json = JSON.parse(response.trim());
                window.eventsData = json;
            } catch (e) {
                console.error(e);
            }
        }, true);
        if ($(".registration-event-selector").length) {
            // Only 1 instance per document is allowed
            // These elements are also used in page/manage-newsletter.js
            fetchPastEventsBtn = $(".registration-event-selector .select-past-event");
            fetchFuturEventsBtn = $(".registration-event-selector .select-futur-event");
            eventSessionSelector = $(".registration-event-select");
            eventPastSessionSelector = $(".registration-event-select-past");
            if (eventPastSessionSelector !== undefined && eventPastSessionSelector.attr("data-extra") !== undefined && eventPastSessionSelector.attr("data-extra") !== '') {
                fetchPastEvents(e, eventPastSessionSelector);
            }
            eventSessionSelector.on("change", saveEventInSession);
            fetchPastEventsBtn.on("click", fetchPastEvents);
            fetchFuturEventsBtn.on("click", fetchPastEvents);
        }

        //INIT STOP
        if (!d.querySelector(".admin-page.registration-zone")) return;

        formValidator = Fw.component.models().form;
        tools = Fw.component.models().tools;
        step1 = $(".registration-step1");
        number = $(".registration-number", step1);
        fname = $(".registration-fname", step1);
        lname = $(".registration-lname", step1);
        email = $(".registration-email", step1);
        sendEmail = $(".registration-send-email", step1);
        participantNotFoundCheck = $(".registration-create-account", step1);
        participantsInfos = $(".participant-infos", step1);

        step2 = $(".registration-step2");
        step3 = $(".registration-step3");
        step4 = $(".registration-step4");

        submitStep = $(".registration-submit-step");
        submitLastStep = $(".registration-submit-last-step");
        backStep = $(".registration-back-step");

        number.on("change", checkMember);
        sendEmail.on("click", toggleEmail);
        participantNotFoundCheck.on("click", toggleEmailCreateAccount);

        submitStep.on("click", submitForm);
        backStep.on("click", backForm);

        if (participantsInfos !== undefined && participantsInfos.attr("data-memberId") !== undefined && participantsInfos.attr("data-memberId") !== '') {
            checkMemberType(participantsInfos.attr("data-memberId"));
        }

        cashToggleBtn = $(".toggle-trigger-element-cash");
        cashToggleBtn.on("click", toggleCash);
        triggeredBtn = $(".toggle-trigger-element", step3);
        triggeredBtn.on("click", visibleToggle);
    }

    $(g).ready(init);
})(jQuery, document, window);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {

    'use strict';

    var formValidator;
    var tools;
    var utilPopupOpenPopup;
    var utilPopupClosePopup;
    var datepicker;
    var promoTypeSelect;
    var updateCCInfosBtn;
    var jobImgBtn;
    var attendedEventCheckbox;
    var allAttendedEventCheckbox;
    var applyCreditPopupBtn;
    var applyCreditConfirmBtn;
    var resendJobInvoiceBtn;
    var formatLocationFields;
    var futureEventSelector;

    var mouseIsDown = false;
    var resizeData = {};

    var initDatepickers = function initDatepickers() {
        datepicker.each(function () {
            var options;
            var t = $(this);
            var val = t.data('date');
            var name = t.attr('name');
            var lang = t.data('lang');
            var format = t.data('date-format');
            var noPast = t.data('beatpicker-disable');
            var disableD = t.data('disable-day');
            var disableM = t.data('disable-month');
            var disableY = t.data('disable-year');

            if (typeof noPast !== "undefined") {
                options = {
                    dateInputNode: t,
                    dateFormat: {
                        separator: '/',
                        format: format ? format.split(',') : []
                    },
                    modules: {
                        gotoDate: false,
                        today: false,
                        clear: false,
                        icon: false
                    },
                    disablingRules: [{ from: [parseInt(disableY), parseInt(disableM), parseInt(disableD)], to: '<' }]
                };
            } else {
                options = {
                    dateInputNode: t,
                    dateFormat: {
                        separator: '/',
                        format: format ? format.split(',') : []
                    },
                    modules: {
                        gotoDate: false,
                        today: false,
                        clear: false,
                        icon: false
                    }
                };
            }

            if (lang === 'fr') {
                options.daysSimple = ["D", "L", "M", "M", "J", "V", "S"];
                options.daysFull = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
                options.monthsSimple = ["Jan", "Fév", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"];
                options.monthsFull = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
            } else if (lang === 'en') {
                options.daysSimple = ["S", "M", "T", "W", "T", "F", "S"];
            }

            var beatpicker = new BeatPicker(options);
            var inputCtn = t.parents('.input-ctn');
            var pickerWrap = t.parents('.datetime-wrap');
            var resetter = pickerWrap.find('.datepicker-reset');
            if (val !== '') {
                beatpicker.selectDate(val);
                beatpicker.setDate(val);
                resetter.parent().removeClass('hide');
            } else {
                beatpicker.setDate(new Date());
            }
            t.parent().before(t);
            t.parent().find('.input-parent').remove();

            beatpicker.on('select', function (data, a, b) {
                formValidator.validateField(t);
                $('input[name="' + name + 'Day"]', inputCtn).val(data.dateObj.getDate());
                $('input[name="' + name + 'Month"]', inputCtn).val(data.dateObj.getMonth());
                $('input[name="' + name + 'Year"]', inputCtn).val(data.dateObj.getFullYear());
                resetter.parent().removeClass('hide');
            });
            resetter.on('click', function () {
                beatpicker.reset();
                $('input[name="' + name + 'Day"]', inputCtn).val('');
                $('input[name="' + name + 'Month"]', inputCtn).val('');
                $('input[name="' + name + 'Year"]', inputCtn).val('');
                $('.form-input[name="' + name + 'Hour"]', pickerWrap).val('');
                $('.form-input[name="' + name + 'Minute"]', pickerWrap).val('');
                resetter.parent().addClass('hide');
            });
        });
    };

    var checkPromoType = function checkPromoType() {
        var t = $(this);
        var form = t.closest('form');
        var v = t.val();

        if (v !== '0' && v !== '') {
            form.find('.input-ctn.value-input-ctn').removeClass('hidden').find('.form-input').addClass('required');
        } else {
            form.find('.input-ctn.value-input-ctn').addClass('hidden').find('.form-input').removeClass('required');
        }
        if (v === '1' || v === '3') {
            form.find('.value2-input-ctn').removeClass('hidden');
        } else {
            form.find('.value2-input-ctn').addClass('hidden');
        }
        //Added for group
        if (v === '7') {
            form.find('.input-ctn.value-input-ctn-group').removeClass('hidden').find('.form-input').addClass('required');
        } else {
            form.find('.input-ctn.value-input-ctn-group').addClass('hidden').find('.form-input').removeClass('required');
        }
    };

    var updateCCInfos = function updateCCInfos() {
        var btn = $(this);
        var form = btn.closest('form');
        var ccError = form.find('.js-form-error-message.cc-error');
        var error = form.find('.js-form-error-message.error-occured');

        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            btn.addClass('disabled');

            var url = '/action/pmiUpdatePayment';

            url += '?id=' + form.find('input[name=id]').val();
            url += '&ccCard=' + encodeURIComponent(form.find('input[name=ccCard]').val());
            url += '&expMM=' + form.find('select[name=expMM]').val();
            url += '&expYY=' + form.find('select[name=expYY]').val();
            url += '&cvv=' + encodeURIComponent(form.find('input[name=cvv]').val());

            if (form.find('input[name=sendInvoice]').prop('checked')) {
                url += '&sendInvoice=true';
            }

            var obj = ajax(url, function (response) {
                if (response.indexOf('success') !== -1) {
                    ccError.slideUp();
                    error.slideUp();
                    window.location.reload();
                } else if (response.indexOf('Unable to process payment') !== -1) {
                    error.slideDown();
                    ccError.slideUp();
                    btn.removeClass('disabled');
                } else {
                    ccError.slideDown();
                    error.slideUp();
                    btn.removeClass('disabled');
                }
            }, true);
        }
    };

    var updateJobImgChoice = function updateJobImgChoice() {
        var t = $(this);
        var input = t.closest('.create-job-image-ctn').find('input[name^=field0]');
        // var input = t.closest('.create-job-image-ctn').find('input[name=field1]');
        var popup = t.closest('.file-preview-picker-popup');
        var itemSelected = $('.file-preview-picker-item:not(.folder).selected', popup);
        var fileUrl = itemSelected.attr('data-file-url');
        var value = itemSelected.attr('data-value');
        var fullPathValue = fileUrl + '/' + value;

        input.val(fullPathValue);
    };

    var participantRefunded = function participantRefunded() {
        var url = '/action/pmiSignupRefunded';
        url += '?id=' + $(this).val();
        url += '&refunded=' + $(this).prop('checked');

        ajax(url, function (response) {}, true);
    };

    var pmiAttended = function pmiAttended() {
        var id = $(this).val();
        var checked = $(this).prop('checked');

        var url = '/action/pmiAttended';
        url += '?id=' + id;
        url += '&attended=' + checked;

        ajax(url, function (response) {}, true);
    };

    var pmiAllAttended = function pmiAllAttended() {
        var t = $(this);
        var checked = t.prop('checked');
        var table = t.closest('table');

        table.find(attendedEventCheckbox).each(function () {
            if ($(this).prop('checked') !== checked) {
                $(this).trigger('click');
            }
        });
    };

    var applyCreditValidate = function applyCreditValidate() {
        var form = $(this).closest('.js-form');

        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            form.find('.open-popup-btn').trigger('click');
        }
    };

    var applyCredit = function applyCredit() {
        var btn = $(this);
        var form = btn.closest('.js-form');
        var input = form.find('input[name=credit]');

        btn.addClass('disabled');

        var url = '/action/pmiAttended';
        url += '?id=' + form.attr('data-id');
        url += '&credit=' + input.val();

        var obj = ajax(url, function (response) {
            btn.removeClass('disabled');

            if (response.indexOf('success') !== -1) {
                btn.closest('.popup').find('.close-popup-btn').trigger('click');
                input.val('').removeClass('error').removeClass('success').removeClass('has-value');
                $('.success-msg.credit').slideDown();

                setTimeout(function () {
                    $('.success-msg.credit').slideUp(function () {});
                }, 5000);
            }
        }, true);
    };

    var resendJobInvoice = function resendJobInvoice() {
        var btn = $(this);
        var form = btn.closest('form');
        var input = form.find('input[name=paymentId]');

        var url = '/action/shopResendPaymentEmail?jobEmail=true';
        url += '&id=' + input.val();

        var obj = ajax(url, function (response) {
            if (response.indexOf('success') !== -1) {
                input.val('').removeClass('error').removeClass('success').removeClass('has-value');
                $('.success-msg.resend-job-email').slideDown();

                setTimeout(function () {
                    $('.success-msg.resend-job-email').slideUp();
                }, 5000);
            }
        }, true);
    };

    var copyUrlToClipboard = function copyUrlToClipboard() {
        var id = $(this).attr('data-id');
        var copyText = document.getElementById(id);
        var popup = $('.popup-outer[data-id="pmi-event-url-copied"]');

        copyText.select();
        document.execCommand('copy');
        popup.find('.copied-url').html(copyText.value);
        popup.addClass('open');

        setTimeout(function () {
            popup.removeClass('open');
        }, 1500);
    };

    var formatLocation = function formatLocation() {
        var json = {};
        formatLocationFields.each(function () {
            var t = $(this);
            json[t.attr("name")] = t.val();
        });
        $(".final-location").val(JSON.stringify(json));

        setTimeout(formatLocation, 1000);
    };

    var previewLocationImage = function previewLocationImage() {
        if (!$('.location-image-preview')[0]) {
            return false;
        }

        $('.location-image-preview').each(function (i) {
            var newSrc = $('.location-field-img-picker input')[i].value || "";
            var curSrc = this.getAttribute('data-src') || "";

            if (newSrc !== curSrc) {
                this.innerHTML = '<img src="' + newSrc + '" alt=""/>';
                this.setAttribute('data-src', newSrc);
            }
        });

        setTimeout(previewLocationImage, 1000);
    };

    var loadPromoEvents = function loadPromoEvents() {
        var select = $('.promocode-event-select');
        var eId = select.attr('data-extra');
        var url = '/action/pmiEvent';

        var _getEvents = function _getEvents(extraParam, groupName, callback) {
            ajax(url + extraParam, function (response) {
                try {
                    var json = JSON.parse(response.trim());
                    if (json.length > 0) {
                        var builder = '';
                        builder += '<optgroup label="' + groupName + '">';
                        for (var i in json) {
                            var event = json[i];
                            var option = '<option value="' + event.id + '"';

                            if (eId !== undefined && eId !== '' && event.id == eId) {
                                option += ' selected=""';
                            }
                            option += '>' + event.name + ' - ' + event.timeStart + '</option>';
                            builder += option;
                        }
                        builder += '</optgroup>';
                        select.append(builder);
                    }
                } catch (e) {
                    console.log('error: ' + e);
                }
                if (typeof callback === "function") {
                    callback();
                }
            }, true);
        };

        _getEvents('?getFutureEvents=true', select.attr('data-future'), function () {
            _getEvents('?getPastEvents=true', select.attr('data-past'));
        });
    };

    var loadPromoProducts = function loadPromoProducts() {
        var select = $('.promocode-product-select');
        var id = select.attr('data-extra');

        ajax('/action/shopJSONProducts?json=true', function (response) {
            try {
                var json = JSON.parse(response.trim());
                if (json.length > 0) {
                    var builder = '';
                    for (var i in json) {
                        var obj = json[i];
                        var option = '<option value="' + obj.id + '"';

                        if (id !== undefined && id !== '' && obj.id == id) {
                            option += ' selected=""';
                        }
                        option += '>' + obj.name + '</option>';
                        builder += option;
                    }
                    select.append(builder);
                }
            } catch (e) {
                console.log('error: ' + e);
            }
        }, true);
    };

    var sortByQuery = function sortByQuery(e) {
        var it = e.currentTarget || this;
        var prefix = $(it).closest(".sortquery").attr("data-param-prefix");
        var q = setQuery(prefix ? prefix + "SortBy" : "sortBy", it.getAttribute("data-sort-by"));
        q = setQuery(prefix ? prefix + "SortOrder" : "sortOrder", it.getAttribute("data-sort-order"), q);
        window.location.search = "?" + q;
    };

    var validateEventForm = function validateEventForm(e) {
        var it = e.currentTarget || this;
        var $form = $(it).closest('form');

        // Process extra fields
        $form.find('.multichoice-field').each(function (i, el) {
            if (el.checked) {
                var $ctn = $(document).find('[data-toggle-id="' + $(el).attr('data-toggle-id') + '"]');
                var values = $ctn.find('[name="' + el.name + 'Values"]').val() || "";
                var require = $ctn.find('[name="' + el.name + 'Required"]').val();
                var type = $ctn.find('[name="' + el.name + 'Type"]').val();

                if (values.replace(/ ;/g, '') !== '' || type === 'text') {
                    // Format the values before saving
                    var vA = values.split(';');
                    var vB = [];

                    Array.prototype.forEach.call(vA, function (v) {
                        if (v.trim() !== '') {
                            vB.push(v.trim());
                        }
                    });
                    // The values must be saved in this order: values_!_required_!_type
                    el.value = vB.join(';') + '_!_' + require + '_!_' + type;
                } else {
                    // The values field is empty or invalid
                    el.value = '';
                }
            } else {
                // The field is not active, the data then gets erased
                el.value = '';
            }
        });

        // Process adding guests option
        var field2 = $form.find('[name=field2]');
        if (field2.prop('checked')) {
            field2.val($form.find('[name=field2x]').val());
        }

        // Process extra pricing (aka price options)
        $form.find('.event-price-option').each(function (i, el) {
            // Deleting an option will make associated prices deleted so modification does not matter
            if (!$(el).hasClass('deleting')) {
                var s = [];
                $('.event-price-input', el).each(function (i, inp) {
                    // Having an id means the price is modified. Otherwise, in create mode, only create the price with a valid value
                    if (inp.value && $(inp).hasClass('success') || inp.id) {
                        var k = inp.getAttribute('data-extra') || '';
                        var id = inp.id || '';
                        // Empty value sets the price to be deleted in the backend
                        s.push(id.replace(/[\D_-]/g, '') + ':' + k + ':' + inp.value);
                    }
                });
                $('input[name^=priceIdsKeysValues]', el).val(s.join(';'));
            }
        });

        //Process add extra pricing (aka add price based on Options)
        $form.find('.event-add-price-option').each(function (i, el) {
            // Deleting an option will make associated prices deleted so modification does not matter
            if (!$(el).hasClass('deleting')) {
                var s = [];
                $('.event-add-price-input', el).each(function (i, inp) {
                    // Having an id means the price is modified. Otherwise, in create mode, only create the price with a valid value
                    if (inp.value && $(inp).hasClass('success') || inp.id) {
                        var k = inp.getAttribute('data-extra') || '';
                        var id = inp.id || '';
                        // Empty value sets the price to be deleted in the backend
                        s.push(id.replace(/[\D_-]/g, '') + ':' + k + ':' + inp.value);
                    }
                });
                $('input[name^=priceAddIdsKeysValues]', el).val(s.join(';'));
            }
        });

        // Validation
        try {
            var startDate = new Date($('[name=timeStartYear]').val() + '-' + (parseInt($('[name=timeStartMonth]').val()) + 1) + '-' + $('[name=timeStartDay]').val() + ' ' + $('[name=timeStartHour]').val() + ':' + $('[name=timeStartMinute]').val() + ':00');
            var endDate = new Date($('[name=timeEndYear]').val() + '-' + (parseInt($('[name=timeEndMonth]').val()) + 1) + '-' + $('[name=timeEndDay]').val() + ' ' + $('[name=timeEndHour]').val() + ':' + $('[name=timeEndMinute]').val() + ':00');
            if (startDate.getTime() > endDate.getTime()) {
                throw 'Bad time';
            }
            // Passed, event end time is after start time
            $('.event-date-error').slideUp(300);
            // Validate normal fields and submit the form
            tools.validateForm.call(it, []);
        } catch (err) {
            $('.event-date-error').slideDown(300);
        }
    };

    var validateEmailListForm = function validateEmailListForm(e) {
        var it = e.currentTarget || this;
        var emailListEl = $('[name=emailList]');
        var regex = /^(\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]{2,4}\s*?,?\s*?)+$/;
        var currentDateTime = new Date();
        var validEmailList = true;

        if (emailListEl.hasClass('required')) {
            var emails = $('[name=emailList]').val().replace(/\s/g, '').split(",");
            for (var i = 0; i < emails.length; i++) {
                if (emails[i] == "" || !regex.test(emails[i])) {
                    $('.event-email-list-error').slideDown(300);
                    validEmailList = false;
                }
            }
        }
        if (validEmailList) {
            $('.event-email-list-error').slideUp(300);
            if (currentDateTime.getFullYear() < $('[name=scheduledTimeYear]').val()) {
                // Validate normal fields and submit the form
                tools.validateForm.call(it, []);
                $('.event-email-list-date-error').slideUp(300);
            } else if (currentDateTime.getFullYear() == $('[name=scheduledTimeYear]').val() && currentDateTime.getMonth() < $('[name=scheduledTimeMonth]').val()) {
                // Validate normal fields and submit the form
                tools.validateForm.call(it, []);
                $('.event-email-list-date-error').slideUp(300);
            } else if (currentDateTime.getMonth() == $('[name=scheduledTimeMonth]').val() && currentDateTime.getDay() < $('[name=scheduledTimeDay]').val()) {
                // Validate normal fields and submit the form
                tools.validateForm.call(it, []);
                $('.event-email-list-date-error').slideUp(300);
            } else if (currentDateTime.getDay() == $('[name=scheduledTimeDay]').val() && currentDateTime.getHours() < parseInt($('[name=scheduledTimeHour]').val())) {
                tools.validateForm.call(it, []);
                $('.event-email-list-date-error').slideUp(300);
            } else {
                $('.event-email-list-date-error').slideDown(300);
            }
        }
    };

    var imagePickerSlickSliderInit = function imagePickerSlickSliderInit(event, slick, currentSlide) {
        var slides = slick.$slides;
        slides = $(slides).filter('.calendar-home-event-infos-ver2 .slick-active');
        if (slides.length > 0 && slides.width() !== 0) {
            var dataid;
            var imagePicker = $(slides).find('.background-picker-settings-ctn');
            if (imagePicker.length > 0) {
                dataid = $(imagePicker).attr("data-imageid");
                if ($('.calendar-image-picker .background-picker-settings-ctn[data-imageid="' + dataid + '"]').length > 0) {
                    $(imagePicker).detach();
                } else {
                    $(imagePicker).detach().appendTo(".calendar-image-picker");
                    var ev = $._data($('div > .picker-popup-button', $(imagePicker)), 'events');
                    if (!ev || !ev.click) {
                        initTools(imagePicker);
                    }
                }
            } else {
                var image = $(slides).find('.img');
                if (image.length > 0) {
                    dataid = $(image).attr("data-id");
                }
            }
            if (dataid !== undefined) {
                if (!$('.calendar-image-picker .background-picker-settings-ctn .picker-popup').is(":visible")) {
                    var current = $('.calendar-image-picker .background-picker-settings-ctn[data-imageid="' + dataid + '"]').show();
                    $('.calendar-image-picker .background-picker-settings-ctn').not(current).hide();
                }
            }
        }
    };

    var addEventPdu = function addEventPdu(e) {
        var t = $(this);
        var innerCtn = t.closest('.pdu-ctn').find('.pdu-ctn-inner');
        var inputs = $('.pdu-inputs-ctn')[0];
        var clone = $(inputs).clone(true);

        innerCtn.append(clone);
        $('.form-input', clone).val('').removeClass('has-value success error');
    };

    function fetchEvents(e, th) {
        var t = th !== undefined ? th : $(this);
        var eId = t.attr("data-extra");

        if (!futureEventSelector.hasClass("unloaded")) {
            ajax("/action/pmiAjaxGetEvent?future=true", function (response) {
                try {
                    var json = JSON.parse(response.trim());
                    for (var j in json) {
                        var event = json[j];
                        var option = $("<option value='" + event.id + "'>" + event.name + " - " + event.timeStart + "</option>");
                        if (eId !== undefined && eId !== '' && event.id === parseInt(eId)) {
                            option.attr("selected", "true");
                        }
                        futureEventSelector.append(option);
                    }
                    futureEventSelector.addClass("unloaded");
                } catch (e) {
                    console.error(e);
                }
            }, true);
        }
    }

    var editExpense = function editExpense(e) {
        if (e) e.preventDefault();

        var form = document.getElementById(this.getAttribute("data-form")),
            inputs = form.elements,
            data = $(this).closest("tr").data(),
            name;

        $.each(inputs, function (i, el) {
            if (!el.hasAttribute("ignore")) {
                name = el.name.toLowerCase();
                if (el.type === "checkbox" || el.type === "radio") {
                    el.checked = data.hasOwnProperty(name) && data[name] === el.value;
                } else {
                    el.value = data.hasOwnProperty(name) ? data[name] : "";
                }
                if (el.type === "file") {
                    var $label = $(el).closest(".form-input-upload-input-label");
                    $label.find(".form-input-upload-input-label-value").text($label.attr("data-default-value"));
                }
            }
        });

        $(form).addClass("editing").slideDown(400);
        $('html, body').animate({
            scrollTop: $(form).offset().top
        }, 300);
    };

    var resetExpenseForm = function resetExpenseForm(e) {
        var form = $('#event-expense-form');
        if (form.hasClass('editing')) {
            e.stopImmediatePropagation();
            form[0].reset();
            form.find('input[name="id"]').val('');
            form.find('.form-input-upload-input-label').each(function () {
                $(this).find('.form-input-upload-input-label-value').text($(this).attr('data-default-value'));
            });
            form.removeClass('editing');
        }
    };

    var resetEmailListForm = function resetEmailListForm(e) {
        var form = $('#event-email-list-form');
        if (form.hasClass('editing')) {
            e.stopImmediatePropagation();
            form[0].reset();
            form.find('input[name="id"]').val('');
            form.find('.form-input-upload-input-label').each(function () {
                $(this).find('.form-input-upload-input-label-value').text($(this).attr('data-default-value'));
            });
            form.removeClass('editing');
            form.find('.element-to-toggle[data-toggle-id="emailList"]').slideDown();
        }
    };

    var editEmailList = function editEmailList(e) {
        if (e) e.preventDefault();

        var form = document.getElementById(this.getAttribute("data-form")),
            inputs = form.elements,
            data = $(this).closest("tr").data(),
            name;

        $.each(inputs, function (i, el) {
            if (!el.hasAttribute("ignore")) {
                name = el.name.toLowerCase();
                if (name === "type") {
                    if (data.emaillist === "participants") {
                        if (el.value === "reminder") {
                            el.checked = true;
                            $(el).triggerHandler("click");
                        } else {
                            el.checked = false;
                        }
                    } else {
                        if (el.value === "list") {
                            el.checked = true;
                            $(el).triggerHandler("click");
                        } else {
                            el.checked = false;
                        }
                    }
                    //$(el).triggerHandler("change");
                } else if (name === "emaillist") {
                    el.value = data.emaillist !== "participants" ? data[name] : "";
                } else if (el.type === "checkbox" || el.type === "radio") {
                    el.checked = data.hasOwnProperty(name) && data[name] === el.value;
                } else {
                    el.value = data.hasOwnProperty(name) ? data[name] : "";
                }
            }
        });

        $(form).addClass("editing").slideDown(400);
        $('html, body').animate({
            scrollTop: $(form).offset().top - $('.site-header').height()
        }, 300);
    };

    var eventTypeChange = function eventTypeChange(e) {
        // Remove "required" from price inputs if the event type is display only and price hidden
        var array = ['3', '4'];
        var it = e.currentTarget || this;
        var $form = $(it).closest('.create-event-form');

        if (array.indexOf($('.form-input[name=eventType]', $form).val()) > -1) {
            $('.form-input[name=maxParticipants], .form-input[name=priceAll], .form-input[name=priceMember]', $form).removeClass('required').siblings('.form-input-label').each(function () {
                this.textContent = this.textContent.replace(/\*$/, '');
            });
        } else {
            $('.form-input[name=maxParticipants], .form-input[name=priceAll], .form-input[name=priceMember]', $form).addClass('required').siblings('.form-input-label').each(function () {
                var label = this.textContent;
                if (!label.endsWith('*')) {
                    this.textContent = label + '*';
                }
            });
        }
    };

    function initFormBuilder() {
        var formEditor = $('.admin-forms-editor-fields');
        var formId = getQuery("formId");

        // Verify page
        if (!formEditor[0]) {
            return false;
        }
        // Fix sortable elements getting wrong offset while being dragged.
        // We need to set overflow:auto to the main container, and then change the overflow to initial why we start dragging an element.
        formEditor.css('overflow', 'auto');

        var fieldsetCtn = formEditor.find('.fieldsets');
        var fieldsetTemplate = formEditor.find('.fieldset.last')[0].outerHTML;
        var controlCtn = formEditor.find('.admin-forms-editor-fields-control');
        var fieldCount = 0;
        var currentEditFieldId = void 0;

        var toggleHighlightFieldset = function toggleHighlightFieldset(off, noAdd) {
            // Highlighter on the fieldset for better visualization and to fix the issue with off target dragging 'helper'
            if (off) {
                fieldsetCtn.find('.fieldset').removeClass('ui-droppable-active');
                formEditor.css('overflow', 'auto');
                controlCtn.css('overflow', '');
            } else {
                fieldsetCtn.find('.fieldset' + (noAdd ? ':not(.last)' : '')).addClass('ui-droppable-active');
                formEditor.css('overflow', 'initial');
                controlCtn.css('overflow', 'initial');
            }
        };

        var resizeFieldClickHandler = function resizeFieldClickHandler(e) {
            e.stopPropagation();
            mouseIsDown = true;
            var ctn = e.currentTarget.parentElement;
            resizeData = {
                target: ctn,
                startX: e.clientX,
                startWidth: ctn.clientWidth,
                parentWidth: ctn.parentElement.clientWidth - parseFloat($(ctn).css('margin-left')),
                fullWidth: $(ctn.parentElement).offset().left + ctn.parentElement.clientWidth
            };
            // Add resizing classes for styling
            $(resizeData.target).addClass('resizing');
            $('body').addClass('resizing-col');
        };

        var editFieldClickHandler = function editFieldClickHandler(e) {
            e.preventDefault();
            e.stopPropagation();
            utilPopupOpenPopup.call(this, e);

            var ctn = $(this).closest('.input-ctn, .form-checkbox-ctn');
            var inp = ctn.find('.form-input, .form-check-input, .form-input-upload-input');
            var lbl = ctn.find('.form-input-label, .form-check-input-value, .form-input-upload-input-label-value');

            currentEditFieldId = ctn.attr('id');
            $('.edit-field-name-input').val(inp.attr('name')).removeClass('error').attr('disabled', 'true').addClass('disabled');
            $('.edit-field-required-input').prop('checked', inp.hasClass('required'));
            $('.edit-field-mce-input').prop('checked', inp.hasClass('mce-enabled'));
            $('.edit-field-select-options-item:not(.new)').remove();
            $('.edit-field-select-options-item input').val('');

            if (!lbl[0]) {
                $('.edit-field-label-input').val(ctn.find('.text-content').text());
                $('.edit-field-name-input').parent().hide();
                $('.edit-field-required-input').parent().hide();
            } else {
                $('.edit-field-label-input').val(lbl.text());
                $('.edit-field-name-input').parent().show();
                $('.edit-field-required-input').parent().show();
            }

            if (inp.hasClass('textarea')) {
                $('.edit-field-mce-input').parent().show();
            } else {
                $('.edit-field-mce-input').parent().hide();
            }

            if (inp.hasClass('form-select')) {
                $('.edit-field-select-options').parent().show();
                var item = $('.edit-field-select-options-item.new');
                $('option:not(:empty)', inp).each(function () {
                    var clone = item.clone(true);
                    clone.insertBefore(item);
                    clone.removeClass('new').find('.add').remove();
                    clone.find('input').val(this.value);
                });
            } else {
                $('.edit-field-select-options').parent().hide();
            }

            if (inp.attr('type') === 'file') {
                $('.edit-field-accept-input').val(inp.attr('accept')).parent().show();
            } else {
                $('.edit-field-accept-input').parent().hide();
            }
        };

        // Inject data and build the fieldsets when editing an existing form
        // It should be done before initiating the event handlers
        if (formId) {
            var list = JSON.parse(fieldsetCtn.attr('data-array')) || [];
            var fieldElements = formEditor.find('.add-field-element');

            list.forEach(function (set) {
                var fieldset = fieldsetCtn.find('.fieldset.last');
                var ctn = fieldset.find('.inputs-ctn');

                fieldset.removeClass('last');
                // Clone "last" template
                fieldsetCtn.append(fieldsetTemplate);
                // Iterate field data
                set.fields.forEach(function (field) {
                    var el = fieldElements.filter('[data-ctn="' + field.type + '"]').clone(true);
                    // Append to inputs-ctn
                    ctn.append(el);
                    // Attributes and classes
                    el.removeClass('add-field-element').addClass(field.spanClass).attr('data-span', field.spanClass).attr('id', randomIdMix(6));
                    // Values and labels
                    if (el.hasClass('text-ctn')) {
                        el.find('.text-content').text(field.label);
                    } else {
                        var inp = el.find('.form-input, .form-check-input, .form-input-upload-input');
                        var lbl = el.find('.form-input-label, .form-check-input-value, .form-input-upload-input-label-value');
                        var isCheckbox = el.hasClass('form-checkbox-ctn');

                        if (field.required) {
                            inp.addClass('required');
                        }
                        // Set input name and value
                        inp.attr('name', field.name).attr('value', field.value);
                        // Set field label and required sign (*)
                        lbl.text(field.label);
                        // Set mce class for rich-text format
                        if (field.mceEnabled == true) {
                            inp.addClass('mce-enabled');
                        }
                        // Set select options
                        if (field.type === 'select' && field.items) {
                            inp.html('<option value=""></option>');
                            field.items.forEach(function (value) {
                                inp.append('<option value="' + value + '">' + value + '</option>');
                            });
                        }
                        // Set file input
                        if (field.type === 'upload' && field.accept) {
                            inp.attr('accept', field.accept);
                        }
                        // Resize button
                        el.append('<div class="resize-field-handle">||</div>').find('.resize-field-handle').on('mousedown', resizeFieldClickHandler);
                    }
                    // Edit button
                    el.append('<a class="edit-field-btn" data-id="edit-field-popup">' + makeSvgPencil() + '</a>').find('.edit-field-btn').on('mousedown', editFieldClickHandler);
                });
            });
        }

        // Initiate addable field draggable
        formEditor.find('.add-field-element').draggable({
            connectToSortable: '.fieldset>.inputs-ctn',
            opacity: 0.6,
            zIndex: 1,
            cursor: 'grabbing',
            helper: 'clone',
            revertDuration: 0,
            start: function start(event, ui) {
                // Set helper's width otherwise the width would be auto
                ui.helper.width(this.clientWidth);
                toggleHighlightFieldset();
            },
            stop: function stop(event, ui) {
                toggleHighlightFieldset(true);
            }
        });

        // Initiate fieldset elements sortable in the main container
        fieldsetCtn.sortable({
            cursor: 'move',
            handle: '.fieldset-sort-handle',
            items: '.fieldset:not(.last)',
            scroll: false,
            start: function start(event, ui) {
                toggleHighlightFieldset(false, true);
            },
            stop: function stop(event, ui) {
                toggleHighlightFieldset(true);
            }
        });

        // Initiate input fields sortable inside fieldset
        var sortableOption = {
            cursor: 'move',
            connectWith: '.inputs-ctn',
            scroll: false,
            activate: function activate(event, ui) {
                if (ui.sender) {
                    // Display remove zone when the dragged item is not "add-field-element"
                    formEditor.find('.remove-field-bin').addClass('ui-droppable-active');
                }
            },
            start: function start(event, ui) {
                toggleHighlightFieldset();
            },
            stop: function stop(event, ui) {
                toggleHighlightFieldset(true);
                formEditor.find('.remove-field-bin').removeClass('ui-droppable-active');
            },
            over: function over(event, ui) {
                $(this).parent().addClass('ui-sortable-hover');
            },
            out: function out(event, ui) {
                $(this).parent().removeClass('ui-sortable-hover');
            },
            change: function change(event, ui) {
                if (ui.placeholder && ui.placeholder.hasClass('text-ctn')) {
                    ui.placeholder.width(ui.placeholder.parent().width());
                }
            },
            receive: function receive(event, ui) {
                // Manipulate the received element
                if (ui.helper && ui.helper.hasClass('add-field-element')) {
                    // New field
                    ui.helper.css('width', '').css('height', '').removeClass('add-field-element').attr('id', randomIdMix(6));
                    // Hanlde resizable method
                    if (!ui.helper.hasClass('text-ctn')) {
                        ui.helper.append('<div class="resize-field-handle">||</div>').find('.resize-field-handle').on('mousedown', resizeFieldClickHandler);
                    }
                    // Handle edit button
                    ui.helper.append('<a class="edit-field-btn" data-id="edit-field-popup">' + makeSvgPencil() + '</a>').find('.edit-field-btn').on('mousedown', editFieldClickHandler);
                }

                var ctn = $(this).closest('.fieldset');
                // Create new fieldset when a field is added in the last one (+ zone)
                if (ctn.hasClass('last')) {
                    var $new = $(fieldsetTemplate);
                    fieldsetCtn.append($new);
                    ctn.removeClass('last');
                    // Reinitialize sortable on the new element
                    $new.children('.inputs-ctn').sortable(sortableOption);
                    // Refresh the sortable items. Triggers the reloading of all sortable items, causing new items to be recognized.
                    fieldsetCtn.sortable('refresh');
                }
            },
            remove: function remove(event, ui) {
                // Remove current fieldset when it contains no fields
                if (!this.firstChild) {
                    $(this).closest('.fieldset').remove();
                }
            },
            update: function update(event, ui) {
                // Generate field name, especially for checkbox and radio inputs. 
                // Auto-grouping: General rule is if they are placed next to another field with the same type, they take the name of that sibling.
                fieldCount = 0;
                // Ignore text-ctn (heading, description)
                formEditor.find('.inputs-ctn>*:not(.text-ctn)').each(function () {
                    var inputCtn = $(this);
                    var newName = void 0;

                    if (inputCtn.hasClass('form-checkbox-ctn')) {
                        var isRadio = inputCtn.hasClass('radio-btn');
                        var sibling = inputCtn.prev();
                        if (sibling[0]) {
                            var isRadio2 = sibling.hasClass('radio-btn');
                            if (!isRadio && !isRadio2 || isRadio && isRadio2) {
                                var checkInp = sibling.find('.form-check-input');
                                newName = checkInp.attr('name');
                                if (checkInp.hasClass('required')) {
                                    inputCtn.find('.form-check-input').addClass('required');
                                }
                            }
                        }
                    }
                    if (!newName) {
                        fieldCount++;
                        newName = 'field' + fieldCount;
                    }
                    inputCtn.find('.form-input, .form-check-input, .form-input-upload-input').attr('name', newName);
                });
            }
        };
        fieldsetCtn.find('.fieldset>.inputs-ctn').sortable(sortableOption);

        // Initiate global resizable field handlers
        $('body').on('mouseup', function (e) {
            mouseIsDown = false;
            $(resizeData.target).removeClass('resizing');
            $('body').removeClass('resizing-col');
            resizeData = {};
        });
        $('body').on('mousemove', function (e) {
            if (mouseIsDown) {
                // (Current mouse position - item starting position + item original width) / upper container width
                var x = (e.clientX - resizeData.startX + resizeData.startWidth) / resizeData.parentWidth * 100;
                var clazz = x < 22 ? 'five' : // 20 - 25
                x < 27 ? 'four' : // 25 - 33.3
                x < 41 ? 'three' : // 33.3 - 50
                x < 66 ? '' : // 50 - 80, default is half
                x < 90 ? 'four-fifth' : // 80 - 100
                'full';
                $(resizeData.target).removeClass('full four-fifth three four five').addClass(clazz).attr('data-span', clazz);
            }
        });

        // Initiate remove bin
        // Inputs-ctn accept zone
        formEditor.find('.remove-field-bin>.inputs-ctn').sortable(sortableOption);
        // Fieldset accept zone
        formEditor.find('.remove-field-bin').droppable({
            accept: '.fieldset',
            tolerance: 'pointer',
            drop: function drop(event, ui) {
                ui.draggable.remove();
                // Refresh the sortable items. Triggers the reloading of all sortable items, causing new items to be recognized.
                fieldsetCtn.sortable('refresh');
            }
        });

        // Initiate right panel collapse button
        $('.collapse-panel', controlCtn).on('click', function (e) {
            var ctn = $(e.currentTarget).closest('.admin-forms-editor-fields-control');
            formEditor.toggleClass('collapsed');
            if (formEditor.hasClass('collapsed')) {
                ctn.find('.add-field-list').width(ctn.width());
                ctn.css('overflow', 'hidden');
            } else {
                setTimeout(function () {
                    ctn.find('.add-field-list').width('auto');
                    ctn.css('overflow', 'visible');
                }, 400);
            }
        });

        // Initiate actions in edit field popup
        $('.edit-field-select-options-item').on('click', '.add', function (e) {
            var item = $(e.delegateTarget);
            if (!item.find('input').val()) {
                return false;
            }
            var clone = item.clone(true);
            clone.insertBefore(item);
            clone.removeClass('new').find('.add').remove();
            item.find('input').val('');
        });
        $('.edit-field-select-options-item').on('click', '.del', function (e) {
            e.delegateTarget.parentElement.removeChild(e.delegateTarget);
        });
        $('.edit-field-select-options-item.new input').on('keypress', function (e) {
            // Enter to add
            if (e.keyCode === 13 || e.which === 13) {
                $(this).closest('.edit-field-select-options-item').find('.add').trigger('click');
            }
        });
        $('.edit-field-apply-btn').on('click', function (e) {
            var form = $(e.currentTarget).closest('.edit-field-form');
            var field = $('#' + currentEditFieldId);
            var label = $('.edit-field-label-input', form).val();

            // Text label elements require different actions
            if (field.hasClass('text-ctn')) {
                // Update text content (heading or decsription label)
                field.find('.text-content').text(label);
            } else {
                // Default inputs
                var inp = field.find('.form-input, .form-check-input, .form-input-upload-input');
                var isCheckbox = field.hasClass('form-checkbox-ctn');
                var nameInp = $('.edit-field-name-input', form);
                var required = $('.edit-field-required-input', form).prop('checked');

                if (!nameInp.val()) {
                    nameInp.addClass('error');
                    return false;
                }
                nameInp.removeClass('error');
                // Set field name and required class
                if (isCheckbox) {
                    var allCheckInputs = formEditor.find('.form-check-input[name=' + nameInp.val() + ']');
                    required ? allCheckInputs.addClass('required') : allCheckInputs.removeClass('required');
                } else {
                    required ? inp.addClass('required') : inp.removeClass('required');
                }
                // Set field label and required sign (*)
                if (label) {
                    field.find('.form-input-label, .form-check-input-value, .form-input-upload-input-label-value').text(label);
                }
                // Set rich-text format on textarea
                if (inp.hasClass('textarea')) {
                    if ($('.edit-field-mce-input', form).prop('checked')) {
                        inp.addClass('mce-enabled');
                        initFormTextareaMCE();
                    } else {
                        inp.removeClass('mce-enabled');
                        if (tinymce.get(inp[0].name)) {
                            tinymce.get(inp[0].name).destroy();
                        }
                    }
                }
                // Set select options
                if (inp.hasClass('form-select')) {
                    inp.html('<option value=""></option>');
                    $('.edit-field-select-options-item input', form).each(function () {
                        if (this.value) {
                            inp.append('<option value="' + this.value + '">' + this.value + '</option>');
                        }
                    });
                }
                // Set file accept
                if (inp.attr('type') === 'file') {
                    inp.attr('accept', $('.edit-field-accept-input', form).val());
                }
            }

            currentEditFieldId = undefined;
            utilPopupClosePopup.call(this);
        });

        // Process and save form action
        $('.admin-forms-editor-save-btn').on('click', function (e) {
            // Checking current waiting state
            if (openLoadingWait()) {
                return false;
            }

            var settingsCtn = $('.admin-forms-editor-settings');
            // Validate required fields
            formValidator.validateForm(settingsCtn);
            if (settingsCtn.hasClass('has-error') || settingsCtn.has('.error')[0]) {
                return false;
            }

            var sets = [];
            fieldsetCtn.find('.fieldset:not(.last)').each(function (i, el) {
                var set = {
                    position: i,
                    fields: []
                };

                $('.input-ctn, .form-checkbox-ctn', el).each(function (j, ele) {
                    var $ele = $(ele);
                    var field = {
                        position: j,
                        spanClass: $ele.attr('data-span'),
                        type: $ele.attr('data-ctn')
                    };
                    var inp = void 0;

                    if ($ele.hasClass('text-ctn')) {
                        // Save heading and description text
                        field.label = $ele.find('.text-content').text();
                    } else if ($ele.hasClass('form-checkbox-ctn')) {
                        // Save checkbox and radio info
                        inp = $ele.find('.form-check-input');
                        field.label = field.value = $ele.find('.form-check-input-value').text();
                    } else if ($ele.hasClass('form-input-upload')) {
                        // Save upload field info
                        inp = $ele.find('.form-input-upload-input');
                        field.label = $ele.find('.form-input-upload-input-label-value').text();
                        field.accept = inp.attr('accept');
                    } else {
                        // Save all other input field info
                        inp = $ele.find('.form-input');
                        field.label = $ele.find('.form-input-label').text();
                    }
                    if (inp) {
                        field.name = inp.attr('name');
                        field.required = inp.hasClass('required');
                        if (inp.hasClass('form-select')) {
                            field.items = inp.find('option:not(:empty)').map(function (i, e) {
                                return e.value;
                            }).get();
                        }
                        if (inp.hasClass('textarea')) {
                            field.mceEnabled = inp.hasClass('mce-enabled');
                        }
                    }
                    // Add each field to the fields group
                    set.fields.push(field);
                });
                // Add a set/group to the final array
                sets.push(set);
            });

            var data = {
                ajax: true,
                id: formId,
                name: $('.admin-forms-form-name').val(),
                note: $('.admin-forms-form-note').val(),
                destination: $('.admin-forms-form-destination').val(),
                subject: $('.admin-forms-form-subject').val(),
                responderId: $('.admin-forms-form-responder').val(),
                fieldsets: JSON.stringify(sets)
            };

            $.ajax({
                url: "/action/manageGenForm",
                method: "POST",
                type: "POST",
                cache: false,
                data: data,
                success: function success(response) {
                    if (response.match('success')) {
                        var q = removeQuery('new');
                        q = removeQuery('formId', q);
                        // Redirect
                        window.location.search = q;
                    } else {
                        alert(response);
                    }
                },
                error: function error(response) {}
            });
        });
    }

    function makeSvgPencil() {
        return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="20.3px" height="20.3px" viewBox="0 0 20.3 20.3" xml:space="preserve"><path d="M11.1,3.6l5.6,5.6L5.6,20.3H0v-5.6L11.1,3.6z M4.9,18.6l1.2-1.2l-3.1-3.1l-1.2,1.2v1.4h1.7v1.7H4.9z M11.9,6.1    c0-0.2-0.1-0.3-0.3-0.3c-0.1,0-0.2,0-0.2,0.1l-7.3,7.3C4,13.3,4,13.3,4,13.4c0,0.2,0.1,0.3,0.3,0.3c0.1,0,0.2,0,0.2-0.1l7.3-7.3    C11.8,6.3,11.9,6.2,11.9,6.1z M20.3,4.9c0,0.5-0.2,0.9-0.5,1.2l-2.2,2.2L12,2.7l2.2-2.2C14.5,0.2,14.9,0,15.4,0    c0.5,0,0.9,0.2,1.2,0.5l3.1,3.1C20.1,4,20.3,4.4,20.3,4.9z"></path></svg>';
    }

    function initFormTextareaMCE() {
        if ((typeof tinymce === 'undefined' ? 'undefined' : _typeof(tinymce)) !== 'object') {
            setTimeout(function () {
                initFormTextareaMCE();
            }, 500);
            return false;
        }

        tinymce.init({
            selector: '.mce-enabled',
            content_css: ['/static/css/tiny.css', '/shared/websites/www.pmi.com/assets/tinymce/content.css'],
            cache_suffix: '?v=0.2',
            language: $('html').attr('lang'),
            plugins: ['advlist autolink lists link charmap', 'searchreplace visualblocks textcolor', 'insertdatetime table contextmenu paste hr fullscreen'],
            menubar: false, //'edit insert format',
            statusbar: false,
            toolbar: 'undo redo styleselect fontsizeselect link unlink bold italic underline forecolor backcolor bullist numlist alignleft aligncenter alignright alignjustify ',
            relative_urls: false,
            remove_script_host: false,
            allow_script_urls: false,
            entity_encoding: 'numeric',
            force_br_newlines: false,
            paste_as_text: true,
            contextmenu: 'styleselect fontsizeselect | bold italic underline link | inserttable cell row column deletetable',
            theme_advanced_blockformats: 'p,h1,h2,h3,h4,h5,h6,blockquote',
            fontsize_formats: '8px 9px 10px 11px 12px 13px 14px 15px 16px 18px 20px 22px 24px 28px 30px 32px',
            toolbar_location: 'bottom',
            init_instance_callback: function init_instance_callback(editor) {
                if (window.MiniBar) {
                    var el = editor.getContainer().querySelector('.mce-toolbar-grp .mce-flow-layout');
                    if (el.clientHeight > 10) {
                        $(el).css({
                            height: el.clientHeight + 'px'
                        });
                        new MiniBar(el, {
                            barType: 'default',
                            minBarSize: 5,
                            hideBars: false,
                            alwaysShowBars: false,
                            horizontalMouseScroll: true,
                            wheelScrollAmount: 3, // not working, it always scrolls too much
                            scrollX: true,
                            scrollY: false
                        });
                    }
                }
            }
        });
    }

    function duplicateForm(e) {
        if (openLoadingWait()) {
            return false;
        }

        $.ajax({
            url: "/action/manageGenForm",
            method: "POST",
            type: "POST",
            cache: false,
            data: {
                ajax: true,
                duplicate: true,
                id: $(e.currentTarget).data('id')
            },
            success: function success(response) {
                if (response.match('success')) {
                    var id = response.slice('success-'.length);
                    // Redirect
                    window.location.search = setQuery('formId', id);
                } else {
                    alert(response);
                }
            },
            error: function error(response) {}
        });
    }

    function deleteForm(e) {
        if (window.submittingForm) {
            return false;
        }
        window.submittingForm = true;

        $.ajax({
            url: "/action/manageGenForm",
            method: "POST",
            type: "POST",
            cache: false,
            data: {
                ajax: true,
                delete: true,
                id: $(e.currentTarget).data('id')
            },
            success: function success(response) {
                if (response.match('success')) {
                    // Reload page
                    window.location.reload();
                } else {
                    alert(response);
                }
            },
            error: function error(response) {}
        });
    }

    function deleteFormSubmission(e) {
        if (window.submittingForm) {
            return false;
        }
        window.submittingForm = true;

        $.ajax({
            url: "/action/manageGenForm",
            method: "POST",
            type: "POST",
            cache: false,
            data: {
                ajax: true,
                delete: true,
                submissionId: $(e.currentTarget).data('id')
            },
            success: function success(response) {
                if (response.match('success')) {
                    // Reload page
                    window.location.reload();
                } else {
                    alert(response);
                }
            },
            error: function error(response) {}
        });
    }

    function openLoadingWait() {
        var waiting = window.submittingForm;
        window.submittingForm = true;
        $('.popup-outer[data-id="loadingWait"]').addClass('open');
        return waiting;
    }

    function previewEventMedia() {
        if (!$('.event-media-preview')[0]) {
            return false;
        }

        $('.event-media-preview').each(function (i) {
            var newSrc = $(this).closest('.event-media-ctn').find('.event-media-source-input').val() || "";
            var curSrc = this.getAttribute('data-src') || "";

            if (newSrc !== curSrc) {
                this.innerHTML = '<img src="' + newSrc + '" alt=""/>';
                this.setAttribute('data-src', newSrc);
            }
        });

        setTimeout(previewEventMedia, 1000);
    }

    function previewJobMedia() {
        if (!$('.job-media-preview')[0]) {
            return false;
        }

        $('.job-media-preview').each(function (i) {
            var newSrc = $(this).closest('.job-media-ctn').find('.job-media-source-input').val() || "";
            var curSrc = this.getAttribute('data-src') || "";

            if (newSrc !== curSrc) {
                this.innerHTML = '<img class="job-logo" src="' + newSrc + '" alt=""/>';
                this.setAttribute('data-src', newSrc);
            }
        });

        setTimeout(previewJobMedia, 1000);
    }

    $(window).ready(function (e) {
        formValidator = Fw.component.models().form;
        tools = Fw.component.models().tools;
        utilPopupOpenPopup = Fw.component.models().popup.openPopup;
        utilPopupClosePopup = Fw.component.models().popup.closePopup;
        datepicker = $('.datepicker');
        promoTypeSelect = $('.promo-type-select');
        updateCCInfosBtn = $('.update-cc-infos-btn');
        jobImgBtn = $('.create-job-image-ctn .file-preview-picker-popup-accept-btn');
        attendedEventCheckbox = $('.admin-event-participants input[name="attended"]');
        allAttendedEventCheckbox = $('.admin-event-participants input[name="all-attended"]');
        applyCreditPopupBtn = $('.apply-credit-popup-btn');
        applyCreditConfirmBtn = $('.confirm-credit-btn');
        resendJobInvoiceBtn = $('.resend-job-invoice');
        formatLocationFields = $('.location-field');
        futureEventSelector = $(".registration-event-select:not(.registration-event-select-past)");

        if (formatLocationFields.length) {
            setTimeout(formatLocation, 1000);
        }
        if (datepicker.length) {
            initDatepickers();
        }
        promoTypeSelect.change(checkPromoType);
        updateCCInfosBtn.click(updateCCInfos);
        jobImgBtn.click(updateJobImgChoice);
        $('.admin-event-participants input[name="refunded"]').on('change', participantRefunded);
        attendedEventCheckbox.on('change', pmiAttended);
        allAttendedEventCheckbox.on('change', pmiAllAttended);
        applyCreditPopupBtn.click(applyCreditValidate);
        applyCreditConfirmBtn.click(applyCredit);
        resendJobInvoiceBtn.click(resendJobInvoice);
        $('.copy-event-url').click(copyUrlToClipboard);
        $('.check-events-form').click(validateEventForm);
        $('.add-expense-btn').click(resetExpenseForm);
        $('.edit-expense-btn').click(editExpense);
        $('.add-email-list-btn').click(resetEmailListForm);
        $('.edit-email-list-btn').click(editEmailList);
        $('.check-email-list-form').click(validateEmailListForm);
        $('.event-add-pdu').click(addEventPdu);
        $('.create-event-form .form-input[name=eventType]').on('change', eventTypeChange);

        if ($('.background-picker-settings-ctn').length) {
            $('.slick-slider').on('setPosition', imagePickerSlickSliderInit);
        }

        if ($('.promocode-event-select').length) {
            loadPromoEvents();
        }
        if ($('.promocode-product-select').length) {
            loadPromoProducts();
        }

        previewLocationImage();
        previewEventMedia();
        previewJobMedia();

        if ($('.registration-event-select').length) {
            fetchEvents(e, futureEventSelector);
        }

        $('.sortquery').addClass('tablesorter-default').find('th[data-sort-by]').addClass('tablesorter-header').click(sortByQuery);

        /* Initiate form builder functions */
        initFormBuilder();
        initFormTextareaMCE();

        $('.admin-form-duplicate').on('click', duplicateForm);
        $('.admin-form-delete-confirm').on('click', deleteForm);
        $('.admin-form-submission-delete-confirm').on('click', deleteFormSubmission);
    });
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var blogIds;
	var formValidator;

	var getBlogs = function getBlogs(blogIds) {
		var ctn = blogIds.closest('.related-blogs-js');
		var months = ctn.attr('data-months').split(',');
		var clone = ctn.find('.js-blog-link-ctn.clone');
		var ids = blogIds.val().trim().split(' ').join().replace(/,,/g, ',');

		ajax('/action/ajaxGetBlog?ajax=true&ids=' + ids, function (response) {
			var json = JSON.parse(response.trim());

			$.each(json, function (k, v) {
				var blogClone = clone.clone();
				var link = blogClone.find('.js-blog-link');
				var img = blogClone.find('.js-blog-img');

				if (json[k].imagePath) {
					img.css('background-image', json[k].imagePath);
				} else if (json[k].mediaId !== '0') {
					img.css('background-image', img.attr('data-prefix') + json[k].mediaId + img.attr('data-suffix'));
				} else {
					img.remove();
				}

				var url = link.attr('href') + json[k].friendlyUrl;
				link.attr('href', url);
				blogClone.find('.js-blog-date').html(json[k].postTimeDay + ' ' + months[json[k].postTimeMonth] + ' ' + json[k].postTimeYear);
				blogClone.find('.js-blog-name').html(hexToHtml(json[k].title));

				blogClone.removeClass('clone');
				ctn.append(blogClone);
			});

			ctn.closest('.page-split-right-side-infos-ctn').slideDown();
		}, true);
	};

	function decodeText() {
		var txt = name;
		txt = txt.replace(/\\\\xA9/g, '\xA9').replace(/\\\\xAE/g, '\xAE').replace(/\\\\xE0/g, '\xE0').replace(/\\\\xE1/g, '\xE1').replace(/\\\\xE2/g, '\xE2').replace(/\\\\xE3/g, '\xE3').replace(/\\\\xE4/g, '\xE4').replace(/\\\\xE5/g, '\xE5').replace(/\\\\xE6/g, '\xE6').replace(/\\\\xE7/g, '\xE7').replace(/\\\\xE8/g, '\xE8').replace(/\\\\xE9/g, '\xE9').replace(/\\\\xEA/g, '\xEA').replace(/\\\\xEB/g, '\xEB').replace(/\\\\xEC/g, '\xEC').replace(/\\\\xED/g, '\xED').replace(/\\\\xEE/g, '\xEE').replace(/\\\\xEF/g, '\xEF').replace(/\\\\xF1/g, '\xF1').replace(/\\\\xF2/g, '\xF2').replace(/\\\\xF3/g, '\xF3').replace(/\\\\xF4/g, '\xF4').replace(/\\\\xF6/g, '\xF6').replace(/\\\\xF9/g, '\xF9').replace(/\\\\xFA/g, '\xFA').replace(/\\\\xFB/g, '\xFB').replace(/\\\\xFC/g, '\xFC').replace(/\\\\xFD/g, '\xFD').replace(/\\\\xFF/g, '\xFF').replace(/\\\\xC0/g, '\xC0').replace(/\\\\xC1/g, '\xC1').replace(/\\\\xC2/g, '\xC2').replace(/\\\\xC3/g, '\xC3').replace(/\\\\xC4/g, '\xC4').replace(/\\\\xC5/g, '\xC5').replace(/\\\\xC6/g, '\xC6').replace(/\\\\xC7/g, '\xC7').replace(/\\\\xC8/g, '\xC8').replace(/\\\\xC9/g, '\xC9').replace(/\\\\xCA/g, '\xCA').replace(/\\\\xCB/g, '\xCB').replace(/\\\\xCC/g, '\xCC').replace(/\\\\xCD/g, '\xCD').replace(/\\\\xCE/g, '\xCE').replace(/\\\\xCF/g, '\xCF').replace(/\\\\xD1/g, '\xD1').replace(/\\\\xD2/g, '\xD2').replace(/\\\\xD3/g, '\xD3').replace(/\\\\xD4/g, '\xD4').replace(/\\\\xD5/g, '\xD5').replace(/\\\\xD6/g, '\xD6').replace(/\\\\xD9/g, '\xD9').replace(/\\\\xDA/g, '\xDA').replace(/\\\\xDB/g, '\xDB').replace(/\\\\xDC/g, '\xDC').replace(/\\\\xDD/g, '\xDD').replace(/\\\\xDF/g, '\xDF');
		return decodeURI(txt);
	}

	function hexToHtml(name) {
		var txt = name;
		txt = txt.replace(/\\xA9/g, '&#169;').replace(/\\xAE/g, '&#174;').replace(/\\xE0/g, '&#224;').replace(/\\xE1/g, '&#225;').replace(/\\xE2/g, '&#226;').replace(/\\xE3/g, '&#227;').replace(/\\xE4/g, '&#228;').replace(/\\xE5/g, '&#229;').replace(/\\xE6/g, '&#230;').replace(/\\xE7/g, '&#231;').replace(/\\xE8/g, '&#232;').replace(/\\xE9/g, '&#233;').replace(/\\xEA/g, '&#234;').replace(/\\xEB/g, '&#235;').replace(/\\xEC/g, '&#236;').replace(/\\xED/g, '&#237;').replace(/\\xEE/g, '&#238;').replace(/\\xEF/g, '&#239;').replace(/\\xF1/g, '&#241;').replace(/\\xF2/g, '&#242;').replace(/\\xF3/g, '&#243;').replace(/\\xF4/g, '&#244;').replace(/\\xF6/g, '&#245;').replace(/\\xF9/g, '&#249;').replace(/\\xFA/g, '&#250;').replace(/\\xFB/g, '&#251;').replace(/\\xFC/g, '&#252;').replace(/\\xFD/g, '&#253;').replace(/\\xFF/g, '&#255;').replace(/\\xC0/g, '&#192;').replace(/\\xC1/g, '&#193;').replace(/\\xC2/g, '&#194;').replace(/\\xC3/g, '&#195;').replace(/\\xC4/g, '&#196;').replace(/\\xC5/g, '&#197;').replace(/\\xC6/g, '&#198;').replace(/\\xC7/g, '&#199;').replace(/\\xC8/g, '&#200;').replace(/\\xC9/g, '&#201;').replace(/\\xCA/g, '&#202;').replace(/\\xCB/g, '&#203;').replace(/\\xCC/g, '&#204;').replace(/\\xCD/g, '&#205;').replace(/\\xCE/g, '&#206;').replace(/\\xCF/g, '&#207;').replace(/\\xD1/g, '&#209;').replace(/\\xD2/g, '&#210;').replace(/\\xD3/g, '&#211;').replace(/\\xD4/g, '&#212;').replace(/\\xD5/g, '&#213;').replace(/\\xD6/g, '&#214;').replace(/\\xD9/g, '&#217;').replace(/\\xDA/g, '&#218;').replace(/\\xDB/g, '&#219;').replace(/\\xDC/g, '&#220;').replace(/\\xDD/g, '&#221;').replace(/\\xDF/g, '&#223;');
		return txt;
	}

	var init = function init() {
		blogIds = $('.related-blogs-ids');

		if (blogIds.length) {
			blogIds.each(function () {
				if ($(this).val() !== '') {
					getBlogs($(this));
				}
			});
		}

		// $('.comment-input').on('input', function(e) {
		// 	var hasText = $(this).val().trim().length > 0;
		// 	var hasAuthor = $('.comment-author').val().trim().length > 0;

		// 	$('.submit-comment-form').prop('disabled', (!hasText || !hasAuthor));

		//   });

		$('.comment-input, .comment-author').on('input', function () {
			var $form = $(this).closest('.blog-comment-form');
			var hasText = $form.find('.comment-input').val().trim().length > 0;
			var hasAuthor = $form.find('.comment-author').val().trim().length > 0;

			$form.find('.submit-comment-form').prop('disabled', !(hasText && hasAuthor));
		});

		$('.blog-comment-reply').on('click', function () {
			$(this).next('.replies').slideToggle(); // Toggles the visibility with animation
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($) {
    'use strict';

    var recaptcha, validateForm;

    var submittingForm = false;

    $(window).ready(function () {
        recaptcha = Fw.component.models().utils.recaptcha;
        validateForm = Fw.component.models().form.validateForm;

        $('.candidate-cv-btn').on('click', openCV);

        $('.job-candidate-application-form .confirm-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendApplication.call(btn, response, form);
            }, true, $(this).closest('.job-candidate-application-form'));
        });

        $('.candidate-contact-form button').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendContact.call(btn, response, form);
            }, true, $(this).closest('.candidate-contact-form'));
        });
    });

    function openCV(e) {
        e.preventDefault();
        var btn = $(this);
        var link = btn.attr('data-link');
        var candidateId = btn.attr('data-id');

        if (btn.hasClass("notify-view")) {
            $.post('/action/candidateSendEmail?notify=true&id=' + candidateId, function () {
                btn.removeClass("notify-view");
            });
        }

        window.open(link, '_blank');
    }

    function sendApplication(captchaToken, form) {
        form.find('input[name="captcha"]').val(captchaToken);
        if (!form.hasClass('has-error') && !submittingForm) {
            submittingForm = true;
            form.submit();
        }
    }

    function sendContact(captchaToken, form) {
        var captchaInput = form.find('input[name="captcha"]');

        $('.candidate-contact-sent-message').removeClass('show');
        captchaInput.val(captchaToken);
        validateForm(form);
        if (!form.hasClass('has-error') && !submittingForm) {
            submittingForm = true;
            $.post('/action/candidateSendEmail', form.serialize(), function () {
                submittingForm = false;
                $('.candidate-contact-sent-message').addClass('show');
                form.closest('.popup-outer.open').removeClass('open');
                form[0].reset();
                captchaInput.val('');
            });
        }
    }
})(jQuery);
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {

    'use strict';

    var formValidator;
    var tools;
    var stripe;
    var worldPay;
    var checkoutContinueBtn;
    var checkoutBackBtn;
    var checkoutConfirmBtn;
    var checkoutParams;

    var continueCheckout = function continueCheckout(t) {
        var btn;
        if (t.length) {
            btn = t;
        } else {
            btn = $(this);
        }
        var form = btn.closest('form');
        var personRecap = $('.checkout-recap-infos-ctn.person .checkout-recap-infos-inner');
        var cardRecap = $('.checkout-recap-infos-ctn.card .checkout-recap-infos-inner');
        var stepOne = $('.checkout-step.one');
        var stepTwo = $('.checkout-step.two');

        tools.ignoreUnusedStates(form);
        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            checkoutParams = [];
            stepOne.find('.form-input').each(function () {
                if ($(this).hasClass('select-state-input')) {
                    if ($(this).hasClass('selected')) {
                        checkoutParams.push({
                            name: this.name,
                            value: this.value
                        });
                    }
                } else {
                    checkoutParams.push({
                        name: this.name,
                        value: this.value
                    });
                }
            });

            var firstName = stepOne.find('input[name=firstName]').val();
            var lastName = stepOne.find('input[name=lastName]').val();
            var email = stepOne.find('input[name=email]').val();
            var companyName = stepOne.find('input[name=companyName]').val();
            var field4 = stepOne.find('input[name=field4]').val();
            var field5 = stepOne.find('input[name=field5]').val();
            var field6 = stepOne.find('input[name=field6]').val();
            var street = stepOne.find('input[name=street]').val();
            var street2 = stepOne.find('input[name=street2]').val();
            var city = stepOne.find('input[name=city]').val();
            var province = form.find('.select-state-input-ctn.selected select').val();
            var postalCode = stepOne.find('input[name=postalCode]').val();
            var country = form.find('.select-country-input option:selected').html();
            var arrayCPP = [];

            if (street2 !== '') {
                street = street2 + ' - ' + street;
            }
            if (city !== '') {
                arrayCPP.push(city);
            }
            if (province !== '') {
                arrayCPP.push(province);
            }
            if (postalCode !== '') {
                arrayCPP.push(postalCode);
            }

            personRecap.empty();
            personRecap.append('<p>' + firstName + ' ' + lastName + '</p>');
            personRecap.append('<p>' + email + '</p>');
            personRecap.append('<p>' + companyName + '</p>');
            if (field4) personRecap.append('<p>' + field4 + '</p>');
            if (field5) personRecap.append('<p>' + field5 + '</p>');
            if (field6) personRecap.append('<p>' + field6 + '</p>');
            personRecap.append('<p>' + street + '</p>');
            if (arrayCPP.length) personRecap.append('<p>' + arrayCPP.join(', ') + '</p>');
            personRecap.append('<p>' + country + '</p>');

            var surveyCtn = $('.form-survey-ctn');
            if (surveyCtn[0]) {
                var str = '';
                surveyCtn.find('.form-survey-question').each(function () {
                    var it = $(this);
                    var toggledCtn = it.parents('.element-to-toggle');

                    if (!toggledCtn.length || toggledCtn.css('display') !== 'none') {
                        if (str !== '') str += '\n';
                        str += it.text() + ' ';
                        str += it.next('.form-survey-answer-check').find('.form-check-input:checked').val();
                    }
                });
                surveyCtn.find('.form-survey-text-input').each(function () {
                    var it = $(this);
                    var toggledCtn = it.parents('.element-to-toggle');

                    if (!toggledCtn.length || toggledCtn.css('display') !== 'none') {
                        if (str !== '') str += '\n';
                        str += it.find('.form-input-label').text() + ' ';
                        str += it.find('.form-input').val();
                    }
                });
                surveyCtn.find('.form-survey-main-input').val(str);
            }

            var paymentChoiceInp = $('.card-inputs-payment-choice [name="payment-type-toggle"]:checked');

            if (!$('.checkout-pmihu-agreement-input', form)[0]) {
                cardRecap.empty();
                var cardCtn = form.find('.card-inputs-inner');
                if (!cardCtn.hasClass('hide')) {
                    var paymentChoiceText = paymentChoiceInp.closest('label').find('.payment-choice').html();
                    if (paymentChoiceText && paymentChoiceText !== '') {
                        cardRecap.append('<p>' + paymentChoiceText + '</p>');
                    }
                    var paymentType = form.find('.checkout-payment-inputs input[name="paymentType"]').val();
                    var cheque = form.find('.checkout-payment-inputs input[name="cheque"]').val();
                    if (paymentType === 'card' || cheque === 'false') {
                        var cc = cardCtn.find('input[name="ccCard"]').val();
                        if (cc) {
                            cardRecap.append('<p>************' + cc.substring(cc.length - 4, cc.length) + '</p>');
                            cardRecap.append('<p>' + cardCtn.find('[name="expMM"]').val() + '/' + cardCtn.find('[name="expYY"]').val() + '</p>');
                        } else {
                            cardRecap.empty();
                        }
                    } else {
                        //cardCtn.find('.form-input').val(''); To be tested
                    }
                }
            }

            //Smart Paypal Button + Cheque
            if ($('.checkout-paypal-ctn, .checkout-cheque-ctn').length > 1) {
                if (paymentChoiceInp.val() === 'cheque') {
                    $('.checkout-paypal-ctn').hide();
                    $('.checkout-cheque-ctn').show();
                    $('.checkout-step-btns.two .us-paypal-notice').hide();
                } else {
                    $('.checkout-paypal-ctn').show();
                    $('.checkout-cheque-ctn').hide();
                    $('.checkout-step-btns.two .us-paypal-notice').show();
                }
            }

            // Netherlands iDEAL issuer select
            var issuersCtn = form.find('.checkout-ideal-issuers');
            if (issuersCtn.length) {
                var issuerSelect = issuersCtn.find('.form-select');
                if (form.find('.checkout-ideal-selector').prop('checked')) {
                    issuersCtn.removeClass('hide');
                    issuerSelect.removeClass('required');
                    // Fetch issuer list
                } else {
                    issuersCtn.addClass('hide');
                    issuerSelect.removeClass('required');
                }
            }

            $('.card-inputs').fadeOut();
            $('.step-text.1').fadeOut(function () {
                $('.step-text.2').fadeIn();
            });
            $('.checkout-step-btns.one').fadeOut(function () {
                $('.checkout-step-btns.two').fadeIn();
            });

            $('.checkout-one-step-number-ctn.1').removeClass('active').addClass('done');
            setTimeout(function () {
                $('.checkout-one-step-number-ctn.2').addClass('active');
            }, 300);

            stepOne.slideUp(function () {
                stepTwo.slideDown();
                $('html').animate({ scrollTop: stepTwo.offset().top - 20 }, 300);
                $('body').animate({ scrollTop: stepTwo.offset().top - 20 }, 300);
            });
        }
    };

    var backCheckout = function backCheckout() {
        $('.step-text.2').fadeOut(function () {
            $('.step-text.1').fadeIn();
        });
        $('.checkout-step.two').slideUp(function () {
            $('.checkout-step.one').slideDown();
        });

        $('.checkout-step-btns.two').fadeOut(function () {
            $('.checkout-step-btns.one').fadeIn();
            $('.card-inputs').fadeIn();
            // Reset Netherlands iDEAL issuer select
            $('.checkout-ideal-issuers').addClass('hide').find('.form-select').removeClass('required');
        });

        $('.checkout-one-step-number-ctn.1').removeClass('done').addClass('active');
        $('.checkout-one-step-number-ctn.2').removeClass('active');
    };

    var submitCheckout = function submitCheckout() {
        $(this).addClass('disabled').closest('form').submit();
    };

    var renderPaypalButton = function renderPaypalButton() {
        var el = document.getElementById('checkoutPaypalButton');
        if (!el || (typeof paypal === 'undefined' ? 'undefined' : _typeof(paypal)) === undefined) {
            return;
        }

        if (window.navigator.userAgent.match(/(MSIE|Trident)/)) {
            $('.checkout-browser-unsupported-warning').removeClass('hide');
        }

        $.ajax({
            url: "/action/pmiPayPalOrder?render=true",
            method: "GET",
            type: "GET",
            dataType: "text",
            success: function success(response) {
                var json = JSON.parse(response.trim().replace(/(\0|\\u0000)/g, ""));
                // JSONArray
                for (var i = 0; i < json.length; i++) {
                    var jo = json[i];
                    // Cart items
                    for (var item in jo.items) {
                        var descr = jo.items[item].description;
                        var name = jo.items[item].name;
                        // The purchase description. Maximum length: 127.
                        if (descr !== undefined && descr.length > 127) {
                            var i1, i2;
                            descr = descr.substring(0, 127);
                            i1 = descr.lastIndexOf("&");
                            i2 = descr.lastIndexOf(";");
                            // In case where there is a unicoded character (&#224;)
                            // that is cut at the end of the string, we trim it 
                            // down until before the "&" character.
                            if (i1 > 0 && (i1 > i2 || i2 === -1)) {
                                descr = descr.substring(0, i1 - 1);
                            }
                            // Set the description with the new value
                            jo.items[item].description = descr;
                        }
                        // The purchase name. Maximum length: 120.
                        if (name !== undefined && name.length > 120) {
                            var i1, i2;
                            name = name.substring(0, 120);
                            i1 = name.lastIndexOf("&");
                            i2 = name.lastIndexOf(";");
                            // In case where there is a unicoded character (&#224;)
                            // that is cut at the end of the string, we trim it 
                            // down until before the "&" character.
                            if (i1 > 0 && (i1 > i2 || i2 === -1)) {
                                name = name.substring(0, i1 - 1);
                            }
                            // Set the name with the new value
                            jo.items[item].name = name;
                        }
                    }
                }
                Object.freeze(json);

                // Render PayPal
                /* https://developer.paypal.com/docs/checkout/integrate/ */
                /* https://developer.paypal.com/docs/checkout/integration-features/customize-button/ */
                paypal.Buttons({
                    style: {
                        layout: 'horizontal'
                    },
                    // Before opening the paypal popup
                    createOrder: function createOrder(data, actions) {
                        var elems = $('.checkout-form')[0].elements;
                        var payer = {};
                        var phoneNumber = elems.phone && elems.phone.value ? elems.phone.value.replace(/[_\-\+\.\s]/g, '') : '';

                        if (/^[0-9]{1,14}?$/.test(phoneNumber)) {
                            payer.phone = {
                                phone_type: 'MOBILE',
                                phone_number: {
                                    national_number: phoneNumber
                                }
                            };
                        }
                        payer.name = {
                            given_name: elems.firstName.value,
                            surname: elems.lastName.value
                        };
                        payer.email_address = elems.email.value;
                        payer.address = {
                            address_line_1: elems.street.value,
                            address_line_2: elems.street2.value,
                            admin_area_1: $('.checkout-form .select-state-input.selected').val(),
                            admin_area_2: elems.city.value,
                            postal_code: elems.postalCode.value,
                            country_code: elems.country.value
                        };

                        return actions.order.create({
                            intent: 'CAPTURE',
                            purchase_units: json,
                            payer: payer,
                            application_context: {
                                shipping_preference: 'NO_SHIPPING'
                            }
                        });
                    },
                    // After the user clicks on Pay and the paypal closes
                    onApprove: function onApprove(data, actions) {
                        $('.popup-outer[data-id="checkout_processing_wait"]').addClass('open');

                        var q = '?orderID=' + data.orderID + "&payerID=" + data.payerID;
                        for (var i = 0; i < checkoutParams.length; i++) {
                            var p = checkoutParams[i];
                            q += '&' + p.name + '=' + encodeURIComponent(p.value);
                        }
                        if ($("input[name='sendInvoicePerSignup']").prop('checked')) {
                            q += '&sendInvoicePerSignup=true';
                        }

                        return window.fetch('/action/pmiPayPalOrder' + q, {
                            method: 'post',
                            headers: {
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify({
                                orderID: data.orderID
                            })
                        }).then(function (_response) {
                            return _response.json(); //Promise
                        }).then(function (_details) {
                            console.log(_details.result);
                            window.location.search = 'success';
                        }).catch(function (_reject) {
                            console.error(_reject);
                            window.location.search = 'ccError';
                        });
                    },
                    // Handles any errors
                    onError: function onError(err) {
                        console.error(err);
                        $('.popup-outer[data-id="checkout_processing_wait"]').removeClass('open');
                        popErrorSite('errorMessageAjaxSite');
                        document.getElementById('errorMessageAjaxSite').innerHTML = "<div>An error occurred during the process. Please try again or contact us if the problem persists.</div>";
                    }
                }).render('#checkoutPaypalButton');
            }
        });
    };

    var removeCheckRequired = function removeCheckRequired(e) {
        var ctn = $(this).closest('.form-survey-answer-check');
        ctn.find('.form-check-input.required').addClass('derequired').removeClass('required');
        ctn.find('.radio-btn').removeClass('error');
    };

    var huRequireField4 = function huRequireField4(e) {
        if (this.value) {
            $('.checkout-form .form-input[name=field4]').addClass('required').trigger('blur');
        } else {
            $('.checkout-form .form-input[name=field4]').removeClass('required').trigger('blur');
        }
    };

    var huToggleConfirmButton = function huToggleConfirmButton(e) {
        var confirmBtn = $(this).closest('.checkout-step-btns').find('.validate-form-btn');
        if (!$('.checkout-pmihu-agreement-input:not(:checked)').length) {
            confirmBtn.removeClass('hide disabled').removeAttr('disabled');
        } else {
            confirmBtn.addClass('disabled').attr('disabled', '');
        }
    };

    var init = function init() {
        formValidator = Fw.component.models().form;
        tools = Fw.component.models().tools;

        checkoutContinueBtn = $('.checkout-continue-btn');
        checkoutBackBtn = $('.checkout-back-btn');
        checkoutConfirmBtn = $('.checkout-confirm-btn');

        if ($('#stripe-cc-form').length) {
            stripe = Fw.component.models().stripeToken;
            stripe.init();
        } else if ($('#worldpay-cc-form').length) {
            worldPay = Fw.component.models().worldpayToken;
            worldPay.init();
        } else {
            checkoutContinueBtn.click(continueCheckout);
        }

        if ($('#stripe-cc-form2').length) {
            stripe = Fw.component.models().stripeIntent;
            stripe.init();
        }

        checkoutBackBtn.click(backCheckout);
        checkoutConfirmBtn.click(submitCheckout);

        $('.form-survey-answer-check .form-check-input.required').on('change', removeCheckRequired);

        // Paypal integration
        renderPaypalButton();

        if (getQuery('skip') === '1') {
            checkoutContinueBtn.trigger('click');
        }

        // PMI Budapest
        if ($('.checkout-pmihu-agreement-input')[0]) {
            // Tax ID (extra field4) required if Company Name is filled
            $('.checkout-form .form-input[name=companyName]').on('change keypress', huRequireField4).trigger('change');
            // Toggle display Confirm button from the acceptance checkboxes
            $('.checkout-pmihu-agreement-input').on('change', huToggleConfirmButton);
        }

        // **Delivery Address Checkbox Handling**
        var deliveryCheckbox = $('#deliveryAddressCheckbox');
        var deliverySection = $('#delivery-address-section');
        var deliveryStreet1 = $('.deliveryStreet1');
        var deliveryCity = $('.deliveryCity');
        var deliveryPostalCode = $('.deliveryPostalCode');
        var deliveryCountry = $('.deliveryCountry');

        // Toggle visibility when checkbox is clicked
        deliveryCheckbox.on('change', function () {
            if ($(this).is(':checked')) {
                //deliverySection.slideDown();
                deliverySection.show();
                deliveryStreet1.addClass('required');
                deliveryCity.addClass('required');
                deliveryPostalCode.addClass('required');
                deliveryCountry.addClass('required');
            } else {
                //deliverySection.slideUp();
                deliverySection.hide();
                deliveryStreet1.removeClass('required');
                deliveryCity.removeClass('required');
                deliveryPostalCode.removeClass('required');
                deliveryCountry.removeClass('required');
            }
        });
    };

    $(window).ready(init);

    Fw.component.export('checkout', {
        continueCheckout: continueCheckout
    });
})(jQuery);
'use strict';

(function () {

    'use strict';

    var formValidator;
    var expanded = false;

    /* Compile customized UNY fields */
    var pmiunyFields = function pmiunyFields($form) {
        var $qs = $form.has('.pmiuny-event-signup-questions');
        if ($qs.length) {
            var v = '';
            var partNumber = 0;

            $qs.find('[name^="metaData_part"]').each(function (i, el) {
                if (el.type === 'radio' || el.type === 'checkbox') {
                    if (el.checked) {
                        partNumber++;
                        v += $qs.find('.metaData_label' + partNumber).text() + ' = ' + el.value;
                        v += '; \n';
                    }
                } else {
                    partNumber++;
                    if (el.value !== '') {
                        v += el.parentElement.querySelector('.form-input-label').textContent + ' = ' + el.value;
                        v += '; \n';
                    }
                }
            });

            $form.find('[name="metaData"]').each(function () {
                if (this.value !== '') {
                    v = this.value + '; \n' + v;
                }
                this.name = 'metaDataX';
            });
            $qs.find('[name="metaDataCompile"]').val(v).attr('name', 'metaData');
        }
    };

    /* Compile dynamically event's extra fields */
    var compileMetaData = function compileMetaData($form) {
        var $parts = $form.find('.event-signup-metadata-part');
        if ($parts.length) {
            var v = '';

            $parts.each(function (i, el) {
                var input = $(el).find('.esmp-input')[0];
                var labelEl = $form.find(input.getAttribute('data-extra'))[0];
                var line = '';

                if (input && input.value.trim() !== '') {
                    // Append the meta label
                    if (labelEl && labelEl.value.trim() !== '') {
                        line += labelEl.value.trim();
                        if (!line.match(': ')) {
                            line += ' = ';
                        }
                    }
                    // Append the meta value
                    line += input.value.trim();
                }
                // Append the meta line to the main value
                if (line !== '') {
                    v += (v !== '' ? '; \n' : '') + line;
                }
            });
            if ($('input[name="metaData"]').length != 0) {
                $('input[name="metaData"]').val(v);
            } else {
                $form.append('<input type="hidden" name="metaData" value="' + v.replace(/"/g, "&quot;") + '"/>');
            }
        }
    };

    var submitEventSignup = function submitEventSignup() {
        var btn = $(this);
        var form = btn.closest('form');
        var count = form.find('input[name=participants-count]').val();
        var inputsFilled = false;

        form.removeClass('has-error');
        $('.js-form-error-message.fields').slideUp();

        form.find('.form-input.required').each(function () {
            if (this.value.trim() !== '') {
                $(this).removeClass('error');
                inputsFilled = true;
            }
        });
        pmiunyFields(form);
        compileMetaData(form);

        if (parseInt(count) === 0 || inputsFilled) {
            formValidator.validateForm(form);
        }

        if (!form.hasClass('has-error')) {
            $('.event-signup-form-btns .btn', form).addClass('disabled');

            var forward = btn.attr('data-url');
            if (inputsFilled) {
                form.find('input[name=pageSuccess]').val(forward);
                setTimeout(function () {
                    form.submit();
                }, 50);
            } else {
                window.location.href = forward;
            }
        }
    };

    function getCheckedValues() {
        var selectedAddPriceId = [];
        $("input[type='checkbox']:checked").each(function () {
            if ($(this).val() != 'on') selectedAddPriceId.push($(this).val());
        });

        $('.event-signup-form input[name="addPriceId"]').val(selectedAddPriceId.join(','));
        console.log(selectedAddPriceId.join(','));
        // Do something with the checked values
    }

    $(window).ready(function () {
        formValidator = Fw.component.models().form;

        $('.submit-event-signup-btn').click(submitEventSignup);
        $('.add-guest-btn').click(submitEventSignup);
        $(".selectBox").on("click", function () {
            var checkboxes = $("#checkboxes");
            if (!expanded) {
                checkboxes.show();
                expanded = true;
            } else {
                checkboxes.hide();
                expanded = false;
            }
        });
        $("#checkboxes input[type='checkbox']").on("change", getCheckedValues);
    });
})();
'use strict';

(function ($, undefined) {

	'use strict';

	var init = function init() {};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($) {

    'use strict';

    var utils_recaptcha2, tools_validateForm;

    var deleteJobFile = function deleteJobFile() {
        var t = $(this);

        t.closest('.element-to-hide').fadeOut(function () {
            $(this).remove();
        });
        t.closest('form').append('<input type="hidden" name="' + t.attr('data-name') + '" value="true"/>');
    };

    var validateJobOffer = function validateJobOffer(captcha) {
        var $btn = $(this);
        var $form = $btn.closest('form');

        // Set the captcha value to input
        $form.find("input[name='captcha']").addClass('required').val(typeof captcha === 'string' ? captcha : 'undefined');
        // Validate required fields
        tools_validateForm($btn);
        // Reset if there is any error
        if ($form.hasClass('has-error') && captcha) {
            grecaptcha.reset($btn.attr('data-widget-id'));
        }
    };

    var init = function init() {
        utils_recaptcha2 = Fw.component.models().utils.recaptcha2;
        tools_validateForm = Fw.component.models().tools.validateForm;

        $('.delete-job-posting-file').click(deleteJobFile);

        $('.job-offer-next-btn').each(function () {
            utils_recaptcha2(this, validateJobOffer);
        });
    };

    $(window).ready(init);
})(jQuery);
"use strict";

(function ($, d, g) {
    /* jshint validthis: true */
    "use strict";

    function init() {
        $("#all-newsletter-lists input[type='checkbox']").on("change", getSelectedCheckboxLists);
    }

    function getSelectedCheckboxLists() {
        var selectedValues = [];
        $("input[type='checkbox']:checked").each(function () {
            if ($(this).val() != 'on') selectedValues.push($(this).val());
        });

        $('#emRegisteredLists input[name="listId"]').val(selectedValues.join(','));
    }

    $(g).ready(init);
})(jQuery, document, window);
'use strict';

(function () {

    'use strict';

    var recaptcha;
    var formValidator;

    var submitForgotPwForm = function submitForgotPwForm(captcha, form) {
        var btn = $(this);

        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            var url = '/action/pmiForgetPassword';

            url += '?ajax=true';
            url += '&email=' + encodeURIComponent(form.find('input[name=email]').val());
            if (captcha) {
                url += '&captcha=' + captcha;
            }

            btn.addClass('disabled');
            form.find('.forgot-pw-success, .forgot-pw-error').slideUp();

            ajax(url, function (response) {
                btn.removeClass('disabled');
                if (response.indexOf('success') > -1) {
                    form.find('input').val('').removeClass('has-value');
                    form.find('.forgot-pw-success').slideDown(function () {
                        setTimeout(function () {
                            form.find('.forgot-pw-success').slideUp();
                        }, 15000);
                    });
                } else {
                    form.find('.forgot-pw-error').slideDown();
                }
            }, true);
        }
    };

    var convertRequiredLogLinks = function convertRequiredLogLinks() {
        var url = $('.page').attr('data-page-login');
        if (url && url !== '' && !$('body').hasClass('is-signed-in')) {
            $('a.required-log').attr("href", url);
        }
    };

    var init = function init() {
        recaptcha = Fw.component.models().utils.recaptcha;
        formValidator = Fw.component.models().form;

        $('.submit-forgot-pw-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                submitForgotPwForm.call(btn, response, form);
            }, true, $(this).closest('form'));
        });

        convertRequiredLogLinks();
    };

    $(window).ready(init);
})();
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* global Fw, tinyMCE, tinymce, submittingForm */

(function ($, d, g) {
    /* jshint validthis: true */
    "use strict";

    g.submittingForm = g.submittingForm !== undefined ? submittingForm : false;

    var tools_form;
    var utils_recaptcha;

    var currentSearchQuery;
    var $addingList;
    var $selectedList;

    var searchRequest;
    var searchTimeout;
    var searchDelay = 500;
    var expanded = false;

    function reloadPage() {
        g.location.reload();
    }

    function filterItem() {
        var txt = this.querySelector("span").textContent.replace(/\(|\)/g, "");
        if (txt.match(currentSearchQuery)) {
            $(this).removeClass("hide");
        } else {
            $(this).addClass("hide");
        }
    }

    function searchList(e) {
        var $ctn = $(this).closest(".list-selector-main");
        var k = e.which || e.keyCode;

        if (k === 13) {
            e.preventDefault();
        }

        currentSearchQuery = new RegExp($ctn.find(".list-selector-main-search input").val(), "i");
        $ctn.find(".list-selector-item").each(filterItem);
    }

    function ntczMoveUp(e) {
        var $el = $(this).closest(".ntc-zone"),
            $prev = $el.prev(),
            i = $el.index();

        moveElementWithTinyMCE($el, function () {
            $el.insertBefore($prev);
        });

        if (i - 1 === 0) {
            $(this).addClass("hide");
            $prev.find(".ntc-zone-btn-up").removeClass("hide");
        } else if (i + 1 === $el.parent().children().length) {
            $prev.find(".ntc-zone-btn-down").addClass("hide");
            $el.find(".ntc-zone-btn-down").removeClass("hide");
        }
    }
    function ntczMoveDown(e) {
        var $el = $(this).closest(".ntc-zone"),
            $next = $el.next(),
            i = $next.index();

        moveElementWithTinyMCE($el, function () {
            $el.insertAfter($next);
        });

        if (i + 1 === $el.parent().children().length) {
            $(this).addClass("hide");
            $next.find(".ntc-zone-btn-down").removeClass("hide");
        } else if (i - 1 === 0) {
            $next.find(".ntc-zone-btn-up").addClass("hide");
            $el.find(".ntc-zone-btn-up").removeClass("hide");
        }
    }
    function ntczDisplay(e) {
        $(this).closest(".ntc-zone").attr("data-hidden", !this.checked);
    }

    function processTemplate($form, callback) {
        var displayArray = [],
            orderArray = [],
            parser = tinymce.get("tinymceDOMParser"); //Transform xhtml elements

        // Transfer html content to the header and footer textarea
        parser.setContent($form.find(".ntc-zone-header").html());
        $form.find("[name='header']").val(parser.getContent());
        parser.setContent($form.find(".ntc-zone-footer").html());
        $form.find("[name='footer']").val(parser.getContent());
        parser.setContent("");

        // Compile zone names to display
        $form.find("input[name='displayCheck']:checked").each(function () {
            displayArray.push(this.value);
        });
        if ($form.find("input[name='displays']").length) {
            $form.find("input[name='displays']").val(displayArray.join(","));
        } else {
            $form.append("<input type='hidden' name='displays' value='" + displayArray.join(",") + "'/>");
        }

        // Compile zones ordering
        $form.find(".ntc-sortable-zones>.ntc-zone").each(function () {
            orderArray.push(this.getAttribute("data-name"));
        });
        if ($form.find("input[name='orders']").length) {
            $form.find("input[name='orders']").val(orderArray.join(","));
        } else {
            $form.append("<input type='hidden' name='orders' value='" + orderArray.join(",") + "'/>");
        }

        // Compile other zone's element ids, including "events", "jobs", and "blogs"
        $form.find(".ntc-component-ctn").each(function () {
            var array = [],
                name = $(this).closest(".ntc-zone").attr("data-name");

            $(this).find(".ntc-component").each(function () {
                array.push(this.getAttribute("data-id"));
            });
            if ($form.find("input[name='" + name + "']").length) {
                $form.find("input[name='" + name + "']").val(array.join(","));
            } else {
                $form.append("<input type='hidden' name='" + name + "' value='" + array.join(",") + "'/>");
            }
        });

        var bodyHtmlArray = [];
        var processingContentIncomplete = false;
        var imageNotFound = false;

        $.each(orderArray, function (k, v) {
            if (displayArray.indexOf(v) > -1 && !processingContentIncomplete) {
                var $zone = $form.find(".ntc-zone[data-name='" + v + "']"),
                    zoneData = $zone.data();

                if ($zone.find(".mce-container").length) {
                    var mceContent = tinymce.get(v).getContent();
                    if (mceContent && mceContent.length > 10) {
                        $zone.find("#" + v).val(mceContent);
                        mceContent = escapeXMLEntities2(mceContent);

                        // In gmail and windows mail, for some reasons, the images max-width is not effective at all.
                        // So we have to go through each image in the body and manually set the max-width in each of them.
                        var shell = document.createElement("DIV");
                        var hasChanged = false;
                        shell.innerHTML = mceContent;

                        $.each(shell.getElementsByTagName("IMG"), function (i, img) {
                            var w = 580;
                            if (img.naturalWidth === 0 && !img.complete) {
                                imageNotFound = true;
                            } else if (img.naturalWidth > w && (img.width > w || !img.width)) {
                                var styleWidth;
                                if (img.style.width) {
                                    styleWidth = img.style.width;
                                } else if (img.style.maxWidth) {
                                    styleWidth = img.style.maxWidth;
                                }
                                if (styleWidth) {
                                    if (styleWidth.match("px")) {
                                        w = parseInt(styleWidth);
                                    } else if (styleWidth.match("%")) {
                                        w = w * parseInt(styleWidth) / 100;
                                    }
                                }
                                img.width = w;
                                hasChanged = true;
                            }
                        });
                        if (hasChanged) {
                            mceContent = shell.innerHTML;
                        }

                        bodyHtmlArray.push("<tr><td style=\"" + (zoneData.wrapStyle || "padding-top:30px;") + "\">" + mceContent + "</td></tr>");
                    }
                } else if ($zone.find(".ntc-component-ctn .ntc-component").length) {
                    var nCol = parseInt(zoneData.columns),
                        i = 0,
                        stringBuilder = "";

                    // Serialize component's heading icon and text
                    var heading = $zone.find(".ntc-component-heading")[0].value;
                    stringBuilder += heading;
                    stringBuilder += "<table style=\"" + zoneData.tableStyle + "\">";
                    $zone.find(".ntc-component-ctn .ntc-component").each(function () {
                        if (i % nCol === 0) {
                            stringBuilder += "<tr>";
                        } else if (zoneData.spacingStyle) {
                            stringBuilder += "<td style=\"" + zoneData.spacingStyle + "\"></td>";
                        }
                        // Serialize component's content
                        var content = this.querySelector("table").outerHTML;
                        stringBuilder += "<td style=\"" + zoneData.tdStyle + "\">";
                        stringBuilder += content;
                        stringBuilder += "</td>";
                        if (nCol - i % nCol === 1) {
                            stringBuilder += "</tr>";
                        }
                        i++;
                    });
                    while (i % nCol !== 0) {
                        if (zoneData.spacingStyle) {
                            stringBuilder += "<td style=\"" + zoneData.spacingStyle + "\"></td>";
                        }
                        stringBuilder += "<td style=\"" + zoneData.tdStyle + "\"></td>";
                        i++;
                        if (i % nCol === 0) {
                            stringBuilder += "</tr>";
                        }
                    }
                    stringBuilder += "</table>";

                    bodyHtmlArray.push("<tr><td style=\"" + (zoneData.wrapStyle || "padding-top:30px;") + "\">" + stringBuilder + "</td></tr>");
                }
            }
        });

        if (processingContentIncomplete) {
            setTimeout(function () {
                processTemplate($form, callback);
            }, 100);
            return null;
        }

        var body = "<table style=\"border-collapse:collapse;border:0;width:100%;\">" + bodyHtmlArray.join("") + "</table>";
        // Convert html content to valid xhtml content
        parser.setContent(body);
        body = escapeXMLEntities2(parser.getContent());
        if ($form.find("textarea[name='body']").length) {
            $form.find("textarea[name='body']").html(body);
        } else {
            $form.append("<textarea style='display:none;' name='body'>" + body + "</textarea>");
        }

        if (typeof callback === "function") {
            // Returns the callback function
            return callback(body);
        }

        // Returns the processed content
        return body;
    }
    function submitTemplate(e) {
        if (e) e.preventDefault();

        var $form = $(this);
        tools_form.validateForm($form);
        if ($form.hasClass("has-error") || g.submittingForm) {
            return false;
        }
        g.submittingForm = true;
        $form.find(".js-form-btn").addClass("disabled");

        // Process the raw data in the form
        processTemplate($form, function (content) {
            $form[0].submit();
        });
    }
    function saveAndPreviewTemplate(e) {
        if (e) e.preventDefault();

        var it = e ? e.target : this;
        var $form = $("#newsletterTemplateForm");
        tools_form.validateForm($form);
        if ($form.hasClass("has-error") || g.submittingForm) {
            return false;
        }
        g.submittingForm = true;
        $form.find(".js-form-btn").addClass("disabled");

        // Process the raw data in the form
        processTemplate($form, function (content) {
            $.ajax({
                url: $form.attr("action"),
                method: "post",
                cache: false,
                data: $form.serialize() + "&ajax=true",
                success: function success(response) {
                    var id = response.trim().substr(8);
                    if (response.indexOf("success") !== -1 && id !== "-1") {
                        if (it.hasAttribute("data-preview")) {
                            // Insert new content to preview
                            var $parser = $("#newsTempPreviewInvoker");
                            $parser.find(".newsletter-header").html($form.find(".ntc-zone-header").html());
                            $parser.find(".newsletter-footer").html($form.find(".ntc-zone-footer").html());
                            $parser.find(".newsletter-body").html(content);
                            d.getElementById("newsTempPreviewWindow").removeAttribute("data-hidden");
                            encodePreviewTemplate();
                        }
                        // Update the template id especially for a new template
                        $form.find(".ntf-id").val(id);
                        pushQueryState("nlTemplateId", id);
                    } else {
                        popErrorComplete("Une erreur s'est produite");
                    }
                    g.submittingForm = false;
                    $form.find(".js-form-btn").removeClass("disabled");
                }
            });
        });
    }

    function encodePreviewTemplate() {
        try {
            var wi = d.getElementById("newsTempPreviewWindow");
            if (!$(wi).attr("data-hidden")) {
                wi.querySelector(".news-temp-preview-parser").innerHTML = decodeEntities(d.getElementById("newsTempPreviewInvoker").innerHTML);
                wi.style.display = "block";
                $("html, body").addClass("no-scroll");
            }
        } catch (err) {}
    }

    function closeTemplatePreviewWindow() {
        closeWindow('newsTempPreviewWindow');
        $('html, body').removeClass('no-scroll');
        pushQueryState("preview");
    }

    function ntcAddComponent(e) {
        var $zone = $(this).closest(".ntc-zone"),
            $ctn = $zone.find(".ntc-component-ctn"),
            select = $zone.find(".ntc-component-select")[0],
            option = select.item(select.selectedIndex),
            data = option ? option.dataset : {},
            tempHtml = $zone.find(".ntc-component-temp").html();

        if (select.value !== "") {
            var re, p;
            for (p in data) {
                re = new RegExp("\\[\\[" + p.toUpperCase() + "\\]\\]", "g");
                tempHtml = tempHtml.replace(re, data[p]);
            }
            $ctn.append(tempHtml);
            option.setAttribute("hidden", true);
            select.value = "";
        }
    }
    function ntcDeleteComponent(e) {
        var $el = $(this).closest(".ntc-component");

        $(this).closest(".ntc-zone").find(".ntc-component-select option[value='" + $el.attr("data-id") + "']").removeAttr("hidden");
        $el.remove();
    }

    function loadEventComponents(res) {
        var array = typeof res === "string" ? JSON.parse(res) : array;
        if (array && array[0]) {
            var $ctn = $(".ntc-zone-events");
            var tempHtml = $ctn.parent().find(".ntc-component-temp").html();
            var comHtml;

            for (var i = 0; i < array.length; i++) {
                var ev = array[i];
                var date = ev.timeStart;

                // Displays only the day and date
                if (date.indexOf("Le ") > -1) {
                    date = date.substr(date.indexOf("Le ") + 3);
                }
                if (date.indexOf(" &#224;") > -1) {
                    date = date.substr(0, date.indexOf(" &#224;"));
                }
                if (date.indexOf(" at") > -1) {
                    date = date.substr(0, date.indexOf(" at"));
                }

                comHtml = tempHtml.replace(/\[\[ID\]\]/g, ev.id).replace(/\[\[NAME\]\]/g, ev.name).replace(/\[\[DATE\]\]/g, date);
                $ctn.append(comHtml);
            }
        }
    }

    function loadPastEvents(response) {
        try {
            var json = JSON.parse(response.trim());
            var select = $(".ntc-zone[data-name='events'] .ntc-component-select");
            var optionBuilder = "";

            for (var j in json) {
                var event = json[j];
                optionBuilder += "<option value='" + event.id + "' data-id='" + event.id + "' data-date='" + event.timeStart + "' data-name='" + event.name + "'>" + event.timeStart + " - " + event.name + "</option>";
            }
            select.append(optionBuilder);
        } catch (e) {
            console.error(e);
        }
    }

    function cloneNewsletterItem(e) {
        if (g.submittingForm) return false;
        g.submittingForm = true;

        $(this).closest(".table-actions").find(".clone-nlitem-form").submit();
    }

    function activateElement(e) {
        if (e) e.preventDefault();

        if (g.submittingForm) return;
        g.submittingForm = true;

        ajax(this.getAttribute("data-url"), reloadPage, true);
    }

    function editElement(e) {
        if (e) e.preventDefault();

        var $it = $(this || e.currentTarget),
            form = d.getElementById($it.attr("data-form")),
            inputs = form.elements,
            data = $it.closest("tr").data(),
            name,
            eventEl,
            eventId;

        var listIds;

        //listIds for checkbox
        if (data.listid && data.listid.length > 0 && data.listid.includes(',')) {
            listIds = data.listid.split(',');
        } else {
            listIds = data.listid;
        }

        if ($it.attr("data-hide-elements")) {
            $($it.attr("data-hide-elements"), form).hide();
        }
        if ($it.attr("data-show-elements")) {
            $($it.attr("data-show-elements"), form).show();
        }

        $.each(inputs, function (i, el) {
            if (!el.hasAttribute("ignore")) {
                name = el.name.toLowerCase();
                if (el.type === "checkbox" || el.type === "radio") {
                    if (listIds > 0 && listIds == el.defaultValue || data.listid && data.listid.length > 0 && listIds.includes(el.defaultValue)) {
                        el.checked = true;
                    } else el.checked = data.hasOwnProperty(name) && data[name] === true;
                } else {
                    el.value = data.hasOwnProperty(name) ? data[name] : "";

                    // BIND Complex selection with past and future events
                    if (name === "eventid" && data[name] != -1 && el.selectedIndex === -1) {
                        eventEl = el;
                        eventId = data[name];
                    }
                }
            }
        });

        // HANDLE Complex selection with past and future events
        if (eventEl && eventId) {
            // To modify these events, go to page/admin-registration.js
            if ($(eventEl).hasClass("registration-event-select-past")) {
                $(".registration-event-selector .select-futur-event").click();
                $(".registration-event-select").val(eventId);
            } else {
                $(".registration-event-selector .select-past-event").attr("data-extra", eventId).click();
            }
        }

        $(form).slideDown(400);
        $('html, body').animate({
            scrollTop: $(form).offset().top - $(".site-header").height()
        }, 300);
    }

    /* START Old autocomplete search */
    function autoSearchAccounts(e) {
        var inp = this,
            ctn = inp.parentElement,
            list = ctn.querySelector(".autocomplete-list"),
            icon = ctn.querySelector(".processing-loader"),
            val = inp.value.trim();

        switch (e.type) {
            case "keydown":
            case "keyup":
            case "keypress":
                var k = e.which || e.keyCode,
                    selectedItem = list.querySelector(".autocomplete-item.over"),
                    nextItem = null;

                try {
                    if (k === 13) {
                        //Enter
                        e.preventDefault();
                        chooseSearchedAccount.call(selectedItem);
                        _hideList();
                    } else if (k === 38) {
                        //Up arrow
                        e.preventDefault();
                        if (selectedItem) {
                            nextItem = selectedItem.previousElementSibling;
                        } else {
                            nextItem = list.lastElementChild;
                        }
                        overSearchedAccount.call(nextItem);
                        unoverSearchedAccount.call(selectedItem);
                        scrollElementToView(nextItem, false, list);
                    } else if (k === 40) {
                        //Down arrow
                        e.preventDefault();
                        if (selectedItem) {
                            nextItem = selectedItem.nextElementSibling;
                        } else {
                            nextItem = list.firstElementChild;
                        }
                        overSearchedAccount.call(nextItem);
                        unoverSearchedAccount.call(selectedItem);
                        scrollElementToView(nextItem, true, list);
                    }
                } catch (ex) {}
                break;
            case "input":
                _search();
                break;
            case "focus":
                if (val !== "") _showList();
                break;
            case "blur":
                setTimeout(_hideList, 100);
                break;
        }

        function _search() {
            if (searchRequest) searchRequest.abort();
            if (searchTimeout) clearTimeout(searchTimeout);

            if (val !== inp.getAttribute("data-mem")) {
                $(icon).addClass("is-processing");

                if (!val || val.length < 1) {
                    inp.setAttribute("data-mem", val);
                    _autoSearchAccountsComplete("");
                    _hideList();
                } else if (val.length === 1) {
                    inp.setAttribute("data-mem", val);
                    _autoSearchAccountsComplete();
                } else {
                    searchTimeout = setTimeout(function () {
                        inp.setAttribute("data-mem", val);
                        searchRequest = $.get({
                            url: "/action/pmiAjaxAccounts",
                            cache: false,
                            data: { q: val, count: 25 },
                            dataType: "json",
                            success: _autoSearchAccountsComplete,
                            error: function error(xhr) {
                                console.log(xhr.statusText);
                            }
                        });
                    }, searchDelay);
                }
            }
        }
        function _autoSearchAccountsComplete(response) {
            if (response !== undefined && response !== null) {
                list.innerHTML = "";
                try {
                    var o = typeof response === "string" ? JSON.parse(response) : response;
                    for (var i = 0; i < o.pmiaccounts.length; i++) {
                        var pa = o.pmiaccounts[i],
                            el = d.createElement("DIV");

                        el.className = "autocomplete-item";
                        el.setAttribute("data-id", pa.id);
                        el.innerHTML = pa.lastName + ", " + pa.firstName + " <small>" + pa.email + "</small>";
                        list.appendChild(el);
                    }
                    _showList();
                } catch (err) {}
            }

            $(icon).removeClass("is-processing");
        }

        function _showList() {
            list.style.display = "block";
        }
        function _hideList() {
            list.style.display = "none";
        }
    }
    function chooseSearchedAccount(e) {
        if (!this) throw "this is " + this;

        var $item = $(this);
        $item.closest(".input-ctn").find(".autocomplete-member-input")[0].value = this.textContent;
        $item.closest("form")[0].elements.accountId.value = this.getAttribute("data-id");
        // Clear the list leaving only the chosen element
        var clone = this.cloneNode(true);
        $item.closest(".autocomplete-list").empty().append(clone);
    }
    function overSearchedAccount(e) {
        if (!this) throw "this is " + this;

        $(this).addClass("over");
    }
    function unoverSearchedAccount(e) {
        if (!this) throw "this is " + this;

        $(this).removeClass("over");
    }
    /* END Old autocomplete search */

    function masterSearchAccount(e) {
        var btn = this,
            key = btn.getAttribute("data-key") || "",
            hasNon = key.indexOf("non") === 0,
            data = "";

        if (searchRequest) searchRequest.abort();
        if (searchTimeout) clearTimeout(searchTimeout);

        $(".list-selector-addition-loader").addClass("is-processing");
        data += "count=" + $addingList.attr("data-count");
        if (key !== "") data += "&" + (hasNon ? key.substring(3) : key) + "=" + !hasNon;
        searchRequest = $.get({
            url: "/action/pmiAjaxAccounts",
            cache: false,
            data: data,
            dataType: "json",
            success: function success(response) {
                $(".list-selector-main .processing-loader").removeClass("is-processing");
                $addingList.html("");
                try {
                    var o = typeof response === "string" ? JSON.parse(response) : response;
                    appendSearchedAccounts(o.pmiaccounts);
                } catch (err) {}
            },
            error: function error(xhr) {}
        });
    }
    function searchAccountsList(e) {
        var inp = this,
            $ctn = $(inp).closest(".list-selector-main"),
            val = inp.value.trim();

        if (searchRequest) searchRequest.abort();
        if (searchTimeout) clearTimeout(searchTimeout);

        if (val !== inp.getAttribute("data-mem")) {
            $ctn.find(".list-selector-main-search .processing-loader").addClass("is-processing");

            if (!val || val.length < 1) {
                inp.setAttribute("data-mem", val);
                _searchAccountsSuccess("");
            } else if (val.length === 1) {
                inp.setAttribute("data-mem", val);
                _searchAccountsSuccess();
            } else {
                searchTimeout = setTimeout(function () {
                    inp.setAttribute("data-mem", val);
                    searchRequest = $.get({
                        url: "/action/pmiAjaxAccounts",
                        cache: false,
                        data: "count=" + $addingList.attr("data-count") + "&q=" + val,
                        dataType: "json",
                        success: _searchAccountsSuccess,
                        error: function error(xhr) {}
                    });
                }, searchDelay);
            }
        }

        function _searchAccountsSuccess(response) {
            $ctn.find(".processing-loader").removeClass("is-processing");

            if (response !== undefined && response !== null) {
                $addingList.html("");
                try {
                    var o = typeof response === "string" ? JSON.parse(response) : response;
                    appendSearchedAccounts(o.pmiaccounts);
                } catch (err) {}
            }
        }
    }
    function appendSearchedAccounts(accounts) {
        for (var i = 0; i < accounts.length; i++) {
            var pa = accounts[i],
                el = d.createElement("DIV"),
                content = "";

            if (!d.querySelector(".pmi-account-" + pa.id)) {
                el.className = "list-selector-item";
                el.setAttribute("data-id", pa.id);
                content += "<a class='btn'></a><span>" + pa.lastName + ", " + pa.firstName + " <small>" + pa.email;
                if (pa.pmiorgJoinDate !== undefined) {
                    content += ", joined " + pa.pmiorgJoinDate;
                }
                if (pa.pmiorgExpirationDate !== undefined) {
                    content += ", expiration " + pa.pmiorgExpirationDate;
                }
                content += "</small></span>";
                el.innerHTML = content;
                if ($selectedList.find(".list-selector-item[data-id='" + pa.id + "']")[0]) {
                    $(el).addClass("hide");
                }
                $addingList.append(el);
            }
        }
    }
    function addOrRemoveItem(e) {
        var item = $(this).closest(".list-selector-item")[0];

        if ($.contains($addingList[0], item)) {
            $selectedList.append(item.cloneNode(true));
            $(item).addClass("hide");
            $(this).closest("form").find(".js-form-error-message").addClass("hide");
        } else if ($.contains($selectedList[0], item)) {
            $addingList.find(".list-selector-item[data-id='" + item.getAttribute("data-id") + "']").removeClass("hide");
            item.parentElement.removeChild(item);
        }
    }
    function addOrRemoveAllItems(e) {
        if (this.getAttribute("data-type") === "remove") {
            $addingList.children().removeClass("hide");
            $selectedList.empty();
        } else {
            $selectedList.append($addingList.children(":not(.hide)").clone(true));
            $addingList.children().addClass("hide");
            $(this).closest("form").find(".js-form-error-message").addClass("hide");
        }
    }
    function submitAccountsList(e) {
        if (e) e.preventDefault();

        if (g.submittingForm) return false;

        var listId = this.getAttribute("data-id"),
            progrsEl = d.querySelector(".list-selector-submission-progress"),
            completeCount = 0,
            selectedCount = $selectedList.children().length;

        if (selectedCount > 0) {
            g.submittingForm = true;
            progrsEl.innerHTML = "Complete... " + completeCount + "/" + selectedCount;
            $selectedList.children().each(_send);
        } else {
            $(this).closest("form").find(".js-form-error-message").removeClass("hide");
        }

        function _send() {
            var data = {
                ajax: true,
                listAccount: true,
                listId: listId,
                accountId: this.getAttribute("data-id")
            };

            $.ajax({
                url: "/action/pmiNewsletter",
                method: "post",
                cache: false,
                data: data,
                dataType: "text",
                success: _success
            });
        }

        function _success(response) {
            completeCount++;
            progrsEl.innerHTML = "Complete... " + completeCount + "/" + selectedCount;

            if (completeCount === selectedCount) reloadPage();
        }
    }

    function scrollElementToView(el, bottom, ctn) {
        var parent = ctn || el.offsetParent,
            ph = parent.clientHeight,
            st = parent.scrollTop,
            eh = el.offsetHeight,
            et = el.offsetTop;

        if (et + eh > ph + st || et < st) {
            parent.scrollTop = !bottom ? et : et + eh - ph;
        }
    }

    function subscribeAccount(e) {
        if (e) e.preventDefault();

        if (g.submittingForm) return;
        g.submittingForm = true;

        var str = "ajax=true&listAccount=true";
        str += "&id=" + $(this).closest("tr").attr("data-id");
        str += "&status=" + this.getAttribute("data-status");

        $.ajax({
            url: "/action/pmiNewsletter",
            method: "post",
            data: str,
            cache: false,
            success: reloadPage
        });
    }

    function changeComponentNewsletterList() {
        var $ctn = $($(this).closest(".newsletter-component")[0] || $(this).closest(".newsletter-outer-ctn")[0]),
            $inp = $ctn.find("input.com-settings-newsletter-list-id"),
            val = this.value;

        updateLabelLangs($inp.attr("data-key"), val, $("html").attr("langs"), function () {
            $inp.val(val);
            if (val === "") {
                $ctn.find(".com-settings-newsletter-list-alert").removeClass("hide");
            } else {
                $ctn.find(".com-settings-newsletter-list-alert").addClass("hide");
            }
        });
    }

    function optIn(captcha, form, btn) {
        var $form = $(form);
        //tools_form.validateForm($form); Form validation has already been done through the utils.recaptcha function
        if ($form.hasClass("has-error") || g.submittingForm) {
            return false;
        }
        g.submittingForm = true;

        var $success = $form.find(".ncf-success-response");
        var $error = $form.find(".ncf-error-response");

        $success.hide();
        $error.hide();
        $.ajax({
            url: "/action/pmiSubscribe",
            method: "post",
            data: "ajax=true&captcha=" + captcha + "&" + $form.serialize(),
            cache: false,
            success: function success(response) {
                g.submittingForm = false;
                if (response !== "success--1") {
                    $success.show();
                    setTimeout(function () {
                        $success.hide();
                    }, 9000);
                    $form.find("[name='firstName']").val("");
                    $form.find("[name='lastName']").val("");
                    $form.find("[name='email']").val("");
                } else {
                    $error.show();
                    setTimeout(function () {
                        $error.hide();
                    }, 9000);
                }
                grecaptcha.reset();
            },
            error: function error() {
                g.submittingForm = false;
                $error.show();
                setTimeout(function () {
                    $error.hide();
                }, 9000);
                grecaptcha.reset();
            }
        });
    }

    function initTinyMCE(selector) {
        if ($('body').hasClass('is-logged-in') && $(selector).length) {
            var settings = {
                mode: "specific_textareas",
                selector: selector,
                content_css: ["/shared/websites/www.pmi.com/assets/tinymce/newsletter.css"],
                menubar: true,
                language: $("html").attr("lang") === 'fr' ? "fr_FR" : "en_CA",
                plugins: ["image imagetools advlist autolink lists link charmap print anchor", "searchreplace visualblocks code textcolor", "insertdatetime media table contextmenu paste filemanager hr fullscreen"],
                menu: {
                    file: { title: 'File', items: 'newdocument print' },
                    edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace' },
                    insert: { title: 'Insert', items: 'filemanager link media | charmap anchor hr insertdatetime' },
                    view: { title: 'View', items: 'visualblocks visualaid' },
                    format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat' },
                    table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
                    tools: { title: 'Tools', items: 'code' }
                },
                toolbar: "undo redo | styleselect fontsizeselect | filemanager link | bold italic underline forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent ",
                relative_urls: false,
                remove_script_host: false,
                entity_encoding: "numeric",
                forced_root_blocks: "p",
                paste_as_text: true,
                contextmenu: "link inserttable | bold italic underline | cell row column deletetable | fontsizeselect",
                image_caption: true,
                image_advtab: true,
                imagetools_toolbar: "imageoptions",
                filemanager_title: $("html").attr("lang") === 'fr' ? "Gestion d'images" : "File Manager",
                theme_advanced_blockformats: "p,h1,h2,h3,h4,h5,h6,blockquote",
                fontsize_formats: "12px 13px 14px 15px 16px 18px 20px 22px 24px 28px 30px 32px 36px 40px 50px 60px",
                textcolor_cols: "7",
                textcolor_rows: "7",
                textcolor_map: mceColorMap,
                valid_elements: "*[*]"
            };

            newsletterTinyMCEInit(settings);
        }
    }

    function newsletterTinyMCEInit(settings) {
        if ((typeof tinymce === "undefined" ? "undefined" : _typeof(tinymce)) === "object") {
            tinymce.init(settings);
        } else {
            setTimeout(function () {
                initTinyMCE(settings);
            }, 1000);
        }
    }

    function parseHeadingTitles() {
        var $editZones = $(".ntc-component-heading-title-edit");
        if (!$editZones[0]) {
            return;
        }

        $editZones.each(function (i, e) {
            var $input = $(e).closest(".ntc-zone").find("textarea.ntc-component-heading");
            var $content = $("<div>" + $input.val() + "</div>");
            var $title = $content.children("h2, h3");
            var newText = e.textContent;

            if (newText !== $title.text()) {
                $title.text(newText);
                $input.val($content.html());
            }
        });

        setTimeout(parseHeadingTitles, 1000);
    }

    function init() {
        tools_form = Fw.component.models().form;
        utils_recaptcha = Fw.component.models().utils.recaptcha;

        // Newsletter Component
        $(".com-settings-newsletter-list").on("change", changeComponentNewsletterList);
        $(".newsletter-component-submit, .newsletter-email-subscribe").each(function () {
            var btn = this;
            utils_recaptcha(btn, optIn, true, $(btn).closest(".newsletter-component-inputs-outer"));
        });

        initTinyMCE(".newsletter-tiny-mce:not([id^='mce_'])");

        //INIT STOP
        if (!d.querySelector(".newsletter-zone")) return;

        encodePreviewTemplate();

        if (document.getElementById("newsTempPreviewWindow")) {
            d.querySelector("#newsTempPreviewWindow .full-window-close").onclick = closeTemplatePreviewWindow;
        }

        $(".ntc-zone-btn-up").on("click", ntczMoveUp);
        $(".ntc-zone-btn-down").on("click", ntczMoveDown);
        $(".ntc-zone-btn-display input").on("change", ntczDisplay);
        $("#newsletterTemplateForm").on("submit", submitTemplate);
        $(".ntf-save-btn").on("click", saveAndPreviewTemplate);
        // Hide placement buttons at the first and last position
        $(".ntc-zone:first-child .ntc-zone-btn-up, .ntc-zone:last-child .ntc-zone-btn-down", $(".ntc-sortable-zones")).addClass("hide");

        $(".ntc-component-btn-add").on("click", ntcAddComponent);
        $(".ntc-component-ctn").on("click", ".ntc-component-btn-delete", ntcDeleteComponent);
        $(".ntc-component-ctn").sortable({
            items: ".ntc-component",
            handle: ".ntc-component-btn-move",
            forceHelperSize: true,
            tolerance: "pointer",
            opacity: 0.8
        });
        // Ajax load the event to the component list
        if ($(".ntc-zone-events").attr("data-ids")) {
            ajax("/action/pmiAjaxGetEvent?ids=" + $(".ntc-zone-events").attr("data-ids"), loadEventComponents, true);
        }
        // Ajax load all the past events to the select
        ajax("/action/pmiEvent?getPastEvents=true", loadPastEvents, true);

        $(".clone-nlitem-btn").on("click", cloneNewsletterItem);

        $(".activate-btn, .deactivate-btn").on("click", activateElement);
        $(".edit-nlelement").on("click", editElement);

        $addingList = $(".list-selector-main-items.list-selector-addition");
        $selectedList = $(".list-selector-main-items.list-selector-selection");
        $(".unsubs-nl-account, .subs-nl-account").on("click", subscribeAccount);
        // Deprecated
        $(".autocomplete-member-input").on("keydown input focus blur", autoSearchAccounts);
        $(".autocomplete-list").on("click", ".autocomplete-item", chooseSearchedAccount);
        $(".autocomplete-list").on("mouseover", ".autocomplete-item", overSearchedAccount);
        $(".autocomplete-list").on("mouseout", ".autocomplete-item", unoverSearchedAccount);
        // New
        $(".list-selector-master-btn").on("click", masterSearchAccount);
        $(".list-selector-main-search input").on("input", searchAccountsList);
        $(".list-selector-main-items").on("click", ".btn", addOrRemoveItem);
        $(".list-selector-all-btn").on("click", addOrRemoveAllItems);
        $(".create-subscribers-btn").on("click", submitAccountsList);

        // Detect changes in the double-click sitelabel and parse the new text in the hidden input
        parseHeadingTitles();

        $(".selectBox-campaign").on("click", function () {
            var checkboxes = $("#checkboxes-campaign");
            if (!expanded) {
                checkboxes.show();
                expanded = true;
            } else {
                checkboxes.hide();
                expanded = false;
            }
        });
        $("#checkboxes-campaign input[type='checkbox']").on("change", getCampaignCheckedValues);
    }

    function getCampaignCheckedValues() {
        var selectedCampaign = [];
        $("input[type='checkbox']:checked").each(function () {
            if ($(this).val() != 'on') selectedCampaign.push($(this).val());
        });

        $('#newsletterCampaignForm input[name="listId"]').val(selectedCampaign.join(','));
    }

    $(g).ready(init);
})(jQuery, document, window);
/*
function putListAccount(listId, pmiNumber, email, firstName, lastName) {
    $.get({
        url: "/action/pmiAjaxAccounts",
        cache: false,
        data: "count=1&q=" + pmiNumber,
        dataType: "json",
        success: function(resp) {
            try {
                var o = typeof resp === "string" ? JSON.parse(resp) : resp;
                var pa = o.pmiaccounts[0];
                var dat = {
                    ajax: true,
                    listAccount: true,
                    listId: listId
                };
                if (pa && pa.id) {
                    dat.accountId = pa.id;
                } else {
                    dat.email = email;
                    dat.firstName = firstName;
                    dat.lastName = lastName;
                }

                $.ajax({
                    url: "/action/pmiNewsletter",
                    method: "post",
                    cache: false,
                    data: dat,
                    dataType: "text"
                });
            } catch (err) {
                console.err(err);
            }
        },
        error: function(xhr) {}
    });
}*/
'use strict';

(function ($, undefined) {

	'use strict';

	var exportJson = function exportJson() {
		var selected = $('.mg2_manageGenList_item').filter(function () {
			return $('input[name="mg2_manageGenList_item_checkbox"]', $(this)).is(':checked');
		});

		var json = {};

		selected.each(function () {
			var info = $('.mg2_manageGenList_item_info', $(this));
			var id = info.attr('data-id');
			var total = parseInt(info.attr('data-attr-total'));
			var extraData = info.attr('data-extradata');

			json[id] = {
				id: id,
				extraData: extraData
			};

			for (var i = 0; i <= total; i++) {
				if (info.attr('field' + i) !== undefined) {
					json[id]['field' + i] = info.attr('field' + i);
				}
			}
		});

		$('.mg2_manageGenList_result').html(JSON.stringify(json));
	};

	var importJson = function importJson() {
		var jsonString = $('.mg2_manageGenList_import').val();
		var json = JSON.parse(jsonString);
		var count = 0;
		var total = Object.keys(json).length;

		for (var key in json) {
			var data = {
				extraData: json[key].extraData,
				ajax: true
			};

			for (var k = 1; k <= 26; k++) {
				data['field' + k] = json[key]['field' + k];
			}

			//Fetch id for duplicates
			$('.mg2_manageGenList_adminid').each(function () {
				if ($(this).html() === json[key].field11) {
					data.id = $(this).closest('.mg2_manageGenList_item').find('.mg2_manageGenList_item_info').attr('data-id');
				}
			});

			console.log(data);

			//ajax
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				success: function success(response) {
					count++;

					if (count === total) {
						alert('Done!');
					}
				}
			});
		}
	};

	var init = function init() {
		exportJson();

		$('input[name="mg2_manageGenList_item_checkbox"]').change(exportJson);
		$('.mg2_manageGenList_import_btn').click(importJson);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function ($, d, g) {
    'use strict';

    // --- Configurations & Cache Settings ---

    var CACHE_KEY = "member_directory_all_data";
    var CACHE_TIME_KEY = "member_directory_all_timestamp";
    var CACHE_DURATION = 1000 * 60 * 60 * 4; // 4 Hours Expiration Guard
    var ITEMS_PER_PAGE = 10;

    var allMembers = [];
    var filteredMembers = [];
    var currentPage = 1;

    // Detect if Admin is logged in based on shell attribute
    var isAdmin = $(".shell").attr("data-admin-logged") === "true";
    var urlParams = new URLSearchParams(window.location.search);
    var activeMemberID = urlParams.get('mID');

    var filterData = {
        "Type of Connection": ["Networking / Career opportunities", "Consulting / freelance opportunities", "Expertise requests", "Speaking opportunities", "Chapter Leadership", "Volunteering", "Job Search"],
        "Experience Level": ["Student", "Entry Level", "Associate", "Mid-Senior", "Director", "Executive"],
        "Industry": ["Aerospace", "Architecture/Engineering", "Construction", "Automotive", "Chemical", "Education", "Energy and Utilities", "Financial Services", "Food/Entertainment", "Hospitality", "Healthcare", "Manufacturing", "Media", "Non-profit", "Professional Services", "Real Estate", "Technology", "Telecommunication", "Other"],
        "Expertise": ["Business Analysis", "Change Management", "Leadership", "Organizational Design", "Portfolio Management", "Program Management", "Project Management", "Project Management Office (PMO)/Enterprise PMO", "Risk Management", "Strategy", "Other"],
        "Location": ["Manhattan", "Brooklyn", "Queens", "Bronx", "Staten Island", "Long Island or Westchester", "NYS Other", "Tristate", "US – outside tristate", "International"],
        "Certifications": ["PMP", "CAPM", "PgMP", "PMI-ACP", "CPMAI", "Accounting", "Amazon Web Services", "Construction", "Energy and Environmental", "Engineering", "Finance", "Google", "Healthcare", "Human Resources", "Information Technology", "Management", "Microsoft", "Six Sigma / Quality", "Supply Chain", "Other"]
    };

    var profileGroups = {
        "typeConn": ["Networking / Career opportunities", "Consulting / freelance opportunities", "Expertise requests", "Speaking opportunities", "Chapter Leadership", "Volunteering", "Job Search"],
        "industry": ["Aerospace", "Architecture/Engineering", "Construction", "Automotive", "Chemical", "Education", "Energy and Utilities", "Financial Services", "Food/Entertainment", "Hospitality", "Healthcare", "Manufacturing", "Media", "Non-profit", "Professional Services", "Real Estate", "Technology", "Telecommunication", "Other"],
        "projExp": ["Business Analysis", "Change Management", "Leadership", "Organizational Design", "Portfolio Management", "Program Management", "Project Management", "Project Management Office (PMO)/Enterprise PMO", "Risk Management", "Strategy", "Other"],
        "workLocation": ["Manhattan", "Brooklyn", "Queens", "Bronx", "Staten Island", "Long Island or Westchester", "NYS Other", "Tristate", "US – outside tristate", "International"],
        "nonPmiCert": ["Accounting", "Amazon Web Services", "Construction", "Energy and Environmental", "Engineering", "Finance", "Google", "Healthcare", "Human Resources", "Information Technology", "Management", "Microsoft", "Six Sigma / Quality", "Supply Chain", "Other"]
    };

    function init() {
        // Initialize dynamic DOM setups
        if ($("#filterGroups").length > 0) initFilters();
        if ($("#profileChecks").length > 0) initProfileGroups();

        // LOAD DATA: Cache-first fetching flow
        fetchAndLoadMembers();
        updateLivePreview();

        // Match checkbox values to URL params (if present)
        var params = new URLSearchParams(window.location.search);
        var $filterForm = $("#memberDirectoryFilterForm");
        params.forEach(function (value, key) {
            $filterForm.find("input[name='" + key + "'][value='" + value + "']").prop('checked', true);
        });

        // Tab State Router Setup
        if ($('.tab').length > 0) {
            $('.tab').on('click', function (e) {
                e.preventDefault();
                var tabId = $(this).data('tab');
                if (tabId) {
                    sessionStorage.setItem('activeMemDirTab', tabId);
                    activateMemberDirTab(tabId);
                }
            });

            var savedTab = sessionStorage.getItem('activeMemDirTab');
            activateMemberDirTab(savedTab && $('#' + savedTab).length > 0 ? savedTab : 'directory');
        }

        $("#refreshDirectory").on("click", function (e) {
            e.preventDefault();

            localStorage.removeItem(CACHE_KEY);
            localStorage.removeItem(CACHE_TIME_KEY);

            fetchAndLoadMembers(true);
        });

        // Clear Filters Action
        $("#clearFilters").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $("#filterGroups input[type='checkbox']").prop("checked", false);
            $("#search").val("");
            $("#activeCount").text("0 active");
            filteredMembers = [].concat(_toConsumableArray(allMembers));
            currentPage = 1;
            renderDirectory();
        });

        // Search & Filter Events
        $("#searchBtn").on("click", function () {
            currentPage = 1;applyFiltersAndSearch();
        });
        $("#search").on("keydown", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                currentPage = 1;
                applyFiltersAndSearch();
            }
        });
        $("#applyFilters").on("click", function () {
            currentPage = 1;applyFiltersAndSearch();
        });
        $("#sort").on("change", function () {
            currentPage = 1;renderDirectory();
        });

        // Visibility toggler handler
        $(".member-search-visibility").on("change", handleVisibilityToggle);

        // CSV Export
        $("#exportCsv").on("click", function () {
            var rows = [["First Name", "Last Name", "Preferred Name", "Email", "Certification", "About Me", "Company", "Experience", "Industry", "Expertise", "Location", "Non-PMI Certification", "Connections", "LinkedIn"]].concat(_toConsumableArray(filteredMembers.map(function (m) {
                return [m.first, m.last, m.preferName, m.email, m.cert, m.about, m.company, m.experience, m.industry, m.expertise, m.location, m.nonPmiCert, m.typeConn, m.linkedin];
            })));
            var csv = rows.map(function (r) {
                return r.map(function (v) {
                    return "\"" + String(v || "").replace(/"/g, '""') + "\"";
                }).join(",");
            }).join("\n");
            var a = document.createElement("a");
            a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8;" }));
            a.download = "member-directory-results.csv";
            a.click();
            URL.revokeObjectURL(a.href);
        });

        // Prevent manual tampering of readonly fields
        $("input[readonly]").on("keydown paste change focus", function (e) {
            $(this).blur();
            e.preventDefault();
            return false;
        });

        // Precheck Multi-select Checkboxes on profile edit load
        var fieldMappings = [{ hidden: 'typeConnValue', cbName: 'typeConn_cb' }, { hidden: 'industryValue', cbName: 'industry_cb' }, { hidden: 'projExpValue', cbName: 'projExp_cb' }, { hidden: 'workLocationValue', cbName: 'workLocation_cb' }, { hidden: 'nonPmiCertValue', cbName: 'nonPmiCert_cb' }];

        fieldMappings.forEach(function (map) {
            var $hiddenInput = $("#" + map.hidden);
            if ($hiddenInput.length && $.trim($hiddenInput.val()) !== '') {
                var selectedValues = $hiddenInput.val().split(/[,;]/).map(function (v) {
                    return $.trim(v).toLowerCase();
                });
                $("input[name='" + map.cbName + "']").each(function () {
                    if (selectedValues.indexOf($(this).val().toLowerCase()) !== -1) {
                        $(this).prop('checked', true);
                    }
                });
            }
        });

        // Real-time DOM values sync
        $('#profileForm').on('change', 'input[type="checkbox"]', function () {
            var name = $(this).attr('name');
            if (name && name.endsWith('_cb')) {
                var baseName = name.replace('_cb', '');
                updateHiddenInput(name, baseName + 'Value');
            }
            updateLivePreview();
        });

        // Save Profile via Validation & AJAX Context Syncing
        $("#profileForm").on("submit", function (e) {
            e.preventDefault();

            if (!validateProfileForm()) return false;

            updateHiddenInput('typeConn_cb', 'typeConnValue');
            updateHiddenInput('industry_cb', 'industryValue');
            updateHiddenInput('projExp_cb', 'projExpValue');
            updateHiddenInput('workLocation_cb', 'workLocationValue');
            updateHiddenInput('nonPmiCert_cb', 'nonPmiCertValue');

            var form = this;
            var actionUrl = $(form).attr("action");
            //const formData = $(form).serialize();
            var formData = new FormData(form);

            $.ajax({
                url: actionUrl,
                method: "POST",
                data: formData,
                processData: false,
                contentType: false,
                success: function success() {
                    localStorage.removeItem(CACHE_KEY);
                    localStorage.removeItem(CACHE_TIME_KEY);

                    $("#saveStatus").addClass("show");
                    setTimeout(function () {
                        return $("#saveStatus").removeClass("show");
                    }, 4000);

                    fetchAndLoadMembers(true);
                    // window.location.reload();
                },
                error: function error(err) {
                    console.error("Save profile error", err);
                    alert("Unable to save profile context. Check network connections and try again.");
                }
            });
        });

        // Image file picker listener
        $("#photo").on("change", function (e) {
            var file = e.target.files[0];

            $("#removeMedia").val("false");

            if (!file) return;
            var reader = new FileReader();
            reader.onload = function () {
                $("#uploadPreviewImg").attr("src", reader.result);
                $("#uploadPreviewCtn").css("display", "inline-block");
                $("#fileInputWrap").hide();
                $("#previewAvatar").html("<img src=\"" + reader.result + "\" alt=\"Profile preview\" style=\"width:100%;height:100%;object-fit:cover;border-radius:50%\">");
            };
            reader.readAsDataURL(file);
        });

        // Remove photo handler
        $("#removePhoto").on("click", function () {
            $("#removeMedia").val("true");
            $("#photo").val("");
            $("#uploadPreviewCtn").hide();
            $("#uploadPreviewImg").attr("src", "");
            $("#fileInputWrap").show();

            var firstName = $.trim($("#firstName").val() || "");
            var lastName = $.trim($("#lastName").val() || "");
            var displayName = $.trim($("#preferredName").val() || "") || firstName;

            var firstInitial = displayName.charAt(0).toUpperCase();
            var lastInitial = lastName.charAt(0).toUpperCase();
            $("#previewAvatar").text(firstInitial + lastInitial);
        });

        // Watch profile live edits (inputs, textareas, and selects)
        ["preferredName", "company", "about", "linkedin"].forEach(function (id) {
            $("#" + id).on("input", updateLivePreview);
        });
        $("select[name='experience']").on("change", updateLivePreview);

        // Edit button handler in Directory Search (Admin mode)
        $("#cards").on("click", ".edit-member-btn", function () {
            var memberId = $(this).data("id");
            if (memberId) {
                // Set the profile tab as active upon reload
                sessionStorage.setItem('activeMemDirTab', 'profile');
                // Redirect to loaded member's context
                window.location.href = window.location.pathname + "?mID=" + memberId;
            }
        });

        // Direct Deletion Action (Admins only, inside visibility panel)
        $("#deleteProfileAdmin").on("click", function (e) {
            e.preventDefault();
            if (!activeMemberID) return;

            var name = $("#previewName").text() || "this user";
            var message = "Are you sure you want to continue? This action can be reversed later.";

            showConfirmModal(message, function () {
                $.ajax({
                    url: "/action/deleteMemberProfile",
                    method: "POST",
                    data: { pmiID: activeMemberID },
                    success: function success() {
                        localStorage.removeItem(CACHE_KEY);
                        localStorage.removeItem(CACHE_TIME_KEY);
                        alert("Profile status has been updated.");
                        // Redirect back to standard directory without mID parameter
                        //window.location.href = window.location.pathname;
                        window.location.reload();
                    },
                    error: function error(err) {
                        console.error("Delete profile error", err);
                        alert("Failed to delete the profile. Please check permissions and try again.");
                    }
                });
            });
        });
    }

    // --- Loading & Caching Middleware ---
    function fetchAndLoadMembers() {
        var forceRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var cachedData = localStorage.getItem(CACHE_KEY);
        var cachedTime = localStorage.getItem(CACHE_TIME_KEY);
        var now = Date.now();

        if (!forceRefresh && cachedData && cachedTime && now - cachedTime < CACHE_DURATION) {
            allMembers = JSON.parse(cachedData);
            filteredMembers = [].concat(_toConsumableArray(allMembers));
            renderDirectory();
            return;
        }

        $("#cards").html('<div class="empty"><h3>Loading directory Members...</h3></div>');

        $.ajax({
            url: "/action/directoryMembers",
            method: "GET",
            dataType: "json",
            success: function success(data) {
                allMembers = data;
                filteredMembers = [].concat(_toConsumableArray(allMembers));

                localStorage.setItem(CACHE_KEY, JSON.stringify(data));
                localStorage.setItem(CACHE_TIME_KEY, now);

                renderDirectory();
            },
            error: function error(err) {
                if (cachedData) {
                    allMembers = JSON.parse(cachedData);
                    filteredMembers = [].concat(_toConsumableArray(allMembers));
                    renderDirectory();
                } else {
                    $("#cards").html('<div class="empty"><h3>No members directory found</h3><p>Try clearing filters or broadening search parameters.</p></div>');
                }
            }
        });
    }

    // --- Render Pagination Controls ---
    function renderPagination(totalItems) {
        var totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
        var $paginationCtn = $("#paginationContainer");

        if (totalPages <= 1) {
            $paginationCtn.empty();
            return;
        }

        var buttonsHtml = "<div class=\"pagination-bar\">";
        buttonsHtml += "<button class=\"pagination-btn\" id=\"paginationPrev\" " + (currentPage === 1 ? 'disabled' : '') + ">Back</button>";

        for (var i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || i >= currentPage - 2 && i <= currentPage + 2) {
                buttonsHtml += "<button class=\"pagination-btn " + (currentPage === i ? 'active' : '') + "\" data-page=\"" + i + "\">" + i + "</button>";
            } else if (i === currentPage - 3 || i === currentPage + 3) {
                buttonsHtml += "<span style=\"padding: 0 4px\">...</span>";
            }
        }

        buttonsHtml += "<button class=\"pagination-btn\" id=\"paginationNext\" " + (currentPage === totalPages ? 'disabled' : '') + ">Next</button>";
        buttonsHtml += "</div>";

        $paginationCtn.html(buttonsHtml);

        $(".pagination-btn").on("click", function () {
            if ($(this).is(":disabled")) return;

            var targetPage = parseInt($(this).data("page"), 10);
            if ($(this).attr("id") === "paginationPrev") {
                targetPage = currentPage - 1;
            } else if ($(this).attr("id") === "paginationNext") {
                targetPage = currentPage + 1;
            }

            if (targetPage && targetPage !== currentPage) {
                currentPage = targetPage;
                renderDirectory();
                $('html, body').animate({ scrollTop: $("#directory").offset().top - 80 }, 200);
            }
        });
    }

    // --- Dynamic Filters Rendering ---
    function initFilters() {
        $("#filterGroups").html(Object.entries(filterData).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                g = _ref2[0],
                opts = _ref2[1];

            return "\n            <div class=\"fg closed\">\n                <button type=\"button\" aria-expanded=\"false\">\n                    <span>" + g + "</span>\n                    <span class=\"arrow-indicator\">\u25BC</span>\n                </button>\n                <div class=\"opts\">\n                    " + opts.map(function (o) {
                return "<label class=\"opt\"><input type=\"checkbox\" data-group=\"" + g + "\" value=\"" + o + "\"/> " + o + "</label>";
            }).join("") + "\n                </div>\n            </div>\n        ";
        }).join(""));

        $(".fg > button").on("click", function () {
            var $g = $(this).parent();
            $g.toggleClass("closed");
            var isClosed = $g.hasClass("closed");
            $(this).find(".arrow-indicator").text(isClosed ? "▼" : "▲");
            $(this).attr("aria-expanded", !isClosed);
        });

        $("#filterGroups input").on("change", function () {
            var n = $("#filterGroups input:checked").length;
            $("#activeCount").text(n + " active");
        });
    }

    // --- Dynamic Checkbox Grid Builder ---
    function initProfileGroups() {
        $("#profileChecks").html(Object.entries(profileGroups).map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                g = _ref4[0],
                opts = _ref4[1];

            return "\n            <div class=\"section\">\n                <div class=\"legend\" style=\"text-transform: capitalize;\">" + g.replace('Value', '').replace('typeConn', 'Types of Connection').replace('projExp', 'Expertise').replace('workLocation', 'Work Location').replace('nonPmiCert', 'Non-PMI Certifications') + " " + (g !== 'nonPmiCert' ? ' *' : '') + "</div>\n                <div class=\"checkgrid\">\n                    " + opts.map(function (o) {
                return "<label class=\"opt\"><input type=\"checkbox\" name=\"" + g + "_cb\" value=\"" + o + "\"/> " + o + "</label>";
            }).join("") + "\n                </div>\n            </div>\n        ";
        }).join(""));
    }

    // --- In-Memory Search Engine ---
    function applyFiltersAndSearch() {
        var queryTerms = $("#search").val().toLowerCase().split(",").map(function (x) {
            return x.trim();
        }).filter(Boolean);
        var selectedFilters = {};

        $("#filterGroups input:checked").each(function () {
            var group = $(this).data('group');
            if (!selectedFilters[group]) selectedFilters[group] = [];
            selectedFilters[group].push($(this).val().toLowerCase());
        });

        filteredMembers = allMembers.filter(function (m) {
            var haystack = Object.values(m).join(" ").toLowerCase();
            // if (queryTerms.length && !queryTerms.some(term => haystack.includes(term))) {
            //     return false;
            // }
            if (queryTerms.length && !queryTerms.some(function (term) {
                var escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                var wordPattern = new RegExp("\\b" + escapedTerm + "\\b", 'i');

                return wordPattern.test(haystack);
            })) {
                return false;
            }

            var schemaMap = {
                "Experience Level": "experience",
                "Industry": "industry",
                "Expertise": "expertise",
                "Location": "location",
                "Certifications": "cert",
                "Type of Connection": "typeConn"
            };

            return Object.entries(selectedFilters).every(function (_ref5) {
                var _ref6 = _slicedToArray(_ref5, 2),
                    groupTitle = _ref6[0],
                    selectedArray = _ref6[1];

                var targetKey = schemaMap[groupTitle];
                var memberValue = (m[targetKey] || "").toLowerCase();
                return selectedArray.some(function (val) {
                    return memberValue.includes(val);
                });
            });
        });

        renderDirectory();
    }

    // --- Main Directory Grid Rendering Engine ---
    function renderDirectory() {
        if ($("#cards").length === 0) return;

        var sortMode = $("#sort").val();
        var sortKey = sortMode === "first" ? "first" : sortMode === "company" ? "company" : "last";

        filteredMembers.sort(function (a, b) {
            var valA = (a[sortKey] || "").toString().trim();
            var valB = (b[sortKey] || "").toString().trim();
            return valA.localeCompare(valB);
        });

        $("#resultCount").text(filteredMembers.length + " member" + (filteredMembers.length === 1 ? "" : "s"));

        var startOffset = (currentPage - 1) * ITEMS_PER_PAGE;
        var pageSlice = filteredMembers.slice(startOffset, startOffset + ITEMS_PER_PAGE);

        if (pageSlice.length === 0) {
            $("#cards").html("<div class=\"empty\"><h3>No members directory found</h3><p>Try clearing filters or broadening search parameters.</p></div>");
            $("#paginationContainer").empty();
            return;
        }

        $("#cards").html(pageSlice.map(function (m) {
            var memberId = m.pmiNumber || m.id || m.pmiID || "";

            var displayName = m.preferName ? ((m.first || "") + " (" + m.preferName + ") " + (m.last || "")).trim() : ((m.first || "") + " " + (m.last || "")).trim();

            var initials = "" + (m.first ? m.first.charAt(0).toUpperCase() : "") + ("" + (m.last ? m.last.charAt(0).toUpperCase() : ""));

            return "\n            <div class=\"directory-profile-card\">\n\n                <div class=\"directory-summary\">\n\n                    <div class=\"directory-summary-left\">\n\n                        <div class=\"avatar\">\n                            " + (Number(m.mediaId) > 0 ? "<img src=\"/static/uploaded/MemberDirectoryImages/" + m.mediaId + "-preview.jpg\" alt=\"" + displayName + "\">" : initials) + "\n                        </div>\n\n                        <div class=\"directory-summary-content\" style=\"margin-top: 15px\">\n                            <h3>" + displayName + "</h3>\n\n                            " + (m.company ? "\n                                <div class=\"company\">\n                                    " + m.company + "\n                                </div>\n                            " : "") + "\n                        </div>\n                    </div>\n\n                    <div class=\"directory-summary-right\">\n                        " + (isAdmin && memberId ? "<button type=\"button\" class=\"iconbtn edit-member-btn\" onclick=\"window.location.href='members-search?mID=" + memberId + "'\"  \n                        style=\"border-color: var(--p); color: var(--p);\">\u270F\uFE0F Edit Profile</button>" : "") + "\n\n\n                        " + (m.linkedin ? "\n                            <a\n                                class=\"linkedin-btn\"\n                                href=\"" + m.linkedin + "\"\n                                target=\"_blank\"\n                                rel=\"noopener noreferrer\">\n                                LinkedIn \u2197\n                            </a>\n                        " : "") + "\n                    </div>\n                </div>\n                <div style=\"margin: 18px\">\n\n                    <aside class=\"profile-preview-sidebar\">\n\n                        " + (m.about ? "\n                                <div class=\"preview-about\">\n                                    <h4>About Me</h4>\n                                    <p>" + m.about + "</p>\n                                </div>\n                            " : "") + "\n\n                        " + (isAdmin && memberId ? "\n                            <div class=\"preview-section preview-admin-section\">\n\n                                <div class=\"preview-section-title\">\n                                    Administrative Information\n                                </div>\n\n                                <div class=\"preview-details\">\n\n                                    <div class=\"preview-detail-row\">\n                                        <span class=\"preview-detail-label\">PMI Number</span>\n                                        <strong class=\"preview-detail-value\">#" + memberId + "</strong>\n                                    </div>\n\n                                    <div class=\"preview-detail-row\">\n                                        <span class=\"preview-detail-label\">Email</span>\n                                        <strong class=\"preview-detail-value\">" + (m.email || "") + "</strong>\n                                    </div>\n\n                                </div>\n\n                            </div>\n                        " : "") + "\n\n                    </aside>\n\n                    <div class=\"summary-tags\">\n\n                        " + (m.cert ? "\n                            <span class=\"tag\">\n                                \uD83C\uDFC5 " + m.cert + "\n                            </span>\n                        " : "") + " \n\n                        " + (m.experience ? "\n                            <span class=\"tag\">\n                                \uD83D\uDCBC " + m.experience + "\n                            </span>\n                        " : "") + "\n                        \n                        " + (m.location ? "\n                            <span class=\"tag\">\n                                \uD83D\uDCCD " + m.location + "\n                            </span>\n                        " : "") + "\n\n                    </div>\n                </div>\n\n                <div class=\"directory-details\">\n\n                    <div class=\"directory-info-grid\">\n\n                        " + (m.typeConn ? "\n                            <div class=\"directory-info-item\">\n                                <strong>\uD83E\uDD1D Connections</strong>\n                                <div>" + m.typeConn + "</div>\n                            </div>\n                        " : "") + "\n\n                        " + (m.industry ? "\n                            <div class=\"directory-info-item\">\n                                <strong>\uD83C\uDFF7\uFE0F Industry</strong>\n                                <div>" + m.industry + "</div>\n                            </div>\n                        " : "") + "\n\n                        " + (m.expertise ? "\n                            <div class=\"directory-info-item\">\n                                <strong>\uD83D\uDCA1 Expertise</strong>\n                                <div>" + m.expertise + "</div>\n                            </div>\n                        " : "") + "\n\n                        " + (m.nonPmiCert ? "\n                            <div class=\"directory-info-item\">\n                                <strong>\uD83D\uDCDC Non-PMI Certifications</strong>\n                                <div>" + m.nonPmiCert + "</div>\n                            </div>\n                        " : "") + "\n\n                    </div>\n\n                </div>\n\n            </div>\n            ";
        }).join(""));

        renderPagination(filteredMembers.length);
    }

    $("#cards").on("click", ".directory-summary", function (e) {

        if ($(e.target).closest(".linkedin-btn").length) return;

        var card = $(this).closest(".directory-profile-card");

        $(".directory-profile-card").not(card).removeClass("expanded");

        card.toggleClass("expanded");
    });

    $("#cards").on("click", ".linkedin-btn", function (e) {

        e.stopPropagation();
    });

    // --- Validation Logic ---
    function validateProfileForm() {
        $(".input-error").removeClass("input-error");
        $(".error-text").remove();

        var isValid = true;

        var markErr = function markErr(id, message) {
            var $field = $("#" + id);
            $field.addClass("input-error");
            $field.after("<span class=\"error-text\">" + message + "</span>");
            isValid = false;
        };

        if ($.trim($("#firstName").val()) === "") markErr("firstName", "First Name is required.");
        if ($.trim($("#lastName").val()) === "") markErr("lastName", "Last Name is required.");

        var email = $.trim($("#email").val());
        if (email === "" || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            markErr("email", "Please enter a valid email.");
        }

        if ($.trim($("#phone").val()) === "") markErr("phone", "Phone is required.");

        var linkedin = $.trim($("input[name='linkedInUrl']").val());
        var linkedinReg = /^https?:\/\/(www\.)?linkedin\.com\/[^\s]+$/i;
        if (linkedin === "" || !linkedinReg.test(linkedin)) {
            markErr("linkedin", "Please enter a valid LinkedIn URL");
        }

        if (!$("select[name='experience']").val()) {
            markErr("experience", "Experience Selection is required.");
        }

        var groupsToVerify = ['typeConn_cb', 'industry_cb', 'projExp_cb', 'workLocation_cb'];
        groupsToVerify.forEach(function (name) {
            if ($("input[name='" + name + "']:checked").length === 0) {
                var $ctn = $("input[name='" + name + "']").closest('.section');
                $ctn.addClass("input-error");
                $ctn.append('<span class="error-text">Please select at least one option.</span>');
                isValid = false;
            }
        });

        if ($("input[name='termsCheck']").length && !$("input[name='termsCheck']").is(':checked')) {
            var $group = $("input[name='termsCheck']").closest('.section');
            $group.addClass("input-error");
            $group.append('<span class="error-text">Please accept the required terms to continue.</span>');
            isValid = false;
        }

        if (!isValid) {
            $('html, body').animate({ scrollTop: $(".input-error").first().offset().top - 120 }, 300);
        }

        return isValid;
    }

    function updateHiddenInput(cbName, hiddenId) {
        var values = $("input[name=\"" + cbName + "\"]:checked").map(function () {
            return $(this).val();
        }).get().join(', ');
        $("#" + hiddenId).val(values);
    }

    function activateMemberDirTab(tabId) {
        if (!tabId) return;
        $('.tab').removeClass('active');
        $('.panel').removeClass('active');
        $(".tab[data-tab=\"" + tabId + "\"]").addClass('active');
        $('#' + tabId).addClass('active');
    }

    // --- Side Preview Dynamic Synchronizer ---
    function updateLivePreview() {
        var first = $.trim($("#firstName").val() || "");
        var last = $.trim($("#lastName").val() || "");
        var pref = $.trim($("#preferredName").val() || "");
        var comp = $.trim($("#company").val() || "");
        var about = $.trim($("#about").val() || "");
        var linkedin = $.trim($("#linkedin").val() || "");

        var displayName = pref || first;

        // Identity Strings Sync (With matching emoji integration)
        if ($("#previewName").length) $("#previewName").text((displayName + " " + last).trim());
        if ($("#previewCompany").length) $("#previewCompany").text(comp ? "\uD83C\uDFE2 " + comp : "Company not provided");
        if ($("#previewAbout").length) $("#previewAbout").text(about || "No About Me content provided.");
        if ($("#previewLinkedin").length) $("#previewLinkedin").attr("href", linkedin || "#").css("display", linkedin ? "flex" : "none");
        if ($("#aboutCount").length) $("#aboutCount").text(about.length);

        // Standard Fallback Avatar Setup
        if ($("#previewAvatar").length && !$("#previewAvatar").find("img").length) {
            var firstInitial = displayName.charAt(0).toUpperCase();
            var lastInitial = last.charAt(0).toUpperCase();
            $("#previewAvatar").text(firstInitial + lastInitial);
        }

        // Professional Selection Box Text Synchronizer (Appends matching icon prefixes)
        var blockMappings = [{ name: 'experience_cb', label: '💼 Experience', target: 'experience' }, { name: 'typeConn_cb', label: '🤝 Types of Connections', target: 'typeConn' }, { name: 'industry_cb', label: '🏷️ Industry', target: 'industry' }, { name: 'projExp_cb', label: '💡 Expertise', target: 'projExp' }, { name: 'workLocation_cb', label: '📍 Work Location', target: 'workLocation' }, { name: 'nonPmiCert_cb', label: '📜 Non-PMI Certifications', target: 'nonPmiCert' }];

        blockMappings.forEach(function (mapping) {
            var selectedText = '';

            if (mapping.target === 'experience') {
                selectedText = $("select[name='experience']").val() || '';
            } else {
                selectedText = $("input[name=\"" + mapping.name + "\"]:checked").map(function () {
                    return $(this).val();
                }).get().join(', ');
            }
        });
    }

    function showConfirmModal(message, onConfirm, onCancel) {
        $("#modalText").text(message);
        $("#modal").addClass("open");

        $("#modalConfirm").off("click").on("click", function () {
            $("#modal").removeClass("open");
            if (typeof onConfirm === "function") onConfirm();
        });

        $("#modalCancel").off("click").on("click", function () {
            $("#modal").removeClass("open");
            if (typeof onCancel === "function") onCancel();
        });
    }

    function handleVisibilityToggle() {
        var checkbox = this;
        var isChecked = checkbox.checked;
        var action = isChecked ? "ENABLE" : "DISABLE";
        var message = "Are you sure you want to " + action + " your visibility?";

        checkbox.checked = !isChecked;

        showConfirmModal(message, function () {
            checkbox.checked = isChecked;
            var pmiID = $.trim($("input[name='pmiID']").val());

            $.ajax({
                url: "/action/changeVisibility",
                method: "POST",
                data: { status: isChecked, pmiID: pmiID },
                success: function success() {
                    localStorage.removeItem(CACHE_KEY);
                    localStorage.removeItem(CACHE_TIME_KEY);
                    window.location.reload();
                },
                error: function error() {
                    alert("Could not save visibility settings. Try again later.");
                    checkbox.checked = !isChecked;
                }
            });
        }, function () {
            checkbox.checked = !isChecked;
        });
    }

    $(g).ready(init);
})(jQuery, document, window);
'use strict';

(function ($, undefined) {

	'use strict';

	var changePageVar = function changePageVar() {
		var t = $(this);
		updateLabelLangs(t.attr('name'), t.val(), $('html').attr('data-all-langs'), null, true);
	};

	var toggleRadioWarnings = function toggleRadioWarnings() {
		var t = $(this);
		var ctn = t.closest('.settings-master-checkbox-ctn');
		var outerCtn = t.closest('.radio-btns-ctn');

		outerCtn.find('.element-to-toggle.radio').slideUp();
		ctn.find('.element-to-toggle.radio').slideDown();
	};

	var init = function init() {
		$('.change-page-var').focusout(changePageVar);
		$('.settings-master-radio-toggle').change(toggleRadioWarnings);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var formValidator;
	var addToCartBtn;
	var toggleShopItemDetailsBtn;

	// var addToCart = function() {
	// 	var t = $(this);
	// 	var id = t.attr('data-id');
	// 	var form = t.closest('.add-shop-item-form');
	// 	var qtyInput = form.find('input[name="quantity"]');

	// 	console.log(qtyInput.val());
	// 	formValidator.validateForm(form);

	// 	if (!form.hasClass('has-error')) {
	// 		var url = '/action/shopAddCart';

	// 		url += '?productId=' + id;
	// 		url += '&quantity=' + qtyInput.val();
	// 		url += '&override=true&data=true&ajax=true';

	// 		t.addClass('disabled');

	// 		var obj = ajax(url,function (response) {
	// 			console.log(response);
	// 			t.removeClass('disabled');
	// 			window.location.href = window.location.href;
	// 			// form.find('input').val('').removeClass('has-value');
	// 			// form.find('.forgot-pw-success').slideDown(function() {
	// 			// 	setTimeout(function() {
	// 			// 		form.find('.forgot-pw-success').slideUp();
	// 			// 	}, 5000);
	// 			// });
	// 		},true);
	// 	}
	// };

	var toggleDetails = function toggleDetails() {
		$(this).closest('.shop-item-extra-infos-ctn').find('.shop-item-extra-infos-inner-ctn').slideToggle();
	};

	var init = function init() {
		formValidator = Fw.component.models().form;
		// addToCartBtn = $('.add-to-cart-btn');
		toggleShopItemDetailsBtn = $('.toggle-shop-details');

		// addToCartBtn.click(addToCart);
		toggleShopItemDetailsBtn.click(toggleDetails);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
'use strict';

(function ($, undefined) {

    'use strict';

    var nextBtn;
    var firstDot;
    var secondDot;
    var recaptcha;
    var tools_form;

    var nextSlide = function nextSlide() {
        var ctn = $(this).closest('.account-form-outer-ctn');
        var form = ctn.find('form');
        var dots = ctn.find('.slick-dots');

        form.addClass('second');
        dots.find('.slick-active').removeClass('slick-active');
        secondDot.addClass('slick-active');
    };

    var prevSlide = function prevSlide() {
        var ctn = $(this).closest('.account-form-outer-ctn');
        var form = ctn.find('form');
        var dots = ctn.find('.slick-dots');

        form.removeClass('second');
        dots.find('.slick-active').removeClass('slick-active');
        firstDot.addClass('slick-active');
    };

    var initSignupCaptcha = function initSignupCaptcha(captcha, form) {
        var $form = $(form);
        tools_form.validateForm($form);
        if ($form.hasClass("has-error")) {
            return false;
        }
        $form.find("input[name = 'captcha']").val(captcha);

        $form.submit();
    };

    var init = function init() {
        tools_form = Fw.component.models().form;
        recaptcha = Fw.component.models().utils.recaptcha;
        nextBtn = $('.signup-next-btn');
        firstDot = $('.slick-dots .first');
        secondDot = $('.slick-dots .second');

        nextBtn.click(nextSlide);
        secondDot.click(nextSlide);
        firstDot.click(prevSlide);

        $('.signup-submit-btn').each(function () {
            var form = $(this).closest('.signup-form');
            if (form.length === 0) {
                form = $(this).closest('.admin-account-form');
            }
            recaptcha(this, initSignupCaptcha, true, form);
        });
    };

    $(window).ready(init);
})(jQuery);
'use strict';

/* global Fw, tinyMCE */

(function () {
    /* jshint validthis: true */
    "use strict";

    window.submittingForm = window.hasOwnProperty('submittingForm') ? window.submittingForm : false;

    var actionPath = '/action/ticketAction';

    var tools_form;
    var utils_recaptcha;

    function init() {
        //INIT STOP
        if (!document.querySelector(".support-tickets-zone")) return;

        tools_form = Fw.component.models().form;
        utils_recaptcha = Fw.component.models().utils.recaptcha;

        $('.action-ticket-details').on('click', goToTicketDetails);
        $('.ticket-info-ctn .action').on('click', openActionPopup);
        $('.action-popup-close').on('click', closeActionPopup);
        $('html').on('click', closeAllActionPopups);
        $('.ticket-info-ctn .action-popup-item').on('click', changeTicketInfo);
    }

    function goToTicketDetails(e) {
        var targ = e.currentTarget;
        var param = targ.getAttribute('data-param').split('=');

        window.location.search = setQuery(param[0], param[1]);
    }

    function openActionPopup(e) {
        e.stopPropagation();
        var btn = e.currentTarget;
        var popup = $(btn).parent().find('.action-popup');

        if (popup.hasClass('open')) {
            popup.removeClass('open');
        } else {
            $('.action-popup.open').removeClass('open');
            popup.addClass('open');
        }
    }

    function closeActionPopup(e) {
        $(e.currentTarget).closest('.action-popup').removeClass('open');
    }

    function closeAllActionPopups(e) {
        if (!e || !$(e.target).closest('.action-ctn')[0]) {
            $('.action-popup.open').removeClass('open');
        }
    }

    function changeTicketInfo(e) {
        var el = e.currentTarget;
        var param = el.dataset.key + '=' + el.dataset.value;
        var id = $(el).closest('.ticket-info-ctn').attr('data-id');

        ajax(actionPath + '?ajax=true&id=' + id + '&' + param, function (resp) {
            if (resp.indexOf('success-' + id) > -1) {
                $(el).closest('.action-ctn').find('.action .text').text(el.dataset.label ? el.dataset.label : el.textContent).attr('data-id', el.dataset.value);
            }
        }, true);

        closeAllActionPopups();
    }

    $(window).ready(init);
})();
"use strict";

/* global Fw, tinyMCE */

(function ($, d, g) {
    /* jshint validthis: true */
    "use strict";

    function catalogCloseDetails(e) {
        catalogToggleDetails(e, ".catalog-product.selected");
    }
    function catalogToggleDetails(e, sel) {
        var aCls = "selected",
            $el = $(sel || this);

        $(window).off("resize", catalogAppendDetails);
        if ($el.hasClass(aCls)) {
            $el.removeClass(aCls);
            window.history.replaceState({}, document.title, location.pathname + location.search);
        } else {
            $(".catalog-product." + aCls).removeClass(aCls);
            $el.addClass(aCls);
            $(window).on("resize", catalogAppendDetails);
            window.history.replaceState({}, document.title, location.pathname + location.search + '#' + $el.attr('id'));
        }
        catalogAppendDetails();
    }
    function catalogAppendDetails(e) {
        var $all = $(".catalog-products-ctner").children(),
            $els = $all.filter(".catalog-product"),
            $el = $els.filter(".selected"),
            $cnts = $els.find(".catalog-product-details"),
            $ctn = $all.filter(".catalog-products-detailer"),
            $ctnCnt = $ctn.find(".catalog-products-detailer-content"),
            ind = $els.index($el),
            pos = $all.index($ctn),
            old = $ctn.attr("data-index"),
            bigScreen = window.innerWidth >= 1024;

        if (old && !e) {
            $ctnCnt.children().appendTo($cnts.eq(old));
        }
        if (ind === -1) {
            $ctn.hide();
            return;
        }
        if (!e) {
            $cnts.eq(ind).children().appendTo($ctnCnt);
            $ctn.attr("data-index", ind);
            $ctn.show();
        }
        if (bigScreen && ind % 2 === 0 && ind !== $els.size() - 1) {
            if (ind !== pos - 2) {
                $els.eq(ind + 1).after($ctn);
            }
        } else if (ind !== pos - 1) {
            $el.after($ctn);
        }
    }

    function catalogAddCart(e) {
        e.preventDefault();
        var form = this;
        var opts = form.elements.namedItem("option1");
        var cartData = "";

        if (opts) {
            if (!opts.length) {
                if (opts.checked && opts.value !== "") {
                    cartData = opts.getAttribute("data-cart");
                }
            } else {
                for (var i = 0; i < opts.length; i++) {
                    if (opts[i].checked && opts[i].value !== "") {
                        cartData = opts[i].getAttribute("data-cart");
                        break;
                    }
                }
            }
        }

        if (cartData === "") {
            form.querySelector(".errorMessage").style.display = "block";
        } else {
            form.elements.namedItem("data").value = cartData;
            setTimeout(function () {
                form.submit();
            });
        }
    }
    function catalogOptionSelected(e) {
        if (this.checked) {
            this.form.querySelector(".errorMessage").style.display = "none";
        }
    }

    function filterMyProducts() {
        var filters = document.getElementsByClassName("my-products-filters-select"),
            els = document.getElementsByClassName("my-product");

        for (var i = 0; i < els.length; i++) {
            var el = els[i],
                hide = "";

            $(el).removeClass("none");
            for (var j = 0; j < filters.length; j++) {
                var filter = filters[j],
                    type = filter.type,
                    val = filter.value.toLowerCase(),
                    name = filter.name,
                    attr = el.getAttribute("data-" + name).toLowerCase();

                switch (type) {
                    case "checkbox":
                    case "radio":
                        var checked = filter.checked;
                        if (checked.toString() !== attr || checked && attr === "") hide += " none";
                        break;
                    case "text":
                        if (val.trim() !== "" && attr.indexOf(val) === -1) hide += " none";
                        break;
                    default:
                        if (!(val === "all" || val === "" || val === attr)) hide += " none";
                        break;
                }
            }
            $(el).addClass(hide);
        }
        document.querySelector(".text-result-count").innerHTML = els.length - $(els).filter(".none").size();
    }

    function openVideoPopup(e) {
        var a = this,
            b = a.nextElementSibling,
            c = a.previousElementSibling.innerHTML,
            s = b.value,
            t = b.getAttribute("data-type"),
            pop = document.getElementById("myProductsViewer"),
            wrp = pop.querySelector(".wistia_responsive_padding"),
            vfc = pop.querySelector(".my-products-viframe-ctner"),
            ctnTop = pop.querySelector(".my-products-viframe"),
            ctnBtm = pop.querySelector(".my-products-product-info>div");

        if (t === "wistia") {
            vfc.style.display = "none";
            wrp.style.display = "block";
            wrp.querySelector(".wistia_embed").src = s;
        } else {
            vfc.style.display = "block";
            wrp.style.display = "none";
            wrp.querySelector(".wistia_embed").src = "";
        }
        vfc.querySelector(".video-buffer").style.display = "none";
        vfc.querySelector(".video-controls").style.display = "none";
        ctnTop.innerHTML = "";
        switch (t) {
            case "wistia":
                break;
            case "video":
                vfc.querySelector(".video-buffer").style.display = "block";
                vfc.querySelector(".video-controls").style.display = "block";
                if (mg2vp) {
                    mg2vp.embed(ctnTop, s, b.getAttribute("data-poster"));
                } else {
                    var frame = document.createElement("VIDEO");
                    frame.src = s;
                    frame.autoplay = true;
                    frame.setAttribute("poster", b.getAttribute("data-poster"));
                    ctnTop.appendChild(frame);
                }
                break;
            case "embed":
                ctnTop.innerHTML = s;
                break;
            case "vimeo":
                var re;
                if (navigator.userAgent.match(/Safari\//)) {
                    // Safari error regexp, doesn't support lookbehind group
                    re = new RegExp('(?:\w\/)[a-f0-9]+(?=[\/\?]|$)', 'g');
                } else {
                    re = new RegExp('(?<=\w\/)[a-f0-9]+(?=[\/\?]|$)', 'g');
                }
                var code = s.match(re);
                s = "https://player.vimeo.com/video/" + code[0] + (code.length > 1 ? "?h=" + code[1] : "");
            default:
                ctnTop.innerHTML = '<iframe src="' + s + '" frameborder="0" allowfullscreen></iframe>';
                break;
        }
        ctnBtm.innerHTML = c;
        pop.style.display = "block";
        pop.oncontextmenu = function (e) {
            e.preventDefault();
        };
        document.body.style.overflow = "hidden";
    }
    function closeVideoPopup(e) {
        var pop = document.getElementById("myProductsViewer"),
            ctnTop = pop.querySelector(".my-products-viframe"),
            ctnBtm = pop.querySelector(".my-products-product-info>div");

        pop.style.display = "none";
        ctnTop.innerHTML = ctnBtm.innerHTML = "";
        document.body.style.overflow = "";
    }

    function init() {
        // Section Shop
        $(".catalog-webinar").on("click", catalogToggleDetails);
        $(".catalog-products-detailer-close").on("click", catalogCloseDetails);
        $(".cpd-price-option-checker input").on("change", catalogOptionSelected);
        $(".cpd-add-cart-form").on("submit", catalogAddCart);

        // Section Account
        $(".my-products-filters-select").on("change", filterMyProducts);
        $(".catalog-product-opener").on("click", openVideoPopup);
        $(".my-products-popup .popup-close-btn").on("click", closeVideoPopup);
    }

    $(g).ready(init);
})(jQuery, document, window);

(function ($) {
    'use strict';

    var mg2vp = {};
    var videoCtn;
    var videoElt;
    var videoCtrl;
    var playPauseBtn;
    var updateInterval;
    var timeIn;
    var timeOut;
    var cursor;
    var progressBar;
    var progressBarCtn;
    var muteBtn;
    var muteBar;
    var muteBarCurrent;
    var volume;
    var currentProgress;
    var nextProgress;

    var init = function init() {
        videoCtrl = $('.video-controls');
        playPauseBtn = $('.video-play-pause');
        timeIn = $('.video-time-in');
        setTime(timeIn, 0);
        timeOut = $('.video-time-out');
        setTime(timeOut, 0);
        cursor = $('.video-progress-bar-cursor');
        progressBar = $('.video-progress-bar-progress');
        progressBarCtn = $('.video-progress-bar');
        muteBtn = $('.video-volume');
        muteBar = $('.video-volume-inner');
        muteBarCurrent = $('.video-volume-current');
        volume = 1;
        currentProgress = '000';
        nextProgress = '000';
    };
    var destroy = function destroy() {
        pauseVideo();
        videoElt.off('waiting seeking playing seeked canplay', toggleBuffering);
        videoElt.off('ended', handleVideoEnd);
        progressBarCtn.off('mousedown touchstart', goToTimeCode);
        progressBarCtn.off('mouseover mouseout', overProgress);
        progressBarCtn.off('mousemove', updateOverProgress);
        muteBtn.off('click', toggleMute);
        muteBar.off('mousedown', changeVolume);
        playPauseBtn.off("click", togglePlay);
        $(window).off("resize", videoResize);
        videoCtn = undefined;
        videoElt = undefined;
        videoCtrl = undefined;
        playPauseBtn = undefined;
        updateInterval = undefined;
        timeIn = undefined;
        timeOut = undefined;
        cursor = undefined;
        progressBar = undefined;
        progressBarCtn = undefined;
        muteBtn = undefined;
        muteBar = undefined;
        muteBarCurrent = undefined;
        volume = undefined;
        currentProgress = undefined;
        nextProgress = undefined;
    };

    /* ====== VIDEO SETUP ====== */
    var createVideo = function createVideo(videoElemCtn, videoUrl, vidPoster) {
        var videoSource = '<source src="' + videoUrl + '" type="video/mp4">';
        var videoElem = $('<video preload="auto" class="mg2vp-element"/>');

        init();
        videoElem.append(videoSource);
        videoElem.append('<p>Your user agent does not support the HTML5 Video element.</p>');
        videoCtn = $(videoElemCtn);
        videoCtn.append(videoElem);
        if (vidPoster) videoElem.attr("poster", vidPoster);

        videoElt = videoElem;
        videoElem.on('loadedmetadata', function () {
            // HACK: Fix stuck frames in Firefox
            videoElem[0].currentTime = 0.01;
            setVideoTime(videoElem);
            setupVideo(videoElem);
            setupVideoControls();
            $(window).on("resize", videoResize);
        });
    };
    var setVideoTime = function setVideoTime(videoElem) {
        var videoDuration = videoElem[0].duration;
        setTime(timeIn, videoElem[0].currentTime, videoDuration);
        setTime(timeOut, videoDuration);
        moveProgress(0, videoDuration);
        toggleBuffering({ type: 'seeked' });
    };
    var setTime = function setTime(elt, val, total) {
        var time = getTime(val);
        var hours = total && total >= 3600 ? '00:' : '';

        if (parseInt(time.hours) > 0) {
            hours = time.hours + ':';
        }
        elt.text(hours + time.minutes + ':' + time.seconds);
    };
    var getTime = function getTime(timeVal) {
        var time = {};
        time.hours = padValue(Math.floor(timeVal / 3600), 2);
        time.minutes = padValue(Math.floor(timeVal / 60 % 60), 2);
        time.seconds = padValue(Math.floor(timeVal % 60), 2);
        return time;
    };
    var padValue = function padValue(val, len) {
        var valueToPad = isNaN(val) ? '0' : val.toString();
        while (valueToPad.length < len) {
            valueToPad = '0' + valueToPad;
        }
        return valueToPad;
    };
    var setupVideo = function setupVideo(videoElem) {
        videoElem[0].volume = volume;
        videoElem.on('waiting seeking playing seeked canplay', toggleBuffering);
        videoElem.on('ended', handleVideoEnd);
    };
    var handleVideoEnd = function handleVideoEnd(e) {
        //pauseVideo();
    };
    var setupVideoControls = function setupVideoControls() {
        progressBarCtn.on('mousedown touchstart', goToTimeCode);
        progressBarCtn.on('mouseover mouseout', overProgress);
        progressBarCtn.on('mousemove', updateOverProgress);
        muteBtn.on('click', toggleMute);
        muteBar.on('mousedown', changeVolume);
        playPauseBtn.click(togglePlay);
        $(document).on("click", controlFocus);
        $(document).on("keydown", toggleKeyAction);
    };
    var checkVideoControl = function checkVideoControl() {
        if (!videoElt.parent()[0]) {
            $(document).off("click", controlFocus);
            $(document).off("keydown", toggleKeyAction);
            destroy();
        }
    };
    var controlFocus = function controlFocus(e) {
        var targ = $(e.target).closest('.video-controls')[0];
        if (targ) {
            videoCtrl.addClass('focused');
        } else {
            videoCtrl.removeClass('focused');
        }
        checkVideoControl();
    };
    var toggleKeyAction = function toggleKeyAction(e) {
        if (videoCtrl.hasClass('focused')) {
            var k = e.which || e.keyCode;
            if (k === 32) togglePlay(e);
        }
        checkVideoControl();
    };
    var togglePlay = function togglePlay(e) {
        e.preventDefault();
        if (videoElt[0].paused) {
            startVideo();
        } else {
            pauseVideo();
        }
        try {
            ga("send", "event", "webconf�rence symposium", "play/pause/watched", $("#myProductsViewer .catalog-product-info-name").text());
        } catch (err) {}
    };
    var startVideo = function startVideo() {
        videoElt[0].play();
        playPauseBtn.addClass('playing');
        updateInterval = setInterval(function () {
            var t = videoElt[0].currentTime;
            var d = videoElt[0].duration;
            setTime(timeIn, t, d);
            moveProgress(t, d);
        }, 100 / 3);
    };
    var pauseVideo = function pauseVideo() {
        videoElt[0].pause();
        playPauseBtn.removeClass('playing');
        clearInterval(updateInterval);
    };
    var toggleBuffering = function toggleBuffering(e) {
        var buffer = $('.video-buffer', videoCtn.parent());
        var isBuffering = buffer.hasClass('buffering');
        var isPlaying = e.type === 'playing' && isBuffering;
        var wasSeeked = e.type === 'seeked' && isBuffering;
        var isWaiting = e.type === 'waiting' && !isBuffering;
        var isSeeking = e.type === 'seeking' && !isBuffering;
        var canPlay = e.type === 'canplay' && isBuffering;

        if (isPlaying || wasSeeked || isWaiting || isSeeking || canPlay || !e) {
            buffer.toggleClass('buffering');
            buffer.toggle(0);
        }
    };
    var videoResize = function videoResize(e) {
        updateProgressView();
        /*if(window.matchMedia('(max-width: 1023px)').matches && !videoElt[0].paused) {
        	pauseVideo();
        }*/
    };
    /* =================== */

    /* ====== PROGRESS BAR ====== */
    var moveProgress = function moveProgress(curr, end) {
        var progressSizePercent = curr / end;
        cursor.attr('data-percentage', progressSizePercent);
        updateProgressView(progressSizePercent);
    };
    var updateProgressView = function updateProgressView(percentage) {
        var value = percentage ? percentage : cursor.attr('data-percentage');
        var progressSizePixels = value * progressBarCtn.width();

        cursor.css('transform', 'translateX(' + progressSizePixels + 'px)');
        progressBar.css('transform', 'scaleX(' + value + ')');
    };
    var overProgress = function overProgress(e) {
        var mouseOverBar = $('.video-progress-bar-mouse');

        if (e.type === 'mouseover') {
            updateOverProgress(e);
        } else if (e.type === 'mouseout') {
            mouseOverBar.width(0);
        }
    };
    var updateOverProgress = function updateOverProgress(e) {
        e.preventDefault();

        var initialValue = e.pageX;
        var progressLeft = progressBarCtn.offset().left;
        var progressWidth = progressBarCtn.width();
        var clampedValue = clampValue(initialValue - progressLeft, 0, progressWidth);

        $('.video-progress-bar-mouse').width(clampedValue);
    };
    var goToTimeCode = function goToTimeCode(e) {
        var leftBtnPressed = e.which === 1;
        if (leftBtnPressed || e.type === 'touchstart') {
            pauseVideo();
            progressBarCtn.data('wasPaused', videoElt[0].paused);
            updateTimeCode(e, true);
        }
    };
    var updateTimeCode = function updateTimeCode(e, isClicked) {
        e.preventDefault();

        var initialValue = e.type === 'mousemove' || e.type === 'mousedown' ? e.pageX : e.originalEvent.touches[0].pageX;
        var progressLeft = progressBarCtn.offset().left;
        var progressWidth = progressBarCtn.width();
        var value = clampValue(initialValue - progressLeft, 0, progressWidth);
        var timeTotal = videoElt[0].duration;
        var timeConversion = value / progressWidth * timeTotal;

        setTime(timeIn, timeConversion, timeTotal);
        moveProgress(value, progressWidth);
        progressBarCtn.data('timeConversion', timeConversion);
        if (isClicked) {
            setTimeout(function () {
                $(document).on('touchmove mousemove', updateTimeCode);
                $(document).on('touchend mouseup', goToTimeCodeComplete);
            }, 20);
        }
    };
    var goToTimeCodeComplete = function goToTimeCodeComplete(e) {
        e.preventDefault();
        $(document).off('touchmove mousemove', updateTimeCode);
        $(document).off('touchend mouseup', goToTimeCodeComplete);

        var timeConversion = progressBarCtn.data('timeConversion');
        var wasPaused = progressBarCtn.data('wasPaused');

        videoElt[0].currentTime = timeConversion;
        progressBarCtn.removeData('wasPaused');
        if (!wasPaused) {
            startVideo();
        }
    };
    var clampValue = function clampValue(val, min, max) {
        var value = isNaN(val) ? 0 : val;
        return Math.min(Math.max(min, value), max);
    };
    /* =================== */

    /* ====== VOLUME ====== */
    var toggleMute = function toggleMute(e) {
        var volumeBeforeMute = parseFloat(muteBtn.attr('data-volume'));

        if (volumeBeforeMute > 0) {
            if (muteBtn.hasClass('mute')) {
                volume = volumeBeforeMute;
                videoElt[0].volume = volumeBeforeMute;
                muteBarCurrent.css("height", volumeBeforeMute * 100 + "%");
            } else {
                volume = 0;
                videoElt[0].volume = 0;
                muteBarCurrent.height(0);
            }
            muteBtn.toggleClass('mute');
        }
    };
    var changeVolume = function changeVolume(e) {
        var leftBtnPressed = e.which === 1;

        if (e.type === 'mousedown' && leftBtnPressed) {
            updateVolume(e);
            $(document).on('mousemove', updateVolume);
            $(document).on('mouseup', changeVolume);
            muteBar.parent().addClass('opened');
        } else if (e.type === 'mouseup') {
            $(document).off('mousemove', updateVolume);
            $(document).off('mouseup', changeVolume);
            muteBar.parent().removeClass('opened');
        }
    };
    var updateVolume = function updateVolume(e) {
        var initialValue = e.pageY;
        var muteT = muteBar.offset().top;
        var muteH = muteBar.height();
        var clampedValue = clampValue(initialValue - muteT, 0, muteH);
        var volumePercent = (1 - clampedValue / muteH).toFixed(4);

        e.preventDefault();
        volume = volumePercent;
        videoElt[0].volume = volumePercent;
        muteBarCurrent.css("height", volumePercent * 100 + "%");
        muteBtn.attr('data-volume', volumePercent);

        if (volumePercent > 0.66) {
            muteBtn.removeClass('medium low mute');
        } else if (volumePercent > 0.33 && volumePercent <= 0.66) {
            muteBtn.addClass('medium');
            muteBtn.removeClass('low mute');
        } else if (volumePercent > 0 && volumePercent <= 0.33) {
            muteBtn.addClass('low');
            muteBtn.removeClass('mute');
        } else {
            muteBtn.addClass('mute');
        }
    };
    /* =================== */

    mg2vp.embed = createVideo;
    window.mg2vp = window.mg2vp || mg2vp;
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var doc = $(document);
	var currPage;
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	var body;
	var items;
	var checkLabel;
	var checkboxItems;
	var checkboxItemsInner;
	var file;
	var fileInput;
	var formSwitch;
	var formCheck;
	var selectCountry;
	var daysCell;

	var validateForm = function validateForm(form) {
		$(form).each(function () {
			var ctn = $(this);
			var toValidateItems = $('.form-input:not(.select-state-input:not(.selected))', ctn);
			var toValidateUpload = $('.form-input-upload.required', ctn);
			var toValidateCheck = $('.form-check-input.required, .form-check-input.min-one-checked', ctn);
			var password = $('.js-password', ctn);
			var passwordConfirm = $('.js-password-confirm', ctn);
			var email = $('.js-email', ctn);
			var emailConfirm = $('.js-email-confirm', ctn);
			var btn = $('.js-form-btn', ctn);
			var isOk = true;
			var passwordOk = true;
			var termsOk = true;
			var checkOk = true;
			var emailOk = true;
			var containsOk = true;
			var fieldsErrorMessage = $('.js-form-error-message.fields', ctn);
			var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', ctn);
			var fieldsErrorTerms = $('.js-form-error-message.terms', ctn);
			var fieldsErrorPassword = $('.js-form-error-message.password', ctn);
			var fieldsErrorEmail = $('.js-form-error-message.email-check', ctn);
			var fieldsErrorContains = $('.js-form-error-message.contains', ctn);

			toValidateItems.each(function () {
				var tChild = $(this);
				validateField(tChild);

				if (tChild.hasClass('error')) {
					isOk = false;
				}

				if (tChild.hasClass('validate-contain') && tChild.val() !== '') {
					var splitChar = tChild.attr('data-split');
					var containsList = splitChar && splitChar !== '' ? tChild.attr('data-contain').split(splitChar) : [tChild.attr('data-contain')];

					if (containsList.indexOf(tChild.val()) > -1) {
						tChild.addClass('error').removeClass('success');
						containsOk = false;
					}
				}
			});

			toValidateUpload.each(function () {
				var tUpload = $(this);
				var input = $('.form-input-upload-input', tUpload);

				if (input.val() === '') {
					tUpload.addClass('error');
				}

				if (tUpload.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateCheck.each(function () {
				var tCheck = $(this);
				var tCtn = tCheck.closest('.form-checkbox-ctn');

				if (tCheck.hasClass('required')) {
					if (!tCheck.is(':checked')) {
						tCtn.addClass('error');

						if (tCtn.attr('name') !== 'terms') {
							checkOk = false;
						}
					} else {
						tCtn.removeClass('error');
					}

					if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
						termsOk = false;
					}

					if (tCtn.hasClass('error')) {
						termsOk = false;
					}
				} else {
					var lengthMinOneChecked = ctn.find('[name=' + this.name + '].min-one-checked:checked').length;
					if (lengthMinOneChecked === 0) {
						checkOk = false;
						tCtn.addClass('error');
					} else {
						tCtn.removeClass('error');
					}
				}
			});

			if (password.length !== 0 && passwordConfirm.length !== 0 && (password.val() !== passwordConfirm.val() || password.val().length === 0)) {
				if (password.val().length === 0) {
					password.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					password.addClass('success').removeClass('error');
					passwordOk = true;
				}

				if (password.val() !== passwordConfirm.val() || passwordConfirm.val().length === 0) {
					passwordConfirm.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					passwordConfirm.removeClass('error');
					passwordOk = true;

					if (password.val().length !== 0) {
						passwordConfirm.addClass('success');
					}
				}
			}

			if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
				if (email.val().length === 0) {
					email.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					email.addClass('success').removeClass('error');
					emailOk = true;
				}

				if (email.val() !== emailConfirm.val() || email.val().length === 0) {
					emailConfirm.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					emailConfirm.removeClass('error');
					emailOk = true;

					if (email.val().length !== 0) {
						emailConfirm.addClass('success');
					}
				}
			}

			ctn.addClass('is-checked');

			if (!termsOk) {
				fieldsErrorTerms.slideDown(300);
			} else {
				fieldsErrorTerms.slideUp(300);
			}

			if (!checkOk) {
				fieldsErrorCheckbox.slideDown(300);
			} else {
				fieldsErrorCheckbox.slideUp(300);
			}

			if (!containsOk) {
				fieldsErrorContains.slideDown(300);
			} else {
				fieldsErrorContains.slideUp(300);
			}

			if (password.length !== 0 && passwordConfirm.length !== 0) {
				if (password.length !== 0 && passwordOk) {
					ctn.addClass('has-password');
					password.add(passwordConfirm).removeClass('error');
					fieldsErrorPassword.slideUp(300);
				} else {
					ctn.removeClass('has-password');
					password.add(passwordConfirm).addClass('error');
					fieldsErrorPassword.slideDown(300);
				}
			}

			if (email.length !== 0 && emailConfirm.length !== 0) {
				if (email.length !== 0 && emailOk) {
					ctn.addClass('has-email');
					email.add(emailConfirm).removeClass('error');
					fieldsErrorEmail.slideUp(300);
				} else {
					ctn.removeClass('has-email');
					email.add(emailConfirm).addClass('error');
					fieldsErrorEmail.slideDown(300);
				}
			}

			if (!isOk) {
				fieldsErrorMessage.slideDown(300);
			} else {
				fieldsErrorMessage.slideUp(300);
			}

			if (!isOk || !passwordOk || !termsOk || !checkOk || !emailOk || !containsOk) {
				btn.addClass('disabled');
				ctn.addClass('has-error');

				if (!passwordOk && password.hasClass('required')) {
					ctn.addClass('error-password');
				} else {
					ctn.removeClass('error-password');
				}
				return false;
			} else {
				btn.removeClass('disabled');
				ctn.removeClass('has-error').removeClass('error-password');

				fieldsErrorTerms.slideUp(300);
				return true;
			}
		});
	};

	var submitValidateForm = function submitValidateForm(e) {
		e.preventDefault();

		validateForm(this);

		if (!$(this).hasClass('has-error')) this.submit();
	};

	var ajaxSubmit = function ajaxSubmit(e) {
		e.preventDefault();

		var $btn = $(this);
		var $form = $btn.closest('form');
		validateForm($form[0]);

		if (!$form.hasClass('has-error') && !$btn.hasClass('disabled')) {
			$btn.addClass('disabled');
			$.post({
				url: $form.attr('action'),
				data: $form.serialize() + '&ajax=true',
				cache: false,
				success: function success(resp) {
					$btn.removeClass('disabled');
					$form.slideUp(400).next('.ajax-submit-success').fadeIn(400);
					$form[0].reset();
				}
			});
		}
	};

	var showAjaxSubmitForm = function showAjaxSubmitForm(e) {
		var $popup = $(this).parents('.popup');
		setTimeout(function () {
			$popup.find('.ajax-form').show();
			$popup.find('.ajax-submit-success').hide();
		}, 300);
	};

	var checkFieldValue = function checkFieldValue(elt) {
		var val = elt.val();
		if (val && val.trim() !== '') {
			elt.addClass('has-value');
		} else {
			elt.removeClass('has-value');
		}
	};

	var validateField = function validateField(elt) {
		var tag = elt[0].tagName;
		var type = elt.attr('type');
		var val = elt.val() || "";
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
		//Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
		//the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
		var validate = elt.attr('data-validate');
		var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
		var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
		var emailValid = true;
		var whiteSpaceValid = true;
		var urlValid = true;
		var telValid = true;
		var inputValid = true;

		checkFieldValue(elt);

		if (tag === 'TEXTAREA' && (!elt.hasClass('mceNoEditor') || elt.hasClass('mce-enabled'))) {
			try {
				val = window.tinymce.get(elt[0].id ? elt[0].id : elt[0].name).getContent();
			} catch (err) {
				console.error(err);
			}
		}

		if (!val.replace(/\s/g, '').length) {
			whiteSpaceValid = false;
		}

		if (tag === 'INPUT' && (type === 'email' && elt.hasClass('required') || validate === 'email') && validate !== 'default') {
			emailValid = reEmail.test(val);
		} else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
			urlValid = reUrl.test(val);
		} else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
			telValid = reTel.test(val);
		} else if (elt.hasClass('form-input-upload-input')) {
			if (classTarget.hasClass('required') && elt.val() !== '') {
				classTarget.removeClass('error').addClass('success');
			} else {
				classTarget.addClass('error').removeClass('success');
			}
		} else {
			if (classTarget.hasClass('required') && $.trim(val).length === 0) {
				classTarget.removeClass('success').addClass('error');
				inputValid = false;
			} else if (!classTarget.hasClass('required') && val.length === 0) {
				classTarget.removeClass('success').removeClass('error');
			}
		}

		if (emailValid && urlValid && telValid && inputValid && whiteSpaceValid) {
			classTarget.removeClass('error').addClass('success');
		} else if (val.length === 0 && !classTarget.hasClass('required')) {
			classTarget.removeClass('error').removeClass('success');
		} else {
			classTarget.addClass('error').removeClass('success');
		}
	};

	var formItemsBlur = function formItemsBlur(t) {
		var elt = t.target === undefined ? t : $(this);
		var ctn = elt.closest('.form-input');
		var form = ctn.closest('.js-form');

		validateField(elt);

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formCheckChange = function formCheckChange() {
		var t = $(this);
		var ctn = t.closest('.form-checkbox-ctn');
		var form = ctn.closest('.js-form');

		if (form.hasClass('is-checked')) {
			validateForm(form);

			if (t.is(':checked')) {
				ctn.removeClass('error');
			}
		}
	};

	var checkLabelClick = function checkLabelClick() {
		var t = $(this);
		var ctn = t.closest('.register-checkbox');

		if (ctn.hasClass('is-checked')) {
			ctn.removeClass('is-checked');
		} else {
			ctn.addClass('is-checked');
		}
	};

	var toggleCheckbox = function toggleCheckbox() {
		var t = $(this);
		var ctn = t.closest('.form-input-checkbox');
		var input = $('.form-input-checkbox-input', t);

		if (ctn.hasClass('checked')) {
			ctn.removeClass('checked');
			input.removeAttr('checked');
		} else {
			ctn.addClass('checked');
			input.attr('checked', 'checked');
		}
	};

	var fileInputChange = function fileInputChange() {
		var t = $(this);
		var label = t.closest('.form-input-upload-input-label');
		var labelDefault = label.attr('data-default-value');
		var labelValue = $('.form-input-upload-input-label-value:not(.btn)', label);
		var ctn = t.closest(t.attr('data-validator-apply-class-on'));
		var form = ctn.closest('.js-form');

		if (t.val() !== '') {
			ctn.removeClass('error').addClass('success');
			labelValue.html(t.val().split('\\')[t.val().split('\\').length - 1]);
		} else {
			ctn.addClass('error').removeClass('success');
			labelValue.html(labelDefault);
		}

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formSwitchClick = function formSwitchClick() {
		var t = $(this);
		var elem = $(t).find('.checkbox');

		t.find('.form-checkbox-slider').toggleClass('active');
		if (elem.prop("checked")) {
			elem.removeAttr("checked");
		} else {
			elem.attr("checked", "checked");
		}
	};

	var updateStateSelect = function updateStateSelect() {
		var t = $(this);
		var val = t.val().toLowerCase();
		var form = t.closest('form');
		var statesCtn = $('.select-state-ctn', form);
		$('.form-select-ctn, .form-select-ctn .form-select', statesCtn).removeClass('selected');

		if (['ca', 'can', 'canada'].indexOf(val) > -1) {
			$('.form-select-ctn.us .form-select', statesCtn).removeAttr('name');
			$('.form-select-ctn.canada, .form-select-ctn.canada .form-select', statesCtn).addClass('selected');
			$('.form-select-ctn.canada .form-select', statesCtn).attr('name', 'province');
			$('.form-select-ctn.australia .form-select', statesCtn).removeAttr('name');
			$('.form-select-ctn.other .form-select', statesCtn).removeAttr('name');
		} else if (['us', 'usa', 'united-states'].indexOf(val) > -1) {
			$('.form-select-ctn.us, .form-select-ctn.us .form-select', statesCtn).addClass('selected');
			$('.form-select-ctn.us .form-select', statesCtn).attr('name', 'province');
			$('.form-select-ctn.canada .form-select', statesCtn).removeAttr('name');
			$('.form-select-ctn.australia .form-select', statesCtn).removeAttr('name');
			$('.form-select-ctn.other .form-select', statesCtn).removeAttr('name');
		} else if (['au', 'aus', 'australia'].indexOf(val) > -1) {
			$('.form-select-ctn.us .form-select', statesCtn).removeAttr('name');
			$('.form-select-ctn.canada .form-select', statesCtn).removeAttr('name');
			$('.form-select-ctn.australia, .form-select-ctn.australia .form-select', statesCtn).addClass('selected');
			$('.form-select-ctn.australia .form-select', statesCtn).attr('name', 'province');
			$('.form-select-ctn.other .form-select', statesCtn).removeAttr('name');
		} else {
			$('.form-select-ctn.us .form-select', statesCtn).removeAttr('name');
			$('.form-select-ctn.canada .form-select', statesCtn).removeAttr('name');
			$('.form-select-ctn.australia .form-select', statesCtn).removeAttr('name');
			$('.form-select-ctn.other, .form-select-ctn.other .form-select', statesCtn).addClass('selected');
			$('.form-select-ctn.other .form-select', statesCtn).attr('name', 'province');
		}
	};

	var setFieldsWithValues = function setFieldsWithValues() {
		items = $('.form-input:not([type=file])');
		items.each(function () {
			checkFieldValue($(this));
		});
	};

	var splitDate = function splitDate(t) {
		var date = t.val().split('/');
		var ctn = t.closest('.input-ctn');

		ctn.find('.day').val(date[0]);
		ctn.find('.month').val(date[1] - 1);
		ctn.find('.year').val(date[2]);
	};

	var collectCheckboxValues = function collectCheckboxValues(e) {
		var $ctn = $(e.delegateTarget || this).closest('.checkbox-value-collector');
		var $inp = $ctn.find('input[name="' + this.name.replace('Split', '') + '"]');
		var sep = $ctn.attr("data-separator") || " | ";
		var arr = [];

		$ctn.find('.form-check-input').each(function () {
			if (this.checked) arr.push(this.value);
		});

		$inp.val(arr.join(sep));
		if ($inp.hasClass('save-data')) {
			$inp.trigger('change');
		}
	};

	var submitAfterFileSelect = function submitAfterFileSelect(e) {
		var it = e.currentTarget || this;
		if (it.files[0]) {
			$('.popup-outer[data-id="newsletter_import_list_wait"]').addClass('open');
			it.form.submit();
		}
	};

	var transferElementDataToForm = function transferElementDataToForm(e) {
		if (e) e.preventDefault();

		var $it = $(this || e.currentTarget),
		    form = document.getElementById($it.attr("data-form")),
		    inputs = form.elements,
		    data = $it.closest(".element-data-item").data(),
		    name;

		if ($it.attr("data-hide-elements")) {
			$($it.attr("data-hide-elements"), form).hide();
		}
		if ($it.attr("data-show-elements")) {
			$($it.attr("data-show-elements"), form).show();
		}

		$.each(inputs, function (i, el) {
			if (!el.hasAttribute("ignore")) {
				name = el.name.toLowerCase();
				if (el.type === "checkbox" || el.type === "radio") {
					el.checked = data.hasOwnProperty(name) && data[name].toString() === el.value;
				} else {
					el.value = data.hasOwnProperty(name) ? data[name] : "";
				}
			}
		});

		$(form).slideDown(400);
		scrollToElement(null, 'html, body', form, $(".site-header").height());
	};

	var init = function init(page) {
		// currPage = $(page);
		body = $('body');
		items = $('.form-input:not([type=file])');

		checkLabel = $('.register-checkbox-label', currPage);
		checkboxItems = $('.form-input-checkbox', currPage);
		checkboxItemsInner = $('.form-input-checkbox-inner', checkboxItems);
		file = $('.form-input-upload', currPage);
		fileInput = $('.form-input-upload-input', file);
		formSwitch = $('.form-switch', currPage);
		formCheck = $('.form-check-input', currPage);
		selectCountry = $('.select-country-input');
		daysCell = $('.days-cell');

		checkLabel.click(checkLabelClick);
		checkboxItemsInner.click(toggleCheckbox);
		fileInput.change(fileInputChange);
		formSwitch.click(formSwitchClick);
		formCheck.change(formCheckChange);
		selectCountry.change(updateStateSelect);

		items.each(function () {
			var t = $(this);
			if (!t.hasClass('no-blur')) {
				t.blur(formItemsBlur);
			}
		});

		$('.form-validate').on('submit', submitValidateForm);
		$('.ajax-submit').on('click', ajaxSubmit);
		$('.ajax-submit-success').parents('.popup').find('.close-popup-btn').on('click', showAjaxSubmitForm);

		$('.checkbox-value-collector').on('change', '.form-check-input', collectCheckboxValues);

		$('.input-file-import').on('change', submitAfterFileSelect);

		setInterval(setFieldsWithValues, 800);

		$(".edit-element").on("click", transferElementDataToForm);
	};

	Fw.component.export('form', {
		init: init,
		validateForm: validateForm,
		validateField: validateField,
		transferElementDataToForm: transferElementDataToForm
	});

	$(window).ready(init);
})(jQuery);
'use strict';

(function ($, undefined) {

	'use strict';

	var openPopupClickBtn;
	var openPopupHoverBtn;
	var closePopupBtn;

	var openPopup = function openPopup() {
		var t = $(this);
		var id = t.attr('data-id');
		var popup = $('.popup-outer[data-id=' + id + ']');
		var key = t.attr('data-key');
		var insText = t.attr('data-insert-text');

		popup.addClass('open');

		if (key) {
			popup.find('.popup-lock').val(key);
		}
		if (insText) {
			popup.find('.popup-insert-text').text(insText);
		}

		if (t.hasClass('hover') && !$('html').hasClass('mobile')) {
			popup.find('.popup').mouseleave(closePopup);
		}
	};

	var closePopup = function closePopup() {
		var t = $(this);
		var popup = t.closest('.popup-outer');

		popup.removeClass('open');
	};

	var showSuccessPopup = function showSuccessPopup(successClass) {
		var success = successClass;
		if (success === undefined) {
			success = 'form-success';
		}

		showPopupAnimation(success);
	};

	var showErrorPopup = function showErrorPopup(errorClass) {
		var error = errorClass;
		if (error === undefined) {
			error = 'form-error';
		}

		showPopupAnimation(error);
	};

	var showPopupAnimation = function showPopupAnimation(messageClass) {
		var message = $('.form-popup-message.' + messageClass);

		$('.form-popup-message').removeClass('show');
		message.addClass('show');

		setTimeout(function () {
			message.removeClass('show');
		}, 5000);
	};

	var closeMsgPopup = function closeMsgPopup() {
		$(this).closest('.form-popup-message').removeClass('show');
		var qkey = this.getAttribute('data-qkey');
		if (qkey && qkey !== '') {
			Fw.component.models().utils.changeURLState(qkey, null, {});
		}
	};

	var init = function init() {
		openPopupClickBtn = $('.open-popup-btn:not(.hover), html.mobile .open-popup-btn.hover');
		openPopupHoverBtn = $('html:not(.mobile) .open-popup-btn.hover');
		closePopupBtn = $('.close-popup-btn');

		openPopupClickBtn.click(openPopup);
		openPopupHoverBtn.mouseover(openPopup);
		closePopupBtn.click(closePopup);
		$('.form-popup-message-close-btn').click(closeMsgPopup);
	};

	Fw.component.export('popup', {
		openPopup: openPopup,
		closePopup: closePopup,
		showSuccessPopup: showSuccessPopup,
		showErrorPopup: showErrorPopup,
		closeMsgPopup: closeMsgPopup
	});

	$(window).ready(init);
})(jQuery);
'use strict';

(function ($, undefined) {

  'use strict';

  var formValidator;
  var filtersForm;
  var scrollTopBtn;
  var validateFormBtn;
  var toggleTriggerBtn;
  var toggleTriggerVal;
  var toggleTriggerInput;
  var submitFormBtn;
  var numbersOnlyInput;
  var priceOnlyInput;
  var settingsInput;
  var bgPosRange;
  var toggleSettingsBtn;

  var refresh = function refresh() {
    window.location.reload();
  };

  var submitForm = function submitForm() {
    if (!$(this).hasClass('no-disable')) {
      $(this).addClass('disabled');
    }
    $(this).closest('form').submit();
  };

  var submitMultiFilter = function submitMultiFilter() {
    var t = $(this);
    var val = t.val();

    if (val === '') {
      window.location.href = t.attr('data-extra');
    } else {
      var option = t.find('option[value=' + val + ']');
      var search = option.attr('data-search');
      var search2 = option.attr('data-search2');
      var url = t.attr('data-extra');

      if (t.attr('data-extra').indexOf('?') === -1) {
        url += '?';
      } else if (t.attr('data-extra').indexOf('&') !== -1 || t.attr('data-extra').indexOf('?') !== -1) {
        url += '&';
      }

      if (search === undefined || search === '') {
        search = option.parent()[0].name + '=' + val;
      }
      url += search;

      if (search2 !== undefined && search2 !== '') {
        url += '&' + search2;
      }

      window.location.href = url;
    }
  };

  var ignoreUnusedStates = function ignoreUnusedStates(form) {
    var states = form.find('.select-state-input-ctn');
    if (states.length) {
      states.each(function () {
        var state = $(this);
        if (state.find('.fake-input').length) {
          // Do nothing. The "fake-input" class is a way to make the input non required.
        } else if (state.css('display') === 'none') {
          state.find('.form-input').removeClass('required').addClass('derequired');
        } else if (state.css('display') === 'block') {
          state.find('.form-input').removeClass('derequired').addClass('required');
        }
      });
    }
  };

  var validateForm = function validateForm(t) {
    var btn;
    if (t.length) {
      btn = t;
    } else {
      btn = $(this);
    }
    var form = btn.closest('form');

    ignoreUnusedStates(form);
    formValidator.validateForm(form);

    if (!form.hasClass('has-error')) {
      if (form.find('.remove-on-submit').length) {
        form.find('.remove-on-submit').each(function () {
          if ($(this).css('display') === 'none') {
            $(this).remove();
          }
        });
      }

      btn.addClass('disabled');
      form.submit();
    }
  };

  var ajaxValidateFormAndReload = function ajaxValidateFormAndReload(t) {
    var btn;
    if (t.length) {
      btn = t;
    } else {
      btn = $(this);
    }
    var form = btn.closest('form');

    ignoreUnusedStates(form);
    formValidator.validateForm(form);

    if (!form.hasClass('has-error') && !btn.hasClass('disabled')) {
      btn.addClass('disabled');

      var data, forward, settings;

      settings = {
        url: form.attr('action'),
        method: form.attr('method').toUpperCase(),
        type: form.attr('method'),
        cache: false,
        processData: false,
        complete: function complete(xhr, status) {
          // No matter success or error
          if (forward) {
            window.location.href = forward;
          } else {
            window.location.reload();
          }
        }
      };

      if (form.attr('enctype') === 'multipart/form-data') {
        settings.contentType = 'multipart/form-data';
        data = new FormData(form[0]);
        data.append('ajax', 'true');
        forward = data.get('pageName') || data.get('pageSuccess');
      } else {
        data = form.serialize() + "&ajax=true";
        forward = form.find('[name="pageName"],[name="pageSuccess"]').val();
      }
      settings.data = data;

      $.ajax(settings);
      if (btn.hasClass('open-loading-popup')) {
        $('.popup-outer[data-id="loadingWait"]').addClass('open');
      }
    }
  };

  var scrollUp = function scrollUp() {
    $('html').animate({ scrollTop: 0 }, 300);
    $('body').animate({ scrollTop: 0 }, 300);
  };

  var toggleElement = function toggleElement(e) {
    var t = $(this);
    var togId = t.attr('data-toggle-id');
    var ctn = t.closest('.toggle-outer-ctn');
    var el = t.hasClass('first-level-toggle') ? ctn.children('.element-to-toggle') : ctn.find('.element-to-toggle');
    var togglers = ctn.find('.toggle-trigger-element.required');
    var closeAll = t.hasClass('close-all');
    var elIsClosed = el.css('display') === 'none';

    if (closeAll) {
      ctn.find('.element-to-toggle').slideUp();
      t.removeClass('toggled');
    }

    setTimeout(function () {
      if (t.attr("data-hide-elements")) {
        $(t.attr("data-hide-elements"), ctn).hide();
      }
      if (t.attr("data-show-elements")) {
        $(t.attr("data-show-elements"), ctn).show();
      }
    }, elIsClosed ? 0 : 300);

    if (elIsClosed && el[0].tagName === 'FORM' && t.attr('data-reset-form') === 'true') {
      el[0].reset();
      // Clear filled values
      el.find('[data-reset-value]').each(function () {
        var it = $(this);
        if (this.tagName === 'INPUT' || this.tagName === 'SELECT') {
          it.val(it.attr('data-reset-value'));
        } else {
          it.html(it.attr('data-reset-value'));
        }
      });
    }

    if (togglers.length) {
      if (togglers.filter(':checked').length) {
        togglers.removeClass('required').addClass('derequired');
      } else {
        togglers.removeClass('derequired').addClass('required');
      }
    }

    if ((!togId || togId === '') && this.type !== 'checkbox' && this.type !== 'radio') {
      if (el.css('display') !== 'none' && el.find('.required').length) {
        el.find('.required').removeClass('required').addClass('derequired');
      } else if (elIsClosed && el.find('.derequired').length) {
        el.find('.derequired').removeClass('derequired').addClass('required');
      }
      if (!closeAll) {
        el.slideToggle();

        if (elIsClosed) {
          t.addClass('toggled');
        } else {
          t.removeClass('toggled');
        }
      }
    } else {
      el.each(function () {
        var $_ = $(this);
        if (this.getAttribute('data-toggle-id') === togId) {
          if (t.hasClass('toggle-trigger-on')) {
            if (!closeAll) $_.slideDown();
            $_.find('.derequired').removeClass('derequired').addClass('required');
          } else if (t.hasClass('toggle-trigger-off')) {
            $_.slideUp();
            $_.find('.required').removeClass('required').addClass('derequired');
          } else if (t.prop('checked')) {
            if (!closeAll) $_.slideDown();
            $_.find('.derequired').removeClass('derequired').addClass('required');
          } else if (t.hasClass('select-toggle-element')) {
            var offValue = t.attr('data-toggle-off-value');
            var onValue = t.attr('data-toggle-on-value');

            if (onValue && !offValue || offValue && offValue === t.val()) {
              $_.slideUp();
              $_.find('.required').removeClass('required').addClass('derequired');
            } else if (offValue && !onValue || onValue && onValue === t.val()) {
              $_.slideDown();
              $_.find('.derequired').removeClass('derequired').addClass('required');
            }
          } else {
            $_.slideToggle();
            if ($_.css('display') === 'none') {
              $_.find('.required').removeClass('required').addClass('derequired');
            } else {
              $_.find('.derequired').removeClass('derequired').addClass('required');
            }
          }
        } else {
          $_.slideUp();
          $_.find('.required').removeClass('required').addClass('derequired');
        }
      });
    }
  };

  var toggleCloseElement = function toggleCloseElement() {
    var $el = $(this).closest('.element-to-toggle');
    if (!$el[0]) {
      $el = $(this).closest('.toggle-outer-ctn').find('.element-to-toggle');
    }
    $el.slideUp();
  };

  var toggleVal = function toggleVal() {
    var t = $(this);
    var el = t.closest('.toggle-val-ctn').find('.val-to-toggle');
    var val = t.val();

    if (t.attr('type') === 'checkbox') {
      val = t.prop('checked').toString();
    }

    el.val(val);
  };

  var checkSubmitForm = function checkSubmitForm(e) {
    if (e.which == 10 || e.which == 13) {
      e.preventDefault();
      $(this).closest('form').find('.form-submit-btn, .validate-form-btn, .trigger-form-btn').trigger('click');
    }
  };

  var typeNumbersOnly = function typeNumbersOnly(e) {
    if (!e.shiftKey && (e.which === 0 || e.which === 8 || e.which === 48 || e.which === 49 || e.which === 50 || e.which === 51 || e.which === 52 || e.which === 53 || e.which === 54 || e.which === 55 || e.which === 56 || e.which === 57)) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  };

  var typePricesOnly = function typePricesOnly(e) {
    var k = e.which || e.keyCode || e.charCode;
    // Allow: BACKSPACE, TAB, ESCAPE, END, HOME, ARROWS, ., DELETE, NUMLOCK
    // Allow: Ctrl+A, Ctrl+C, Ctrl+X, Ctrl+V, Ctrl+Z, Ctrl+Y
    if ([0, 8, 9, 27, 35, 36, 37, 38, 39, 40, 46, 110, 144].indexOf(k) > -1 || [65, 67, 86, 88, 89, 90].indexOf(k) > -1 && (e.ctrlKey || e.metaKey)) {
      // Prevent more than 1 decimal point
      // keypress single quote is 39 and n is 110
      if (k === 46 && this.value.indexOf(".") > -1 || [39, 110].indexOf(k) > -1 && e.type === "keypress") {
        e.preventDefault();
      } else {
        return;
      }
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || k < 48 || k > 57) && (k < 96 || k > 105 || e.type === "keypress")) {
      e.preventDefault();
    }
  };

  var settingsInputChange = function settingsInputChange(e) {
    var t = $(this);
    if (t.hasClass('settings-no-save')) {
      return;
    }

    var ctn = t.closest('.settings-ctn');
    if (ctn === undefined) {
      ctn = t.closest('.settings-master');
    }
    var label = t.attr('name');
    var val = t.val();
    var langs = t.attr('data-lang') ? t.attr('data-lang') : $('html').attr('data-all-langs');
    var element = $('.' + label);
    var extraClasses = '';

    if (t.attr('type') === 'checkbox') {
      val = t.prop('checked').toString();

      if (t.hasClass('no-false') && t.prop('checked') === false) {
        val = '';
      }
    }

    if (t.attr('multiple') !== undefined) {
      val = t.val() instanceof Array ? t.val().join(',') : t.val();
    }

    if (ctn.hasClass('settings-ctn')) {
      if (t.hasClass('text')) {
        ctn.find('input.text').each(function () {
          if ($(this).prop('checked')) {
            extraClasses += $(this).val() + ' ';
          }
        });
      } else if (t.hasClass('bg')) {
        ctn.find('input.bg').each(function () {
          if ($(this).prop('checked')) {
            extraClasses += $(this).val();
          }
        });
      } else if (t.hasClass('button')) {
        ctn.find('input.button').each(function () {
          if ($(this).prop('checked')) {
            extraClasses += $(this).val();
          }
        });
      }

      element.each(function () {
        $(this).removeClass();
        $(this).addClass($(this).attr('data-class')).addClass(extraClasses);
      });
    }

    updateLabelLangs(label, val, langs, function () {
      if (t.hasClass('refresh')) {
        refresh();
      }
    }, true);
  };

  var updateBgPosLabel = function updateBgPosLabel() {
    var t = $(this);
    var value = t.val() + "%";
    var key = t.data('key');

    var langs = $('html').attr('data-all-langs');
    updateLabelLangs(key, value, langs, function () {}, true);
  };

  var changeBgPos = function changeBgPos() {
    var t = $(this);
    var ctn = $('.background-img-' + t.attr('data-id'));
    var currentPosition = ctn.css('backgroundPosition');
    var value = t.val();
    var otherVal;

    // change background
    if (t.hasClass('horizontal')) {
      otherVal = currentPosition.split('% ');
      ctn.css('backgroundPosition', value + '% ' + otherVal[1]);
    } else if (t.hasClass('vertical')) {
      otherVal = currentPosition.split(' ');
      ctn.css('backgroundPosition', otherVal[0] + ' ' + value + '%');
    }
  };

  var changeComponentImageSize = function changeComponentImageSize(e) {
    var inp = e.target || this;
    var val = inp.value;

    if (!val.match(/(px|rem|em|pt|vh|vw)/i)) {
      // Not a valid height property
      return;
    }

    updateLabelLangs(inp.name, val, $('html').attr('data-all-langs'), voidAjax, true);
    $('.height-' + inp.getAttribute('data-id')).css('min-height', val);
  };

  var checkPageHeight = function checkPageHeight() {
    setTimeout(function () {
      var offset = scrollTopBtn.offset().top;

      if (offset < $(window).height()) {
        scrollTopBtn.fadeOut();
      }
    }, 20);
  };

  var toggleInput = function toggleInput() {
    var t = $(this);
    var id = t.attr('data-id');
    var form = t.closest('form');

    if (t.prop('checked')) {
      form.append('<input type="hidden" name="' + id + '" value="true"/>');
    } else {
      form.find('input[name=' + id + ']').remove();
    }
  };

  var closeOpenSettings = function closeOpenSettings() {
    var t = $(this);
    var compId = t.closest('.componentContainerDiv').attr('id');

    if (!t.hasClass('component-settings-close-btn')) {
      $('.settings-ctn').each(function () {
        if ($(this).closest('.componentContainerDiv').attr('id') !== compId || $(this).closest('.componentContainerDiv').attr('id') !== null && compId === null) {
          $(this).slideUp();
        }
      });
    }
  };

  var updateLabelOnChange = function updateLabelOnChange(e) {
    var $it = $(this);
    var val = this.checked ? 'true' : '';

    if ($it.hasClass('all-langs')) {
      updateLabelLangs($it.attr('name'), val, $('html').attr('data-all-langs'), voidAjax, true);
    } else {
      updateLabel($it.attr('name'), val, voidAjax, true);
    }
  };

  var removeEmptyParams = function removeEmptyParams(e) {
    $(this).find('.filters-form-2-param').each(function () {
      if (this.value === '') this.name = '';
    });
    return true;
  };

  var sendAction = function sendAction(e) {
    var url = this.getAttribute('data-url');
    if (url && url !== '') {
      ajax(url, refresh, true);
    }
  };

  var escapeChars = function escapeChars(str) {
    return str.replace(/�/g, "\xC0").replace(/�/g, "\xC1").replace(/�/g, "\xC2").replace(/�/g, "\xC3").replace(/�/g, "\xC4").replace(/�/g, "\xC5").replace(/�/g, "\xC6").replace(/�/g, "\xC7").replace(/�/g, "\xC8").replace(/�/g, "\xC9").replace(/�/g, "\xCA").replace(/�/g, "\xCB").replace(/�/g, "\xCC").replace(/�/g, "\xCD").replace(/�/g, "\xCE").replace(/�/g, "\xCF").replace(/�/g, "\xD0").replace(/�/g, "\xD1").replace(/�/g, "\xD2").replace(/�/g, "\xD3").replace(/�/g, "\xD4").replace(/�/g, "\xD5").replace(/�/g, "\xD6").replace(/�/g, "\xD8").replace(/�/g, "\xD9").replace(/�/g, "\xDA").replace(/�/g, "\xDB").replace(/�/g, "\xDC").replace(/�/g, "\xDD").replace(/�/g, "\xDE").replace(/�/g, "\xDF").replace(/�/g, "\xE0").replace(/�/g, "\xE1").replace(/�/g, "\xE2").replace(/�/g, "\xE3").replace(/�/g, "\xE4").replace(/�/g, "\xE5").replace(/�/g, "\xE6").replace(/�/g, "\xE7").replace(/�/g, "\xE8").replace(/�/g, "\xE9").replace(/�/g, "\xEA").replace(/�/g, "\xEB").replace(/�/g, "\xEC").replace(/�/g, "\xED").replace(/�/g, "\xEE").replace(/�/g, "\xEF").replace(/�/g, "\xF0").replace(/�/g, "\xF1").replace(/�/g, "\xF2").replace(/�/g, "\xF3").replace(/�/g, "\xF4").replace(/�/g, "\xF5").replace(/�/g, "\xF6").replace(/�/g, "\xF8").replace(/�/g, "\xF9").replace(/�/g, "\xFA").replace(/�/g, "\xFB").replace(/�/g, "\xFC").replace(/�/g, "\xFD").replace(/�/g, "\xFE").replace(/�/g, "\xFF");
  };

  var sortResults = function sortResults(json, prop, asc) {
    json = json.sort(function (a, b) {
      if (asc) {
        return a[prop].toLowerCase() > b[prop].toLowerCase() ? 1 : a[prop].toLowerCase() < b[prop].toLowerCase() ? -1 : 0;
      } else {
        return b[prop].toLowerCase() > a[prop].toLowerCase() ? 1 : b[prop].toLowerCase() < a[prop].toLowerCase() ? -1 : 0;
      }
    });
    return json;
  };

  var appendElement = function appendElement(e) {
    var btn = $(e.currentTarget);
    var ctn = btn.closest('.append-element-ctn');
    var clone = ctn.find('.append-element-temp').clone(true);

    ctn.find('.append-element-wrap').append(clone);
    clone.attr('class', 'appended-element ' + clone.attr('data-replace-class')).removeAttr('data-replace-class');
  };

  var deleteAppendedElement = function deleteAppendedElement(e) {
    var btn = $(e.currentTarget);
    var item = btn.closest('.appended-element');

    if (!!item.attr('id')) {
      item.addClass('deleting').find('.form-input').addClass('disabled').attr('tabindex', '-1');
      item.find('.append-element-deleting-input').val('true');
    } else {
      item.remove();
    }
  };

  var undoDeleteAppendedElement = function undoDeleteAppendedElement(e) {
    var btn = $(e.currentTarget);
    var item = btn.closest('.appended-element');

    item.removeClass('deleting').find('.form-input').removeClass('disabled').removeAttr('tabindex');
    item.find('.append-element-deleting-input').val('');
  };

  var init = function init(page) {
    formValidator = Fw.component.models().form;
    filtersForm = $('.filters-form');
    scrollTopBtn = $('.scrolltop-btn');
    validateFormBtn = $('.validate-form-btn');
    toggleTriggerBtn = $('.toggle-trigger-element');
    toggleTriggerVal = $('.toggle-trigger-val');
    toggleTriggerInput = $('.toggle-form-input');
    submitFormBtn = $('.form-submit-btn');
    numbersOnlyInput = $('input.numbers-only');
    priceOnlyInput = $('input.price-only');
    settingsInput = $('.settings-ctn input[type="radio"], .settings-ctn input[type="checkbox"], .settings-ctn input.save-data, .settings-ctn select.save-data, .settings-master input[type="radio"], .settings-master input[type="checkbox"], .settings-master input.save-data, .settings-master select.save-data');
    bgPosRange = $('.image-bg-pos');
    toggleSettingsBtn = $('.toggle-component-settings-btn');

    submitFormBtn.click(submitForm);
    filtersForm.find('select:not(.multi-filter-select)').change(submitForm);
    filtersForm.find('.multi-filter-select').change(submitMultiFilter);
    filtersForm.find('input[type=radio]').change(submitForm);
    scrollTopBtn.click(scrollUp);
    validateFormBtn.click(validateForm);
    toggleTriggerBtn.click(toggleElement);
    $('.select-toggle-element').change(toggleElement);
    $('.toggle-close-element').click(toggleCloseElement);
    toggleTriggerVal.change(toggleVal);
    toggleTriggerInput.change(toggleInput);
    numbersOnlyInput.keypress(typeNumbersOnly);
    priceOnlyInput.keypress(typePricesOnly);
    settingsInput.change(settingsInputChange);
    bgPosRange.on('change', updateBgPosLabel);
    bgPosRange.on('input', changeBgPos);
    toggleSettingsBtn.click(closeOpenSettings);
    $('.ajax-action').click(sendAction);

    if (scrollTopBtn.length) {
      checkPageHeight();
    }

    $('form:not(#mg2LoginForm):not(.checkout-form)').find('input').keypress(checkSubmitForm);

    $('.filters-form-2').on('submit', removeEmptyParams);

    $('.image-size-input').on('change', changeComponentImageSize);

    $('.update-label-on-change').on('change', updateLabelOnChange);

    $('.ajax-validate-form-and-reload-btn').on('click', ajaxValidateFormAndReload);

    $('.scroll-to-element').on('click', scrollToElement);

    $('.append-element-btn').click(appendElement);
    $('.append-element-delete').click(deleteAppendedElement);
    $('.append-element-undo-delete').click(undoDeleteAppendedElement);
  };

  Fw.component.export('tools', {
    init: init,
    ignoreUnusedStates: ignoreUnusedStates,
    validateForm: validateForm,
    escapeChars: escapeChars,
    sortResults: sortResults
  });

  $(window).ready(init);
})(jQuery);
'use strict';

(function ($) {

	'use strict';

	var recaptchaInitLimit = 3000;

	/* RECAPTCHA UTIL FUNCTION */
	/**
  * Render recaptchas dynamically.
  * @param   btn         An element referencing the button or a string 
  *                      referencing the Id of the element.
  * @param   callback    A function to be called after recaptcha has 
  *                      completed its check. The function is passed back
  *                      the recaptcha response and the form element.
  * @param   validate    (optional) A boolean to know if a form needs to be 
  *                      validated using the formValidator in com/form.js.
  * @param   form        (optional) A jQuery object reference the form to be
  *                      validated using formValidator in com/form.js.
  */

	var recaptcha = function recaptcha(btn, fn, validate, form) {
		if (!btn || --recaptchaInitLimit <= 0) {
			return;
		}

		if (!!window.grecaptcha) {
			if (window.grecaptcha.render) {
				grecaptcha.render(btn, {
					'sitekey': $(btn).attr('data-id'),
					'callback': function callback(response) {
						var formValidator = Fw.component.models().form.validateForm;
						var validated = true;
						if (validate) {
							validated = false;
							formValidator(form);
							if (!form.hasClass('has-error')) {
								validated = true;
							}
						}

						if (validated) {
							fn(response, form, btn);
						} else {
							grecaptcha.reset();
						}
					}
				});
			} else {
				setTimeout(function () {
					recaptcha(btn, fn, validate, form);
				}, 250);
			}
		} else {
			setTimeout(function () {
				recaptcha(btn, fn, validate, form);
			}, 250);
		}
	};

	var recaptcha2 = function recaptcha2(btn, _callback) {
		var key = btn.getAttribute("data-id");
		if (!btn || !key || --recaptchaInitLimit <= 0) {
			// Captcha is not loaded, then bind click event on the functino as fallback
			if (btn && !$(btn).hasClass('get-stripe-token') && !$(btn).hasClass('get-worldPay-token')) {
				$(btn).on('click', _callback);
			}
			return;
		}
		if (!!window.grecaptcha && !!grecaptcha.render) {
			var div = $('<div class="recaptcha-ctn"></div>').insertBefore(btn);
			var widgetId = grecaptcha.render(div[0], {
				'sitekey': key,
				'callback': function callback(response) {
					_callback.call(btn, response);
				},
				'badge': 'inline',
				'size': 'invisible'
			});
			btn.setAttribute('data-widget-id', widgetId);
			// Flow of validation: stripe token -> recaptcha -> form validation -> submit
			if (!$(btn).hasClass('get-stripe-token') && !$(btn).hasClass('get-worldPay-token')) {
				$(btn).on('click', function (e) {
					grecaptcha.execute(widgetId);
				});
			}
		} else {
			setTimeout(function () {
				recaptcha2(btn, _callback);
			}, 250);
		}
	};

	Fw.component.export('utils', {
		recaptcha: recaptcha,
		recaptcha2: recaptcha2
	});
})(jQuery);